import React, {
	createContext,
	useContext,
	useState,
	useEffect,
	useCallback,
} from "react";

const translations = {
	it: {
		// Common
		save: "Salva",
		cancel: "Annulla",
		delete: "Elimina",
		edit: "Modifica",
		create: "Crea",
		select: "Seleziona",
		fillRequiredFields: "Compila i campi obbligatori",
		search: "Cerca",
		loading: "Caricamento...",
		error: "Errore",
		success: "Successo",
		confirm: "Conferma",
		confirmDelete: "Sei sicuro di voler eliminare questo elemento?",
		back: "Indietro",
		next: "Avanti",
		copy: "Copia",
		download: "Scarica",
		upload: "Carica",
		view: "Visualizza",
		close: "Chiudi",
		today: "Oggi",

		// Navigation
		dashboard: "Dashboard",
		athletes: "Atleti",
		yesterday: "Ieri",
		msgNew: "Nuovo",
		msgNoThreads:
			"Nessuna conversazione. Tocca “Nuovo” per scrivere al tuo coach.",
		msgYou: "Tu",
		msgDirect: "Messaggio diretto",
		msgOriginalFeedback: "Feedback originario",
		msgSupportRequest: "Richiesta di supporto",
		msgOpenInDiary: "Apri nel diario",
		msgProgramNoLongerActive: "Programma non più attivo",
		msgProgramNoLongerAvailable: "Programma non più disponibile",
		msgOpenAthlete: "Apri scheda atleta",
		msgAskSupport: "Chiedi supporto al coach",
		msgGoToThread: "Vai alla conversazione",
		actionResultShort: "Risultato",
		actionSupportShort: "Supporto",
		actionThreadShort: "Thread",
		actionLeaderboardShort: "Classifica",
		actionHistoryShort: "Storico",
		exerciseHistoryLabel: "Storico Esercizio",
		exerciseProgressLabel: "Progressione",
		hide: "Nascondi",
		value: "Valore",
		msgEmptyThread: "Nessun messaggio. Scrivi qui sotto.",
		msgWritePlaceholder: "Scrivi un messaggio…",
		msgSend: "Invia",
		msgSelectContact: "Nuova conversazione",
		msgNoContacts: "Nessun contatto disponibile.",
		msgLoadError: "Impossibile caricare la conversazione.",
		msgSendError: "Invio non riuscito.",
		msgArchive: "Archivia",
		msgUnarchive: "Disarchivia",
		msgDeleteThread: "Elimina conversazione",
		msgDeleteThreadConfirmTitle: "Elimina conversazione",
		msgDeleteThreadConfirmBody:
			"Eliminare questa conversazione? Non potrai più vederla.",
		msgArchived: "Archiviate",
		msgInbox: "Messaggi",
		msgArchivedEmpty: "Nessuna conversazione archiviata.",
		msgArchivedDone: "Conversazione archiviata.",
		msgUnarchivedDone: "Conversazione ripristinata.",
		msgDeletedDone: "Conversazione eliminata.",
		msgActionError: "Operazione non riuscita.",
		msgStatusSent: "Inviato",
		msgStatusDelivered: "Consegnato",
		msgStatusRead: "Letto",
		feedbackSeenByCoach: "Visto dal coach",
		feedback: "Feedback",
		feedbackSubtitle: "Tutti i feedback dei tuoi atleti, dal più recente.",
		feedbackMarkAllRead: "Segna come letti",
		feedbackAll: "Tutti",
		feedbackUnreadOnly: "Non letti",
		feedbackNeedsAttention: "Da attenzionare",
		feedbackAllAthletes: "Tutti gli atleti",
		feedbackAllPrograms: "Tutti i programmi",
		feedbackPeriod7: "Ultimi 7 gg",
		feedbackPeriod30: "Ultimi 30 gg",
		feedbackPeriodAll: "Sempre",
		feedbackEmpty: "Nessun feedback da mostrare con questi filtri.",
		feedbackLoadError: "Impossibile caricare i feedback.",
		feedbackAllRead: "Tutti i feedback segnati come letti.",
		feedbackReplySent: "Risposta inviata.",
		feedbackReplyError: "Invio non riuscito.",
		feedbackDiary: "Diario",
		feedbackNoNote: "Nessuna nota",
		feedbackGroup: "Gruppo",
		feedbackReply: "Rispondi",
		feedbackOpenAthlete: "Apri atleta",
		feedbackOpenProgram: "Anteprima programma",
		feedbackReplyPlaceholder: "Scrivi una risposta all'atleta…",
		feedbackSend: "Invia",
		feedbackLoadMore: "Carica altri",
		feedbackMarkReadOne: "Segna letto",
		feedbackViewFeed: "Feed",
		feedbackViewProgram: "Per programma",
		feedbackViewAthlete: "Per atleta",
		feedbackViewGroup: "Classifiche gruppo",
		feedbackSelectProgram: "Seleziona un programma",
		feedbackSelectGroup: "Seleziona un gruppo",
		feedbackSearchGroup: "Cerca gruppo…",
		feedbackNoGroups: "Non gestisci nessun gruppo.",
		feedbackGroupNoPrograms: "Nessun programma assegnato a questo gruppo.",
		feedbackGroupHint:
			"Classifiche per esercizio, ristrette a questo gruppo. Includono anche i risultati non pubblici (visibili solo a te).",
		feedbackGroupMembers: "{count} atleti",
		feedbackGroupExerciseResults: "{count} risultati",
		feedbackGroupNoResultsYet: "Nessun risultato",
		feedbackGroupOpenLeaderboard: "Apri classifica di gruppo",
		feedbackGroupShowPrescription: "Mostra l'esercizio prescritto",
		feedbackGroupNoPrescription: "Nessun dettaglio disponibile.",
		feedbackNoAthletes: "Nessun atleta in questo programma.",
		feedbackColAthlete: "Atleta",
		feedbackGridHint:
			"Clicca una cella per vedere i feedback dell'atleta in questo programma.",
		feedbackSelectAthlete: "Seleziona un atleta per vedere i suoi feedback.",
		feedbackScopeMine: "Miei",
		feedbackScopeAll: "Tutti (admin)",
		feedbackCoachFilter: "Filtro coach",
		feedbackAllCoaches: "Tutti i coach",
		feedbackCompleted: "Completato",
		feedbackLoggedEarly: "registrato in anticipo",
		feedbackIncludeCompleted: "Includi completati",
		feedbackSearchAthlete: "Cerca atleta…",
		feedbackSearchProgram: "Cerca programma…",
		feedbackDetail: "Dettaglio",
		schemaMigrateNeedsSingleField:
			"Conversione automatica non possibile: lo schema deve avere un solo campo di destinazione.",
		schemaMigrateTitle: "Converti i risultati e sblocca lo schema",
		schemaMigrateIntro:
			"Esistono già risultati per questo conditioning. Posso convertire lo score libero esistente nel nuovo campo dello schema e sbloccare la modifica.",
		schemaMigrateResultsToConvert: "Risultati da convertire",
		schemaMigrateTargetField: "Campo di destinazione",
		schemaMigratePrograms: "Programmi aggiornati",
		schemaMigrateHint:
			"Lo score libero diventa il valore del nuovo campo (1:1). Il valore originale non viene cancellato.",
		schemaMigrateConfirmBtn: "Converti e sblocca",
		schemaMigrateDone:
			"Conversione completata: {converted} risultati convertiti, {programs} programmi aggiornati.",
		exercises: "Esercizi",
		programs: "Programmi",
		workouts: "Allenamenti",
		diary: "Diario",
		wellnessDiary: "Diario salute",
		athletesScopeMine: "Miei",
		athletesScopeShared: "Condivisi con me",
		athletesScopeAll: "Tutti (admin)",
		wellnessDiaryTitle: "Diario di salute",
		wellnessDiarySubtitle: "Monitoraggio giornaliero del recupero",
		wellnessConfigure: "Configura",
		wellnessTrends: "Andamenti",
		wellnessEnabled: "Diario abilitato",
		wellnessEnabledDescription:
			"L'atleta vedrà il diario e potrà compilarlo ogni giorno.",
		wellnessDailyReminder: "Promemoria giornaliero",
		wellnessDailyReminderDescription:
			"Mostra all'atleta un avviso finché non compila il diario del giorno. Disattivalo se troppo invasivo.",
		wellnessConsentPending: "In attesa del consenso dell'atleta",
		wellnessConsentAccepted: "Consenso accettato",
		wellnessNoData: "Nessun dato ancora inserito.",
		wellnessSubjectiveParameters: "Parametri soggettivi",
		wellnessObjectiveParameters: "Parametri oggettivi",
		wellnessSaveConfiguration: "Salva configurazione",
		wellnessConfigurationSaved: "Configurazione salvata",
		wellnessEnableToCollect: "Abilita il diario per raccogliere i dati.",
		wellnessNoAthleteData: "Nessun dato ancora inserito dall'atleta.",
		wellnessLoadError: "Errore nel caricamento",
		wellnessSaveError: "Errore nel salvataggio",
		wellnessUnavailable:
			"Il diario non è attivo. Puoi configurarlo e iniziare a monitorare il tuo recupero quando vuoi.",
		wellnessSelfSetupTitle: "Scegli cosa monitorare",
		wellnessSelfSetupDescription:
			"Scegli i parametri che vuoi registrare. Potrai modificarli in seguito.",
		wellnessActivateDiary: "Attiva il diario",
		wellnessSelectAtLeastOne: "Seleziona almeno un parametro per continuare.",
		wellnessInactive: "Non attivo",
		wellnessSetupDiary: "Configura diario",
		wellnessActivationError: "Impossibile attivare il diario",
		wellnessBackToDashboard: "Torna alla dashboard",
		wellnessConsentTitle: "Consenso al diario di salute",
		wellnessAcceptAndStart: "Accetto e inizio",
		wellnessConsentProfileHint:
			"Potrai disattivare il tracciamento e cancellare i tuoi dati in qualsiasi momento dal tuo profilo.",
		wellnessInsert: "Inserisci",
		wellnessDay: "Giorno",
		wellnessTodayFilled: "Oggi già compilato",
		wellnessFilled: "Compilato",
		wellnessToFill: "Da compilare",
		wellnessDayAlreadyFilled:
			"Hai già inserito i dati per questo giorno. Puoi modificarli e salvare di nuovo, oppure cancellarli.",
		wellnessWriteHere: "Scrivi qui...",
		wellnessUpdate: "Aggiorna",
		wellnessRecordedDays: "Giorni registrati",
		wellnessEditing: "In modifica",
		wellnessDeleteDayConfirm: "Cancellare i dati del {date}?",
		wellnessConsentRecorded: "Consenso registrato",
		wellnessDataSaved: "Dati salvati",
		wellnessDataDeleted: "Dati cancellati",
		wellnessDeleteError: "Errore nella cancellazione",
		wellnessDiaryLoadError: "Errore nel caricamento del diario",
		wellnessConsentSaveError: "Errore nel salvataggio del consenso",
		wellnessAthleteTrendsEmpty:
			"Inizia a compilare il diario per vedere i tuoi andamenti.",
		wellnessDisableConfirm:
			"Disattivare il tracciamento? I dati già inseriti restano salvati.",
		wellnessDeleteAllConfirm:
			"Cancellare definitivamente tutti i dati del diario di salute? L'operazione non è reversibile.",
		wellnessTrackingDisabled: "Tracciamento disattivato",
		wellnessConsentToAccept: "Consenso da accettare",
		wellnessActive: "Attivo",
		wellnessPrivacyDescription:
			"I tuoi dati sono visibili solo a te e al coach che ti segue, mai in pubblico. Hai il pieno controllo: puoi consultarli, disattivare il tracciamento o cancellarli.",
		wellnessOpenDiary: "Apri diario",
		wellnessDisable: "Disattiva",
		wellnessDeleteData: "Cancella dati",
		wellnessHealthTab: "Salute",
		wellnessBulkTitle: "Abilitazione massiva diario salute",
		wellnessBulkDescription:
			"Applica la stessa configurazione a più atleti o a interi gruppi in una sola operazione.",
		wellnessBulkDisableDescription:
			"Il diario sparisce dalla vista dell'atleta. I dati già inseriti e i parametri scelti restano salvati.",
		wellnessBulkOverwriteWarning:
			"I parametri scelti qui sostituiscono quelli già configurati per gli atleti selezionati.",
		wellnessBulkConsentNotice:
			"Il consenso non si abilita in massa: ogni atleta dovrà accettarlo prima di inserire il primo dato.",
		wellnessBulkRecipients: "{count} atleti selezionati",
		wellnessBulkRecipientsEmpty:
			"Nessun atleta selezionato: scegli un gruppo o i singoli atleti.",
		wellnessBulkRecipientsBreakdown:
			"{active} con diario già attivo · {inactive} non attivo",
		wellnessBulkSelectAll: "Seleziona tutti",
		wellnessBulkClearSelection: "Deseleziona tutti",
		wellnessBulkFromGroup: "Da gruppo",
		wellnessBulkFromGroupHint:
			"Incluso perché fa parte di un gruppo selezionato.",
		wellnessBulkStepRecipients: "1 · Scegli chi",
		wellnessBulkStepAction: "2 · Cosa vuoi fare",
		wellnessBulkStepSettings: "3 · Cosa monitorare",
		wellnessBulkActionEnable: "Attiva il diario",
		wellnessBulkActionDisable: "Disattiva il diario",
		wellnessBulkGroupMembers: "{count} atleti",
		wellnessBulkGroupActive: "{count} con diario attivo",
		wellnessBulkGroupNoneActive: "nessuno con diario attivo",
		wellnessBulkFilterAll: "Tutti",
		wellnessBulkFilterActive: "Con diario attivo",
		wellnessBulkFilterInactive: "Senza diario",
		wellnessBulkApplyEnable: "Abilita per i selezionati",
		wellnessBulkApplyDisable: "Disabilita per i selezionati",
		wellnessBulkApplyEnableCount: "Attiva per {count} atleti",
		wellnessBulkApplyDisableCount: "Disattiva per {count} atleti",
		wellnessBulkApplied: "Configurazione applicata a {count} atleti",
		wellnessBulkSkipped:
			"{count} atleti saltati: non sono tra quelli che gestisci.",
		wellnessBulkPendingConsent:
			"{count} atleti devono ancora accettare il consenso.",
		wellnessBulkOpen: "Abilitazione massiva",
		wellnessError: "Errore",
		performance: "Performance",
		library: "Libreria",
		leaderboard: "Classifica",
		profile: "Profilo",
		settings: "Impostazioni",
		aiCoach: "Assistente AI",
		aiGuideNav: "Guida AI",
		logout: "Esci",
		languageLabel: "Lingua",
		switchAccountLabel: "Passa ad account",
		textSize: "Dimensione testo",
		textSizeSmall: "Piccolo",
		textSizeMedium: "Medio",
		textSizeLarge: "Grande",
		themeLabel: "Tema",
		themeDark: "Scuro",
		themeLight: "Chiaro",
		accountSwitchSuccess: "Account cambiato",
		accountSwitchError: "Impossibile cambiare account",
		switchRoleLabel: "Modalità",
		roleModeAthlete: "Atleta",
		roleModeCoach: "Coach",
		roleSwitchSuccess: "Modalità cambiata",
		roleSwitchError: "Impossibile cambiare modalità",

		// Auth
		login: "Accedi",
		register: "Registrati",
		email: "Email",
		password: "Password",
		confirmPassword: "Conferma Password",
		confirmEmail: "Conferma Email",
		name: "Nome",
		role: "Ruolo",
		coach: "Coach",
		athlete: "Atleta",
		continueWithGoogle: "Continua con Google",
		sessionExpired: "La tua sessione è scaduta. Effettua nuovamente il login.",

		// Dashboard
		welcome: "Ciao",
		readyToTrain: "Pronto per allenarti oggi?",
		totalWorkouts: "Totale",
		thisWeek: "Questa settimana",
		personalRecords: "Record Personali",
		goal: "Obiettivo",
		todaysWorkout: "Allenamento di Oggi",
		noWorkoutScheduled: "Nessun allenamento programmato",
		addToDiary: "Aggiungi al diario",
		viewAll: "Vedi tutti",
		inviteAthleteLink: "Link invito atleta",
		inviteAthleteLinkIntro: "Invita un atleta con un link pronto da inviare",
		inviteAthleteLinkDescription:
			"Scegli gruppo e programma opzionali, genera il link e invialo via WhatsApp, email o messaggio diretto.",
		createInviteLink: "Crea link invito",
		inviteDialogDescription:
			"Configura il contesto iniziale dell'atleta e genera un link monouso di onboarding.",
		inviteGroupOptional: "Gruppo atleta (opzionale)",
		inviteProgramOptional: "Programma (opzionale)",
		noGroupOption: "Nessun gruppo",
		noProgramOption: "Nessun programma",
		inviteHowItWorksTitle: "Come usarlo",
		inviteCreateStepSelect:
			"Seleziona gruppo e programma solo se vuoi preassegnarli già dal primo accesso.",
		inviteCreateStepGenerate:
			"Genera il link di invito personale per questo atleta.",
		inviteCreateStepSend:
			"Invia il link all'atleta: aprendolo completerà onboarding o login guidato.",
		inviteCreateOutcomeTitle: "Cosa succede dopo",
		inviteCreateOutcome:
			"Quando l'atleta usa il link viene collegato automaticamente al tuo profilo coach e, se li hai scelti, anche al gruppo e al programma selezionati.",
		generateInviteLink: "Genera link invito",
		inviteCreating: "Creazione link...",
		inviteLinkReady: "Link pronto",
		inviteGeneratedHelp:
			"Copia e invia questo link. Alla prima apertura l'atleta vedrà l'onboarding con collegamento automatico al coach e alle assegnazioni impostate qui.",
		inviteExpiryNoticeTitle: "Scadenza link invito",
		inviteExpiryNoticeBody:
			"Per sicurezza, i link invito onboarding scadono automaticamente dopo 30 giorni (massimo 90). Se un atleta apre un link vecchio, genera un nuovo invito.",
		inviteExpiresAtLabel: "Scade il",
		copyInviteLink: "Copia",
		inviteLinkCopied: "Link copiato",
		inviteTitle: "Invito onboarding",
		inviteSubtitle:
			"Accetta l'invito per collegarti automaticamente al coach e completare l'onboarding.",
		inviteLoading: "Verifica invito in corso...",
		inviteInvalid: "Invito non valido o scaduto",
		inviteCoachLabel: "Coach",
		inviteGroupLabel: "Gruppo",
		inviteProgramLabel: "Programma",
		inviteApplying: "Applicazione invito...",
		acceptInviteNow: "Accetta invito",
		goToLoginToAccept: "Accedi o registrati per continuare",
		goToPortal: "Vai al portale e installa applicazione",
		inviteAcceptedSuccess: "Invito applicato con successo",
		inviteAcceptFailed: "Impossibile applicare l'invito",
		errorLinkClick:
			'Se il link è ancora necessario, richiedilo al tuo coach. Per un accesso corretto al portale, installa l\'applicazione con "Aggiungi a schermata Home".',

		// Exercises
		exerciseLibrary: "Libreria Esercizi",
		manageExercises: "Gestisci il database degli esercizi",
		newExercise: "Nuovo Esercizio",
		createExercise: "Crea esercizio",
		createConditioning: "Crea conditioning",
		category: "Categoria",
		allCategories: "Tutte le categorie",
		strength: "Forza",
		cardio: "Cardio",
		gymnastics: "Ginnastica",
		olympic: "Olimpici",
		accessory: "Accessori",
		description: "Descrizione",
		tags: "Tags",
		noMedia: "Nessun media",

		// Programs
		myPrograms: "I Miei Programmi",
		createProgram: "Crea Programma",
		programBuilder: "Costruttore Programma",
		individual: "Individuale",
		group: "Gruppo",
		assignedAthletes: "Atleti Assegnati",
		assignAthleteBtn: "Assegna atleti",
		noAssignedAthletes: "Nessun atleta assegnato",
		days: "Giorni",
		addDay: "Aggiungi Giorno",
		warmup: "Riscaldamento",
		cooldown: "Defaticamento",
		notes: "Note",
		sets: "Serie",
		reps: "Ripetizioni",
		load: "Carico",

		// Workout Execution
		startWorkout: "Inizia Allenamento",
		progress: "Progresso",
		logResult: "Registra Risultato",
		weight: "Peso",
		time: "Tempo",
		suggestedLoad: "Carico Suggerito",
		basedOn1RM: "Basato sul tuo 1RM stimato",
		showInLeaderboard: "Mostra in classifica",
		finishWorkout: "Completa Allenamento",
		workoutComplete: "Allenamento completato!",

		// Profile
		strengthProgression: "Progressione Forza",
		workoutFrequency: "Frequenza Allenamenti",
		records: "Record",
		history: "Storico",
		estimated1RM: "1RM stimato",
		week: "Settimana",
		uploadAvatar: "Carica avatar",
		uploadAvatarHint: "Tocca l'icona per aggiornare la foto profilo",
		uploadingAvatar: "Caricamento avatar...",
		avatarUpdated: "Avatar aggiornato",
		invalidImageType: "Seleziona un'immagine valida (JPG, PNG, WebP o GIF)",
		cropPhoto: "Ritaglia foto",
		cropZoom: "Zoom",
		cropConfirm: "Conferma",
		cropCancel: "Annulla",
		memberSince: "Membro dal",
		personalData: "Dati personali",
		nickname: "Nickname",
		nicknamePlaceholder: "Come vuoi essere chiamato?",
		accountLabel: "Account",
		genderLabel: "Genere",
		selectGender: "Seleziona genere",
		genderMale: "Maschile",
		genderFemale: "Femminile",
		genderRequiredWarning:
			"Per apparire nelle classifiche maschili/femminili devi impostare il genere. Vuoi continuare senza impostarlo?",
		dateOfBirth: "Data di nascita",
		heightCm: "Altezza (cm)",
		upcomingEvents: "Prossimi Eventi",
		pastEvents: "Eventi Passati",
		noEventsScheduled: "Nessun evento in programma",
		eventNamePlaceholder: "CrossFit Open 2026",
		eventNotesPlaceholder: "Dettagli aggiuntivi...",
		fromDiary: "Da agenda",
		manualLabel: "Manuale",
		manualRemovedOn: "Manuale · rimosso il",
		manualValueUnchanged: "Valore già salvato oggi, nessuna modifica",
		manualNoLongerActive: "Manuale · non più attivo",
		enterManualValue: "Inserisci valore manuale",
		removeManualValue: "Rimuovi valore manuale",

		// AI Assistant
		aiAssistant: "AI Coach",
		aiDescription:
			"Il tuo assistente AI per la programmazione degli allenamenti",
		chat: "Chat",
		generateProgram: "Genera Programma",
		howCanIHelp: "Come posso aiutarti?",
		askAnything:
			"Chiedimi di creare programmi, suggerire progressioni, o rispondere a domande.",
		quickPrompts: "Suggerimenti Rapidi",
		programParams: "Parametri Programma",
		duration: "Durata",
		daysPerWeek: "Giorni/Settimana",
		level: "Livello",
		focus: "Focus",
		beginner: "Principiante",
		intermediate: "Intermedio",
		advanced: "Avanzato",
		additionalNotes: "Note Aggiuntive",
		generating: "Generazione in corso...",
		generatedProgram: "Programma Generato",
		libraryContext: "Contesto dalla Libreria",
		selectDocuments: "Seleziona documenti da usare come riferimento",
		noDocumentsSelected: "Nessun documento selezionato",
		documentsSelected: "documenti selezionati",
		toolCallsUsed: "Tool usati",
		sourcesUsed: "Fonti usate",
		estimatedCost: "Costo stimato",
		liveDebug: "Debug live",
		aiModel: "Modello AI",
		aiAttach: "Allega documento",
		aiStop: "Interrompi generazione",
		aiSend: "Invia messaggio",
		qualityGates: "Quality gates",
		jsonRepaired: "JSON riparato",
		agentRetryUsed: "Retry agente usato",
		parseError: "Errore parse",
		activeConstraints: "Vincoli attivi",
		generationTrigger: "Trigger generazione",
		coachStructureLocked: "Struttura coach bloccata",
		athleteHistoryContext: "Contesto storico atleta",
		selectedMesocycle: "Mesociclo selezionato",
		agendaRange: "Range agenda",
		agendaWeeks: "Settimane agenda",
		requestedDurationWeeks: "Durata richiesta (settimane)",
		requestedSessionsPerWeek: "Sessioni richieste/settimana",
		analysisReportAttached: "Report analisi allegato",
		cacheHit: "Cache hit",
		plannerUsed: "Planner usato",
		plannerModel: "Planner model",
		yesLabel: "Si",
		noLabel: "No",
		athleteAnalysis: "Analisi Atleta",
		nextMesocycleAthleteContext: "Contesto atleta prossimo mesociclo",
		nextMesocycleAthleteContextHint:
			"Se attivo, la generazione programma usa i risultati storici dell'atleta selezionato per definire progressioni e priorita.",
		useAthleteHistoricalResults: "Usa risultati storici atleta",
		selectAthleteForMesocycle: "Seleziona atleta per mesociclo",
		selectAthleteForAnalysis: "Seleziona atleta per analisi",
		enabledLabel: "Attivo",
		disabledLabel: "Disattivo",
		analysisPrompt: "Prompt analisi",
		analysisPromptPlaceholder:
			"Es. evidenzia trend 30/90 giorni, punti deboli, rischi e cosa fare nel prossimo mesociclo",
		analyzingAthlete: "Analisi in corso...",
		runAthleteAnalysis: "Avvia analisi atleta",
		analysisResult: "Risultato analisi",
		programReview: "Program Review",
		reviewDraft: "Review bozza",
		programId: "Program ID",
		programIdPlaceholder: "ID programma esistente (opzionale)",
		useGeneratedDraftForReview: "Usa bozza generata corrente per la review",
		reviewPrompt: "Prompt review",
		reviewPromptPlaceholder:
			"Es. evidenzia warning ad alta severita su progressione, copertura pattern e prescrizioni mancanti",
		reviewingProgram: "Review programma in corso...",
		runProgramReview: "Avvia program review",
		reviewResult: "Risultato review",
		reviewWarnings: "Warning",
		correctiveActions: "Azioni correttive",
		quickWins: "Quick wins",
		applySuggestedFixes: "Applica fix suggeriti",
		programReviewEmptyState:
			"Avvia una review su bozza generata o su Program ID per vedere warning e fix applicabili.",
		trend30: "Trend 30 giorni",
		trend90: "Trend 90 giorni",
		riskAlerts: "Alert rischio",
		recommendedActions: "Azioni consigliate",
		athleteAnalysisEmptyState:
			"Seleziona un atleta e avvia l'analisi per ottenere trend, KPI e azioni consigliate.",

		// Library
		coachLibrary: "Libreria Coach",
		manageLibrary: "Gestisci i tuoi materiali e metodologie",
		uploadDocument: "Carica Documento",
		emptyLibrary: "Libreria vuota",
		uploadFirst: "Carica il tuo primo documento PDF",
		methodology: "Metodologia",
		programming: "Programmazione",
		nutrition: "Nutrizione",
		recovery: "Recupero",
		reference: "Riferimenti",
		other: "Altro",

		// Leaderboard
		leaderboardTitle: "Classifica",
		leaderboardPrivateLabel: "Privato",
		leaderboardPrivateResultHint:
			"Risultato non pubblico: visibile solo a te come coach, non compare nelle classifiche pubbliche.",
		compareResults: "Confronta i tuoi risultati con gli altri atleti",
		noResults: "Nessun risultato",
		points: "punti",

		// PDF Export
		exportPDF: "Esporta PDF",
		exporting: "Esportazione...",

		// Errors
		errorLoading: "Errore nel caricamento",
		errorLoadingResults: "Errore nel caricamento dei risultati",
		tryAgain: "Riprova",

		// Results / History
		noResultsFound: "Nessun risultato trovato",
		startLoggingResults: "Inizia a registrare risultati per questo esercizio",
		mostRecent: "Più recente",
		results: "risultati",

		// Login hero
		heroTagline: "ALLENA. TRACCIA.",
		heroTaglineAccent: "DOMINA.",
		heroDescription:
			"La piattaforma completa per coach e atleti. Crea programmi, monitora progressi e raggiungi i tuoi obiettivi.",
		heroDescriptionShort: "La piattaforma per coach e atleti",

		// Layout / Navigation
		messages: "Messaggi",

		// Messages page
		communicateLabel: "Comunica con il tuo coach o atleti",
		newMessage: "Nuovo Messaggio",
		recipient: "Destinatario",
		selectRecipient: "Seleziona destinatario",
		general: "Generale",
		workoutFeedback: "Feedback Allenamento",
		programFeedback: "Feedback Programma",
		messageLabel: "Messaggio",
		subject: "Oggetto",
		subjectPlaceholder: "Oggetto del messaggio",
		messagePlaceholder: "Scrivi il tuo messaggio...",
		send: "Invia",
		inbox: "Ricevuti",
		sent: "Inviati",
		noMessages: "Nessun messaggio",
		reply: "Rispondi",
		replyPlaceholder: "Scrivi la tua risposta...",
		sendReply: "Invia Risposta",
		selectMessageToRead: "Seleziona un messaggio per leggerlo",
		fillAllFields: "Compila tutti i campi",
		messageSent: "Messaggio inviato!",
		writeReply: "Scrivi una risposta",
		replySent: "Risposta inviata!",
		confirmDeleteMessage: "Eliminare questo messaggio?",
		messageDeleted: "Messaggio eliminato",
		conditioning: "Conditioning",
		aiDocs: "Docs AI",
		aiDocsTitle: "Documenti Formativi AI",
		aiDocsSubtitle: "Fonti che danno contesto all'assistente AI.",
		aiDocsDisabledTitle: "Documenti AI momentaneamente disattivati",
		aiDocsDisabledBody:
			"Puoi consultarli, ma non creare, modificare o gestire documenti.",
		aiDocsSearchPlaceholder: "Cerca documenti...",
		aiDocsNew: "Nuovo documento",
		aiDocsActive: "Attivo",
		aiDocsInactive: "Disattivato",
		aiDocsPages: "pagine",
		aiDocsCharacters: "caratteri",
		aiDocsTooLong: "supera il limite di contesto AI; il testo verrà troncato",
		aiDocsWithinLimit: "rientra nel limite di contesto AI",
		aiDocsDeactivate: "Disattiva",
		aiDocsActivate: "Attiva",
		aiDocsDeactivateHelp:
			"Disattiva il documento: non sarà più disponibile all'assistente AI.",
		aiDocsActivateHelp:
			"Riattiva il documento per renderlo disponibile all'assistente AI.",
		aiDocsEditHelp: "Modifica titolo, categoria e contenuto del documento.",
		aiDocsDeleteHelp: "Elimina definitivamente il documento formativo.",
		aiDocsCategoriesTitle: "Categorie documenti AI",
		aiDocsCategoriesSubtitle:
			"Gestisci i nomi usati nei documenti e nei filtri AI.",
		aiDocsCategoriesSave: "Salva categorie",
		aiDocsCategoryName: "Nome categoria",
		aiDocsCategoryUsage: "documenti",
		aiDocsCategoryAddPlaceholder: "Nome nuova categoria",
		aiDocsCategoryAdd: "Aggiungi categoria",
		aiDocsCategoryRequired: "La categoria Altro è obbligatoria",
		aiDocsCategoryUsed: "Riassegna prima i documenti di questa categoria",
		aiDocsCategoryRemove: "Rimuovi categoria",
		aiDocsCategorySaved: "Categorie documenti salvate",
		aiDocsCategoryEmpty: "Ogni categoria deve avere un nome",
		aiDocsCategoryInvalid: "Inserisci un nome categoria valido",
		aiDocsCategoryDuplicate: "Esiste già una categoria con questo nome",
		aiDocsDelete: "Elimina documento",
		aiDocsDeleteAction: "Elimina",
		aiDocsDeleteDocument: "Elimina documento",
		aiDocsManagePermission: "Gestione riservata ad admin o autore",
		aiDocsDeleteConfirm: "Eliminare questo documento formativo?",
		aiDocsDeleted: "Documento eliminato",
		aiDocsDeleteError: "Impossibile eliminare il documento",
		aiDocsActivated: "Documento attivato",
		aiDocsDeactivated: "Documento disattivato",
		aiDocsRequired: "Titolo e contenuto, oppure un PDF, sono obbligatori",
		aiDocsCreated: "Documento creato",
		aiDocsSaveError: "Impossibile salvare il documento",
		aiDocsLoadError: "Errore nel caricamento documenti",
		aiDocsEmptyTitle: "Nessun documento formativo",
		aiDocsEmptyBody:
			"Aggiungi linee guida, metodologie e riferimenti da usare come contesto AI.",
		aiDocsNewTitle: "Nuovo documento formativo",
		aiDocsEditTitle: "Modifica documento formativo",
		aiDocsEntryTitle: "Aggiunta di documenti AI",
		aiDocsEntryHelp:
			"Incolla testo o Markdown oppure carica un PDF con testo selezionabile. Le scansioni non sono supportate.",
		aiDocsUseHelp:
			"I documenti attivi possono essere consultati dall'assistente AI come contesto aggiuntivo.",
		aiDocsTitleLabel: "Titolo",
		aiDocsTitlePlaceholder: "Es. Linee guida periodizzazione forza",
		aiDocsCategory: "Categoria",
		aiDocsSourceText: "Testo",
		aiDocsSourcePdf: "Carica PDF",
		aiDocsPdfLabel: "File PDF",
		aiDocsPdfHint: "Seleziona un PDF testuale da cui estrarre il contenuto.",
		aiDocsContentLabel: "Contenuto",
		aiDocsContentPlaceholder: "Incolla linee guida in testo o Markdown.",
		aiDocsSaving: "Salvataggio...",
		aiDocsSaveChanges: "Salva modifiche",
		aiDocsCreate: "Crea documento",
		billing: "Pagamenti",

		// Desktop sidebar / command palette
		navGroupCoaching: "Coaching",
		navGroupTraining: "Allenamento",
		navGroupAi: "Intelligenza artificiale",
		navGroupManagement: "Gestione",
		navSearch: "Cerca",
		navSearchPlaceholder: "Cerca una sezione o un'azione...",
		navSearchEmpty: "Nessun risultato",
		navSearchSections: "Sezioni",
		navSearchActions: "Azioni rapide",
		navPinSidebar: "Fissa il menu",
		navUnpinSidebar: "Comprimi il menu",
		navMenu: "Menu",
		payments: "Pagamenti",
		invoices: "Fatture",
		invoice: "Fattura",
		products: "Prodotti",
		paymentPlans: "Piani ricorrenti",
		overview: "Panoramica",
		createInvoice: "Crea fattura",
		newProduct: "Nuovo prodotto",
		editProduct: "Modifica prodotto",
		productName: "Nome prodotto",
		recordPayment: "Registra pagamento",
		issueInvoice: "Emetti",
		voidInvoice: "Annulla fattura",
		dueDate: "Scadenza",
		amount: "Importo",
		quantity: "Quantità",
		unitPrice: "Prezzo unitario",
		lineDescription: "Descrizione",
		addLineItem: "Aggiungi voce",
		lineItems: "Voci",
		payer: "Atleta",
		billingNotes: "Note",
		selectAthlete: "Seleziona atleta",
		searchAthlete: "Cerca per nome o email...",
		noAthleteFound: "Nessun atleta trovato",
		selectProduct: "Prodotto (opzionale)",
		customLineItem: "Voce libera",
		total: "Totale",
		amountDue: "Da pagare",
		amountPaid: "Pagato",
		statusDraft: "Bozza",
		statusOpen: "Aperta",
		statusPartiallyPaid: "Parz. pagata",
		statusPaid: "Pagata",
		statusOverdue: "Scaduta",
		statusVoid: "Annullata",
		statusRefunded: "Rimborsata",
		collected: "Incassato",
		toCollect: "Da incassare",
		overdueAmount: "Scaduti",
		recentPayments: "Pagamenti recenti",
		paymentMethod: "Metodo",
		methodCash: "Contanti",
		methodBankTransfer: "Bonifico",
		methodPos: "POS",
		methodOther: "Altro",
		refund: "Rimborsa",
		refundAmount: "Importo rimborso",
		noInvoices: "Nessuna fattura",
		noProducts: "Nessun prodotto",
		noPayments: "Nessun pagamento",
		myPayments: "I miei pagamenti",
		toPay: "Da pagare",
		paymentHistory: "Storico",
		paymentStatus: "Stato",
		paymentActions: "Azioni",
		paymentDate: "Data",
		paymentSaved: "Pagamento registrato",
		invoiceCreated: "Fattura creata",
		invoiceIssued: "Fattura emessa",
		invoiceVoided: "Fattura annullata",
		editInvoice: "Modifica fattura",
		invoiceUpdated: "Fattura aggiornata",
		lineItemsLockedHint:
			"Sono già stati registrati pagamenti: per modificare le righe storna prima il pagamento.",
		refundSaved: "Rimborso registrato",
		refundHint: "Importo incassato:",
		filterByAthlete: "Filtra per atleta",
		filterByStatus: "Filtra per stato",
		allStatuses: "Tutti gli stati",
		paymentStatusPending: "In attesa",
		paymentStatusSucceeded: "Riuscito",
		paymentStatusFailed: "Fallito",
		paymentStatusCanceled: "Annullato",
		paymentStatusRefunded: "Rimborsato",
		paymentStatusPartiallyRefunded: "Parz. rimborsato",
		onlinePayments: "Incassi online",
		stripeNotConfigured:
			"I pagamenti online non sono ancora attivi sulla piattaforma. Contatta l'amministratore.",
		stripeConnectIntro:
			"Collega il tuo account Stripe per far pagare gli atleti online: i fondi arrivano direttamente sul tuo conto Stripe.",
		connectStripe: "Collega Stripe",
		completeSetup: "Completa la configurazione",
		refreshStatus: "Aggiorna stato",
		statusUpdated: "Stato aggiornato",
		connectActive: "Attivo",
		connectOnboarding: "In configurazione",
		connectNotConnected: "Non collegato",
		connectActiveHint: "Gli atleti possono pagare le tue fatture online.",
		externalPaymentLink: "Link di pagamento esterno",
		externalPaymentLinkIntro:
			"In alternativa a Stripe Connect, incolla qui il tuo link di pagamento personale (Stripe Payment Link, PayPal.me, SumUp, Satispay...). L'atleta verrà reindirizzato lì per pagare; dopo il pagamento dovrai registrarlo manualmente tu nella fattura.",
		externalPaymentLinkLabel: "URL del link di pagamento",
		externalLinkSaved: "Link di pagamento salvato",
		externalPaymentRedirectHint:
			"Ti abbiamo aperto la pagina di pagamento del coach in una nuova scheda. Il coach confermerà il pagamento non appena ricevuto.",
		payNow: "Paga ora",
		allAthletes: "Tutti gli atleti",
		dateFrom: "Da",
		dateTo: "A",
		resetFilters: "Reimposta filtri",
		invoiceDate: "Data fattura",
		pickDate: "Scegli una data",
		subtotal: "Subtotale",
		vat: "IVA",
		vatRate: "Aliquota IVA",
		vatNotFiscalHint:
			"Calcolo IVA informativo per riga, non genera alcun documento fiscale (fattura elettronica esclusa).",
		productSaved: "Prodotto salvato",
		confirmVoidInvoice: "Annullare questa fattura?",
		athletePaymentsHint:
			"Le fatture emesse dal tuo coach. I pagamenti vengono registrati dal coach.",
		admin: "Admin",
		manageCookies: "Gestisci Cookie",

		// Login
		welcomeBack: "Benvenuto",
		loginSubtitle: "Accedi o crea un account per continuare",
		orWith: "Oppure",
		loggingIn: "Accesso...",
		registering: "Registrazione...",
		yourName: "Il tuo nome",
		surname: "Cognome",
		yourSurname: "Il tuo cognome",
		newAccountNote:
			"I nuovi account vengono creati come atleta. Il ruolo coach viene assegnato dall'admin.",
		signupOptionalProfileTitle: "Dati profilo",
		signupOptionalProfileHint:
			"Puoi compilare questi campi ora sia per registrazione locale sia con Google.",
		registerSportPlaceholder: "Es. CrossFit, Running, Hyrox",
		passwordsDoNotMatch: "Le password non corrispondono",
		emailsDoNotMatch: "Le email non corrispondono",
		passwordTooShort: "La password deve essere di almeno 6 caratteri",
		saving: "Salvataggio...",
		sending: "Invio...",
		genericError: "Si è verificato un errore. Riprova.",
		newPassword: "Nuova password",
		currentPassword: "Password attuale",
		newEmail: "Nuova email",
		goToLogin: "Vai al login",
		backToLogin: "Torna al login",
		forgotPasswordLink: "Password dimenticata?",
		forgotPasswordEnterEmail:
			"Inserisci prima la tua email nel campo qui sopra.",
		forgotPasswordSent:
			"Se l'email è registrata, riceverai un link per reimpostare la password.",
		resetPasswordTitle: "Reimposta password",
		resetPasswordSubtitle: "Scegli una nuova password per il tuo account.",
		resetPasswordInvalidLink: "Link non valido o mancante.",
		resetPasswordSuccess: "Password aggiornata. Ora puoi accedere.",
		resetPasswordError: "Link non valido o scaduto. Richiedine uno nuovo.",
		resetPasswordCta: "Reimposta password",
		verifyEmailTitle: "Conferma email",
		verifyEmailLoading: "Conferma in corso...",
		verifyEmailSuccess: "Email aggiornata correttamente.",
		verifyEmailError: "Link non valido o scaduto.",
		verifyEmailInvalidLink: "Link non valido o mancante.",
		changeEmailCta: "Cambia email",
		changeEmailHint:
			"Ti invieremo un link di conferma al nuovo indirizzo. L'email cambierà solo dopo la conferma.",
		changeEmailSubmit: "Invia conferma",
		changeEmailSent:
			"Ti abbiamo inviato un'email di conferma al nuovo indirizzo.",
		changeEmailEmailDisabled:
			"Invio email non configurato: contatta il supporto per completare la modifica.",
		googleLoginError: "Errore durante il login con Google",
		loginNavigationCloneError:
			"Accesso riuscito, ma il browser ha bloccato la navigazione automatica. Riprova o chiudi e riapri l'app.",
		loginNavigationCloneFallback:
			"Problema temporaneo dell'app in modalità PWA: stiamo completando l'accesso.",
		googleOnlyAccountError:
			'Questo account è stato creato con Google. Usa il pulsante "Continua con Google" per accedere.',
		completeProfileAfterGoogle:
			"Completa il profilo per terminare la configurazione.",

		// Common actions
		open: "Apri",
		rename: "Rinomina",
		moveToFolder: "Sposta in Cartella",
		saveChanges: "Salva Modifiche",
		errorSavingChanges: "Errore nel salvataggio delle modifiche",
		type: "Tipo",
		date: "Data",
		competitionCalendarTab: "Calendario Agonistico",
		competitionCalendarTabShort: "Gare",
		shootingLeaderboards: "Classifiche tiro",
		shootingDrills: "Libreria drill",
		shootingConfig: "Configurazione tiro",
		mode: "Modalità",
		noneOption: "Nessuno",
		folder: "Cartella",
		root: "Root",
		remove: "Rimuovi",

		// Programs
		programDomainPhysical: "Fisico",
		programDomainShooting: "Tiro",
		programDomainHybrid: "Ibrido",
		programScopeMine: "Mie",
		programSharedBadge: "Condiviso",
		programScopeShared: "Condivise con me",
		programScopeAll: "Tutti (admin)",
		programReorder: "Riordina",
		programsMoreActions: "Altre azioni",
		programReorderDone: "Fine riordino",
		programReorderOwnOnly: "Puoi riordinare solo i tuoi programmi.",
		programDragMoveHint:
			"Trascina un programma o una cartella su una cartella, o su un livello del percorso, per spostarlo.",
		programFolderCount: "cartelle",
		programCount: "programmi",
		programSharing: "Condivisione",
		programVisibleViaSharing: "Visibile in condivisione",
		folderSharingTitle: "Condivisione cartella",
		saveSharing: "Salva condivisione",
		programVisibilityOwner: "Mio",
		programVisibilitySharedDirect: "Condiviso direttamente",
		programVisibilitySharedTeam: "Condiviso tramite il team coach",
		programVisibilityShared: "Condiviso",
		// Visualizzatore in sola lettura di un programma condiviso
		// (docs/coach-teams/DECISIONS.md §2).
		programViewReadonlyBadge: "Sola lettura",
		programViewReadonlyNote:
			"Puoi consultare questo programma ma non modificarlo: solo il coach che lo ha creato puo' cambiarlo.",
		programViewSharedVia: "Condiviso dal team",
		programViewDuplicate: "Duplica nella mia libreria",
		programViewDuplicated: "Programma duplicato nella tua libreria",
		programViewBack: "Torna ai programmi",
		programViewNoWeeks: "Questo programma non ha ancora settimane.",
		programViewLoadError: "Programma non disponibile",
		groupSharingOwnerOnly:
			"Solo il coach che ha creato il gruppo puo' cambiarne la condivisione.",
		// Coach team lato coach (docs/coach-teams/PLAN.md Fase 1)
		coachTeams: "Team di coach",
		coachTeamsSubtitle:
			"I team con cui condividi programmi, cartelle e gruppi di atleti con altri coach.",
		coachTeamsNew: "Nuovo team",
		coachTeamsNewHint:
			"Ne diventi il proprietario: potrai aggiungere coach e assegnargli i tuoi atleti.",
		coachTeamsNamePlaceholder: "es. Palestra Nord, Staff competitor",
		coachTeamsGuideTitle: "Come funzionano i team di coach",
		coachTeamsGuideShow: "Come funzionano?",
		coachTeamsGuideWhat: "Cos'e' un team di coach",
		coachTeamsGuideWhatBody:
			"Un gruppo di coach che lavorano insieme, per esempio i trainer di una palestra. Serve a condividere materiale e atleti senza doverlo fare una persona alla volta: condividi con il team, e vale per tutti quelli che ne fanno parte, anche per chi entrera' domani.",
		coachTeamsGuideOwner: "Se il team e' tuo",
		coachTeamsGuideOwnerBody:
			"Lo hai creato tu, quindi lo amministri: puoi rinominarlo, aggiungere e togliere coach, assegnargli i tuoi atleti ed eliminarlo. Nessun altro coach del team puo' farlo.",
		coachTeamsGuideMember: "Se sei stato aggiunto",
		coachTeamsGuideMemberBody:
			"Vedi il team, i colleghi che ne fanno parte e tutto cio' che ci viene condiviso. Non puoi amministrarlo: chi lo gestisce e' il coach che lo ha creato.",
		coachTeamsGuideShare: "Cosa possono fare i coach del team",
		coachTeamsGuideShareBody:
			"Leggere i programmi e le cartelle condivise con il team, e duplicarli nella propria libreria per lavorarci. Non possono modificare i tuoi programmi: la condivisione e' in sola lettura, cosi' nessuno cancella il lavoro di un altro. Sui gruppi di atleti condivisi, invece, gestiscono gli atleti insieme a te.",
		coachTeamsGuideAdd: "Come si aggiunge un coach",
		coachTeamsGuideAddBody:
			"Puoi aggiungere i colleghi dei team di cui gia' fai parte, oppure un tuo atleta a cui l'amministratore ha abilitato la modalita' coach. Per far entrare un nuovo trainer: invitalo come atleta con il tuo link di invito, chiedi l'abilitazione coach all'amministratore, poi aggiungilo qui.",
		coachTeamsEmpty:
			"Non fai ancora parte di nessun team. Creane uno per condividere programmi e atleti con altri coach.",
		coachTeamsOwnerBadge: "Team tuo",
		coachTeamsOwnerShort: "proprietario",
		coachTeamsOwnerLabel: "Proprietario",
		coachTeamsNoOwner: "Team di piattaforma (nessun proprietario)",
		adminCoachAthletesSummary:
			"{direct} assegnati direttamente · {shared} condivisi",
		adminCoachAthletesSelfNote:
			"Il profilo atleta del coach stesso non e' contato: serve ad assegnarsi programmi e si toglie disattivando la modalita' coach.",
		adminCoachAthletesTabDirect: "Diretti",
		adminCoachAthletesTabShared: "Condivisi",
		adminCoachAthletesTabAdd: "Aggiungi",
		adminCoachAthletesDirectEmpty: "Nessun atleta assegnato direttamente.",
		adminCoachAthletesSharedEmpty: "Nessun atleta condiviso da team o gruppi.",
		adminCoachAthletesSharedHint:
			"Il coach li gestisce perche' fanno parte di un gruppo o di un team condiviso con lui. Non si tolgono da qui: si toglie l'atleta dal gruppo o dal team.",
		adminCoachAthletesViaTeam: "Team",
		adminCoachAthletesGroupOwner: "di {name}",
		adminCoachAthletesTeamBucketMeta:
			"Assegnati al team, fuori dai gruppi condivisi",
		adminCoachAthletesAddHint:
			"Cerca per nome o email un atleta da assegnare direttamente a questo coach.",
		adminCoachAthletesAddMore:
			"Mostrati i primi {count} risultati: affina la ricerca.",
		adminCoachAthletesDirectStat: "Diretti",
		adminCoachAthletesSharedStat: "+{count} condivisi",
		adminCoachAthletesNotDirect:
			"L'atleta non e' assegnato direttamente a questo coach: arriva da un team o da un gruppo condiviso.",
		coachTeamsOwnerUnavailable: "Account non disponibile",
		coachTeamsMemberBadge: "Ne fai parte",
		coachTeamsPlatformBadge: "Gestito dall'amministratore",
		coachTeamsMembers: "Coach e atleti del team",
		coachTeamsCoaches: "Coach",
		coachTeamsAthletes: "Atleti assegnati al team",
		coachTeamsCoachCount: "Coach",
		coachTeamsAthleteCount: "Atleti",
		coachTeamsSharedFolders: "Cartelle condivise",
		coachTeamsSharedPrograms: "Programmi condivisi",
		coachTeamsSharedGroups: "Gruppi condivisi",
		coachTeamsAddCoach: "Aggiungi un coach",
		coachTeamsNoCandidates: "Nessun coach disponibile",
		coachTeamsAddAthletes: "Assegna atleti",
		coachTeamsAddAthletesHint:
			"Gli atleti assegnati al team sono visibili e gestibili da tutti i coach che ne fanno parte.",
		coachTeamsNoAthletes: "Nessun atleta assegnato a questo team.",
		coachTeamsNoAthletesToAdd: "Nessun atleta da aggiungere.",
		coachTeamsAthletesSkipped:
			"Alcuni atleti non sono stati assegnati: puoi assegnare solo i tuoi.",
		coachTeamsCreated: "Team creato",
		coachTeamsDeleted: "Team eliminato",
		coachTeamsDeleteConfirm:
			"Eliminare questo team? I programmi, le cartelle e i gruppi condivisi con esso smetteranno di essere condivisi. Nessun contenuto viene cancellato.",
		programSearchPlaceholder: "Cerca programma...",
		programSortNewest: "Più recenti",
		programSortOldest: "Meno recenti",
		programSortAlphabetical: "Alfabetico",
		team: "Team",
		teams: "Team",
		newProgram: "Nuovo Programma",
		newFolder: "Nuova Cartella",
		renameFolder: "Rinomina Cartella",
		emptyFolder: "Cartella vuota",
		noPrograms: "Nessun programma",
		addToFolder: "Aggiungi programmi o sotto-cartelle",
		createFirstProgram: "Inizia creando il tuo primo programma di allenamento",
		trashBin: "Cestino",
		trashBinDesc: "Programmi eliminati di recente",
		noDeletedPrograms: "Il cestino è vuoto",
		noDeletedProgramsDesc: "I programmi eliminati appariranno qui",
		restoreProgram: "Ripristina",
		permanentlyDelete: "Elimina definitivamente",
		backToPrograms: "Torna ai programmi",
		pbProgramSettings: "Dettagli e assegnazioni",
		pbGroupShowAthletes: "Mostra/nascondi gli atleti del gruppo",
		pbGroupNoAthletes: "Gruppo vuoto",
		pbGroupHiddenAthletes: "non visibili a te",
		pbExerciseActions: "Azioni esercizio",
		pbExerciseToggleEditor: "Apri/chiudi la modifica dell'esercizio",
		pbActionEditExercise: "Modifica esercizio",
		pbActionAddSetRow: "Aggiungi riga serie",
		pbActionMoveUp: "Sposta su",
		pbActionMoveDown: "Sposta giù",
		pbActionLeaderboardOn: "Attiva leaderboard",
		pbActionLeaderboardOff: "Disattiva leaderboard",
		pbActionResultEntryOn: "Attiva inserimento risultato",
		pbActionResultEntryOff: "Disattiva inserimento risultato",
		pbActionCopyExercise: "Copia esercizio",
		pbActionExportExercise: "Esporta esercizio",
		pbActionShareExercise: "Condividi esercizio",
		pbActionDuplicateNextWeek: "Duplica alla settimana successiva",
		pbActionRemoveExercise: "Rimuovi esercizio",
		pbDayActions: "Azioni giornata",
		pbWeekActions: "Impostazioni settimana",
		pbDayActionEdit: "Modifica titolo e data",
		pbDayActionEditClose: "Chiudi modifica titolo e data",
		pbDayActionDuplicate: "Duplica giornata",
		pbDayActionExport: "Esporta giornata",
		pbDayActionRemove: "Elimina giornata",
		pbHideSettings: "Nascondi pannello",
		pbHideSettingsHint:
			"Nasconde la colonna con dettagli, atleti e accessi: l'editor guadagna larghezza. Restano raggiungibili dallo stesso pulsante.",
		pbProgramSettingsHint:
			"Titolo, tipo e date del programma, atleti e gruppi assegnati, accessi degli altri coach",
		pbShowSettingsColumn: "Mostra sempre in colonna",
		pbSettingsInSheetHint:
			"Con il pannello laterale aperto le impostazioni restano qui, per lasciare larghezza all'editor.",
		pbWideModeOn: "Usa tutta la larghezza",
		pbWideModeOff: "Torna alla larghezza standard",
		// Striscia stagionale (docs/program-builder-season-strip)
		pbSeasonStripOn: "Mostra fasi e gare sulle settimane",
		pbWeekViewOverview: "Panoramica settimana a colonne",
		pbWeekViewEditor: "Torna all'editor",
		pbWeekOverviewOpenDay: "Apri nell'editor",
		pbWeekOverviewHint:
			"Vista di sola lettura: clicca un giorno per modificarlo nell'editor. Puoi trascinare qui gli esercizi dal pannello di confronto.",
		pbSeasonBandLabel: "Pianificazione mesociclo",
		pbDockAgenda: "Agenda",
		pbSeasonFollowEditorOn: "Segue la settimana aperta nell'editor",
		pbSeasonFollowEditorOff: "Mese fisso: attiva per seguire l'editor",
		pbSeasonOpenAthlete: "Apri scheda atleta",
		pbSeasonAgendaHint:
			"La settimana aperta nell'editor è evidenziata nel calendario.",
		pbSeasonStripOff: "Nascondi fasi e gare",
		pbSeasonNoPhases: "Nessuna fase pianificata",
		pbDeleteWeekTitle: "Elimina settimana",
		pbDeleteWeekBody:
			"Il programma è datato: le settimane successive possono scalare per chiudere il buco che questa lascia, oppure restare sulle loro date.",
		pbDeleteWeekKeepDates: "Elimina e lascia le date",
		pbDeleteWeekShiftDates: "Elimina e anticipa di",
		pbDeleteWeekLoading: "Carico le settimane successive…",
		pbSeasonAgendaError: "Agenda non caricata",
		pbSeasonAgendaRetry: "Riprova",
		pbSeasonPlan: "Pianifica",
		pbSeasonPlanAthleteHint: "Apri la pianificazione nel pannello laterale",
		pbSeasonPlanGroupHint: "Apri il calendario gare in una nuova scheda",
		pbSeasonGroupBadge: "Gruppo",
		mesocycleGroupReadonly:
			"Fase di gruppo: si modifica dalla pianificazione del gruppo",
		competitionHubPickGroup: "Aggiungi tutti gli atleti di un gruppo",
		pbSeasonNoCompetitions: "Nessuna gara in programma",
		pbSeasonIn: "tra",
		pbSeasonDaysShort: "gg",
		pbSeasonToday: "oggi",
		pbSeasonTomorrow: "domani",
		pbSeasonOngoing: "in corso",
		pbSeasonAthletes: "atleti",
		pbSeasonAthleteSelector: "Agenda di",
		pbCopyDay: "Copia giornata",
		pbPaste: "Incolla",
		pbClipboardOneItem: "1 esercizio negli appunti",
		pbClipboardManyItems: "esercizi negli appunti",
		pbClipboardClear: "Svuota appunti",
		pbClipboardCopiedOne: "Esercizio copiato",
		pbClipboardCopiedMany: "esercizi copiati",
		pbClipboardPastedOne: "Esercizio incollato",
		pbClipboardPastedMany: "esercizi incollati",
		pbClipboardNothingToCopy: "Nessun esercizio copiabile in questa giornata",
		pbClipboardNotShared:
			"Appunti non condivisi con le altre schede del browser (memoria non disponibile)",
		pbDockReference: "Riferimento",
		pbOpenReference: "Confronta",
		pbOpenReferenceHint:
			"Apri un altro programma affiancato per confrontare le settimane e copiare esercizi",
		pbDockAi: "AI",
		pbDockClose: "Chiudi pannello",
		pbDockResize: "Ridimensiona il pannello",
		pbSourceThisProgram: "Questo programma",
		pbSourceOtherProgram: "Altro programma",
		pbSourceSearch: "Cerca programma...",
		pbSourceUntitled: "Programma senza titolo",
		pbSourceNoResults: "Nessun programma trovato",
		pbSourceLoadFailed: "Caricamento programmi non riuscito",
		pbSourceAllPrograms: "Tutti i programmi",
		pbSourceEmptyFolder: "Cartella vuota",
		pbRetry: "Riprova",
		pbSwapWithEditor: "Scambia con l'editor: modifica questo programma",
		pbSwapSaveFirst:
			"Salva il programma prima di scambiarlo con il riferimento",
		pbSwapConfirmTitle: "Modifiche non salvate",
		pbSwapConfirmBody:
			"Questo programma ha modifiche non salvate. Salvale per aprire il programma di riferimento nell'editor, tenendo questo come riferimento.",
		pbSwapSaveAndSwap: "Salva e scambia",
		pbReferenceJumpToDay: "Vai a questa giornata nell'editor",
		pbDeltaVsReference: "Rispetto alla settimana di riferimento:",
		pbDeltaVsPreviousWeek: "Rispetto alla settimana precedente",
		pbDeltaTopLoad: "carico massimo",
		pbDeltaSameTopLoad: "stesso carico massimo",
		pbViewWeek: "Vista settimana",
		pbViewProgression: "Vista progressione",
		pbProgressionEmpty: "Nessun esercizio da confrontare",
		pbProgressionGoToCell: "Vai a questa settimana nell'editor",
		pbProgressionCloseDetail: "Chiudi dettaglio",
		pbProgressionFullscreen: "Apri la matrice a schermo intero",
		pbProgressionLegend:
			"Le frecce confrontano il carico massimo in percentuale con la settimana precedente. Dove il carico non è in percentuale non viene mostrata nessuna freccia.",
		pbReferenceFollowOn: "Segue l'editor (settimana precedente)",
		pbReferenceFollowOff: "Settimana fissa: attiva per seguire l'editor",
		pbReferenceSelect: "Seleziona più esercizi",
		pbReferenceCopySelection: "Copia",
		pbReferenceCopyExercise: "Copia esercizio negli appunti",
		pbReferenceCopyDay: "Copia giornata negli appunti",
		pbReferenceEditorWeek: "Settimana aperta nell'editor",
		pbReferenceSharedReadonly: "Esercizio condiviso in sola lettura",
		pbReferenceEmptyWeek: "Questa settimana non ha giornate",
		pbReferenceEmptyDay: "Nessun esercizio",
		pbReferenceNoWeeks: "Questo programma non ha settimane",
		pbReferencePickSource: "Scegli un programma da affiancare",
		pbReferenceLoadError: "Impossibile caricare il programma",
		pbReferenceReadOnlyHint:
			"Sola lettura: usa gli appunti per portare gli esercizi nell'editor",
		pbReferenceUnsavedHint:
			"Programma non ancora salvato: il riferimento mostra le modifiche correnti",
		deletedOn: "Eliminato il",
		movedToTrash: "Programma spostato nel cestino",
		programRestored: "Programma ripristinato",
		programPermanentlyDeleted: "Programma eliminato definitivamente",
		confirmPermanentDelete:
			"Questo programma sarà eliminato definitivamente e non sarà possibile recuperarlo. Continuare?",
		assignGroups: "Assegna Gruppi",
		datedMode: "Datato (calendario)",
		datedModeRecommended: "Consigliato: datato",
		undatedMode: "Non datato (progressivo)",
		datedModeHint:
			"I giorni hanno date reali: nel builder scegli da quando parte, poi ogni settimana compare agli atleti da sola la domenica prima e si nasconde dopo la sua domenica. Lo cambi in Dettagli.",
		undatedModeHint:
			"Giorni progressivi senza date, da riusare per più atleti in momenti diversi: le settimane le pubblichi tu.",
		sortNewest: "Più recenti",
		sortOldest: "Meno recenti",
		sortAlpha: "Alfabetico",
		titleLabel: "Titolo",
		editProgram: "Modifica programma",
		programsLoadError: "Errore nel caricamento dei programmi",
		programCreatedSuccess: "Programma creato con successo",
		programDuplicated: "Programma duplicato",
		programDeleted: "Programma eliminato",
		confirmDeleteProgram: "Sei sicuro di voler eliminare questo programma?",
		pdfExported: "PDF esportato con successo!",
		exporting: "Esporto...",
		exportPdf: "Esporta PDF",
		duplicateProgram: "Duplica programma",
		exportError: "Errore export",
		folderCreated: "Cartella creata",
		folderRenamed: "Cartella rinominata",
		folderDeleted: "Cartella eliminata",
		folderMoved: "Cartella spostata",
		confirmDeleteFolder:
			"Eliminare questa cartella? I contenuti verranno spostati nella cartella superiore.",
		programMoved: "Programma spostato",
		programTitlePlaceholder: "Programma Forza 4 Settimane",
		programDescriptionPlaceholder: "Descrizione del programma...",
		createIn: "Verrà creato in",
		inLabel: "In",
		folderNamePlaceholder: "Nome cartella",
		rootNoFolder: "Root (nessuna cartella)",
		daysLabel: "giorni",
		athletesLabel: "atleti",
		createdByLabel: "Creato da",
		createdOnLabel: "Data creazione",

		// Athletes
		manageAthletes: "Gestisci i tuoi atleti e monitora i loro progressi",
		editAthlete: "Modifica Atleta",
		sportLabel: "Sport",
		weightKg: "Peso (kg)",
		searchAthletes: "Cerca atleti...",
		selectSport: "Seleziona sport",
		sportsMultiHint:
			"Puoi selezionarne più di uno. Il primo è quello principale e apre il profilo prestativo.",
		sportPrimaryBadge: "Principale",
		performanceNoDomainsForSport:
			"Nessun dominio ancora configurato per questa disciplina.",
		performanceNoSportTitle: "Nessuno sport configurato",
		performanceNoSportHint:
			"Il profilo prestativo è organizzato per disciplina: finché non ne scegli una non puoi inserire i tuoi massimali, e i carichi a percentuale restano stimati dai risultati in agenda.",
		performanceNoSportCta: "Scegli la disciplina",
		performanceNoSportCoachHint:
			"Questo atleta non ha ancora scelto una disciplina: il profilo prestativo resta vuoto e i suoi massimali manuali non sono inseribili. I carichi a percentuale vengono stimati dai risultati in agenda.",
		notesPlaceholder: "Note sull'atleta...",
		openPerformanceProfile: "Apri profilo prestativo",
		// Spiegazione in interfaccia: cosa cambia scegliendo uno sport (atleta)
		// e seguendo una disciplina (coach). Spec: docs/sport-config/ANALYSIS.md §1.3
		sportsNoneConfigured: "Nessuna disciplina configurata.",
		sportsFilterAll: "Tutti gli sport",
		sportsExplainTitle: "Cosa cambia scegliendo uno sport",
		sportsExplainProfile: "Il profilo prestativo",
		sportsExplainProfileBody:
			"Ogni sport ha il suo, con domini, test e tabelle di riferimento propri: quello di sistema, o quello del coach se ne ha pubblicato uno. Con più sport compare un tab per ciascuno. Un massimale vale in tutti gli sport che usano quell'esercizio, ma il livello può cambiare perché le tabelle sono diverse.",
		sportsExplainLeaderboards: "Le classifiche",
		sportsExplainLeaderboardsBody:
			"Si compare nelle classifiche del profilo prestativo di ogni sport praticato, solo se le performance sono pubbliche.",
		sportsExplainSections: "Le schede del profilo",
		sportsExplainSectionsBody:
			"Le discipline di tiro aggiungono la scheda Tiro, con armi e classi di merito; quelle di preparazione fisica la scheda Esercizi, con record e massimali.",
		sportsExplainCompetitions: "Il calendario gare",
		sportsExplainCompetitionsBody:
			"Suggerisce le gare inserite dagli atleti degli stessi coach che praticano almeno uno degli stessi sport, oltre a quelle dei compagni di gruppo.",
		sportsExplainPrimary: "Lo sport principale",
		sportsExplainPrimaryBody:
			"È il primo della lista: il profilo prestativo si apre su quello. Togliendolo, diventa principale il successivo.",
		sportsExplainUnchanged: "Cosa non cambia",
		sportsExplainUnchangedBody:
			"Programmi, risultati registrati e massimali inseriti. Togliere uno sport non cancella niente: lo toglie da profilo e classifiche, e riaggiungendolo torna tutto com'era.",
		sportsExplainCoachNote:
			"Gli sport li può cambiare il coach da qui o l'atleta dal suo profilo: vale l'ultimo salvataggio. Se il profilo prestativo di un atleta è vuoto, di solito manca proprio lo sport.",
		coachDisciplinesExplainTitle:
			"Cosa cambia per un coach seguire una disciplina",
		coachDisciplinesExplainWhat: "Cosa decide",
		coachDisciplinesExplainWhatBody:
			"Gli sport per cui il coach può creare un modello prestativo suo, dalla sezione Sport e modelli. Li sceglie il coach; quelli di tiro li assegna l'admin.",
		coachDisciplinesExplainScope: "Il tiro",
		coachDisciplinesExplainScopeBody:
			"Le discipline di tiro sono le sole che cambiano l'interfaccia: aggiungono drill, dry fire, live fire e classifiche di tiro. Senza una disciplina di tiro il coach non vede queste sezioni.",
		coachDisciplinesExplainEmpty: "Nessuna selezione",
		coachDisciplinesExplainEmptyBody:
			"Il coach lavora sulla preparazione fisica come sempre, ma non può creare modelli suoi finché non sceglie almeno uno sport.",
		coachDisciplinesExplainData: "Cosa non limita",
		coachDisciplinesExplainDataBody:
			"Non è un permesso e non filtra i dati: il coach continua a vedere i suoi atleti, i programmi condivisi e il profilo prestativo completo di ogni atleta, anche negli sport che non segue.",
		coachDisciplinesExplainConfigure: "«Può configurare» è un'altra cosa",
		coachDisciplinesExplainConfigureBody:
			"Permette di modificare i dati di riferimento di una disciplina, cioè le categorie di peso e, per il tiro, division, classi e sistemi di punteggio, senza essere admin. Il modello prestativo di sistema resta dell'admin: chi vuole un profilo diverso se ne crea uno suo. Non dà accesso a utenti, team o programmi.",
		ppSystemModelGlobalOnly:
			"Il modello di sistema usa solo esercizi e conditioning della libreria globale. Per usarne uno personale, rendilo prima globale da Collaborazione Library.",
		// Editor del modello prestativo (components/performance/PerformanceModelEditor.js)
		pmNewDomain: "Nuovo dominio",
		pmTablesLabel: "Tabelle di riferimento",
		pmTablesByGender: "Per genere",
		pmTablesByDivision: "Per genere e division",
		pmExercisesCount: "{count} esercizi",
		pmScale: "Scala",
		pmEditDomainHint: "Modifica dominio e scala punteggio",
		pmDeleteDomain: "Elimina dominio",
		pmScoreScale: "Scala punteggio",
		pmScaleMinColumns: "Solo numeri · minimo {n} colonne",
		pmScaleAddPlaceholder: "es. 20",
		pmAdd: "Aggiungi",
		pmScaleHelp1: "Per riscrivere l'intera scala in un colpo solo usa",
		pmEditDomain: "Modifica dominio",
		pmScaleHelp2:
			"Da qui aggiungi i nuovi valori prima di togliere quelli vecchi: sotto le {n} colonne il punteggio non si può più interpolare.",
		pmRemoveColumn: "Togli la colonna {score}",
		pmRemoveColumnBlocked:
			"Servono almeno {n} colonne: aggiungine una nuova prima di togliere questa",
		pmReferences: "Riferimenti",
		pmMale: "Uomo",
		pmFemale: "Donna",
		pmDivision: "Division",
		pmDivisionEmptyHint:
			"Celle vuote: per questa division vale la tabella per genere.",
		pmColExercise: "Esercizio",
		pmColUnit: "Unità",
		pmColActions: "Azioni",
		pmMoveUp: "Sposta su",
		pmMoveDown: "Sposta giù",
		pmRemoveExercise: "Togli esercizio",
		pmNoExercises: "Nessun esercizio configurato",
		pmNoExercisesHint: "Aggiungi esercizi o conditioning dalla libreria",
		pmAddExercise: "Aggiungi esercizio o conditioning",
		pmNoDomains: "Nessun dominio configurato",
		pmNoDomainsHint:
			"Crea domini come «Forza massima», «Potenza», «Endurance» e aggiungi gli esercizi che li misurano.",
		pmCreateFirstDomain: "Crea il primo dominio",
		pmUnitKg: "Kg",
		pmUnitReps: "Ripetizioni",
		pmUnitSeconds: "Secondi",
		pmUnitMinutes: "Minuti",
		pmUnitMinSec: "Minuti e secondi",
		pmUnitHitFactor: "Hit factor (punti/tempo)",
		pmUnitMeters: "Metri",
		pmUnitPoints: "Punti",
		pmErrScaleValueRequired: "Inserisci il valore da aggiungere alla scala",
		pmErrNotNumber:
			"«{value}» non è un numero: la scala accetta solo numeri, per esempio 1, 5, 10, 15.",
		pmErrColumnExists: "La colonna {score} è già nella scala",
		pmColumnAdded: "Colonna {score} aggiunta",
		pmErrMinColumns:
			"Servono almeno {n} colonne per interpolare il punteggio: aggiungi i nuovi valori prima di togliere questi.",
		pmColumnRemoved: "Colonna {score} tolta",
		pmErrFormat: "Formato non valido. Usa: {format}",
		pmErrDomainName: "Il nome del dominio è obbligatorio",
		pmErrScaleInvalid:
			"Scala non valida: {values}. Usa solo numeri separati da virgola, per esempio 1, 5, 10, 15.",
		pmErrScaleMin: "La scala richiede almeno {n} punteggi numerici.",
		pmDomainUpdated: "Dominio aggiornato",
		pmDomainCreated: "Dominio creato",
		pmConfirmDeleteDomain: "Eliminare questo dominio e tutti i suoi esercizi?",
		pmDomainDeleted: "Dominio eliminato",
		pmExerciseAdded: "{name} aggiunto",
		pmExerciseRemoved: "Esercizio tolto",
		pmUnitUpdated: "Unità aggiornata",
		pmOrderUpdated: "Ordine aggiornato",
		pmSegmentationUpdated: "Tabelle aggiornate",
		pmDomainDialogEdit: "Modifica dominio",
		pmDomainDialogNew: "Nuovo dominio",
		pmDomainName: "Nome del dominio *",
		pmDomainNamePlaceholder: "Es. Forza massima",
		pmDomainDescription: "Descrizione",
		pmDomainDescriptionPlaceholder: "Facoltativa",
		pmDomainDescriptionHint:
			"Coach e atleti la leggono nella guida «Come si leggono i livelli» del profilo: è il posto per dire da dove vengono le soglie.",
		pmDomainColor: "Colore",
		pmDomainScale: "Scala punteggio *",
		pmDomainScaleHelp:
			"Solo numeri separati da virgola, almeno {n}. Sono i livelli della scala, per esempio 1, 5, 10, 15: per ogni esercizio inserisci il riferimento di ciascun livello, e il punteggio dell'atleta si interpola fra questi valori.",
		pmDomainScaleEditWarning:
			"Togliendo un livello, i riferimenti già inseriti su quel livello non si vedono più e si scartano al successivo salvataggio dell'esercizio.",
		pmSaving: "Salvataggio…",
		pmSaveChanges: "Salva modifiche",
		pmCreateDomain: "Crea dominio",
		pmCategory: "Categoria",
		pmAllCategories: "Tutte le categorie",
		// Sezione Sport e modelli (docs/sport-config, Fase 2)
		sportConfigNav: "Sport e modelli",
		scTitle: "Sport e modelli",
		scSubtitle:
			"Gli sport che alleni e i modelli con cui valuti i tuoi atleti.",
		scGuideShow: "Come funziona?",
		scGuideTitle: "Come funziona questa sezione",
		scGuideSports: "Gli sport che segui",
		scGuideSportsBody:
			"Scegli gli sport che alleni: sono quelli per cui puoi costruire un modello prestativo tuo. Non cambiano cosa vedi del resto della piattaforma, né dei tuoi atleti.",
		scGuideModel: "Il modello prestativo",
		scGuideModelBody:
			"È la griglia con cui si valuta un atleta in uno sport: domini, test e livelli, dal principiante all'agonista. Il modello di sistema è uguale per tutti; puoi crearne uno tuo partendo da quello di sistema o da zero.",
		scGuidePublish: "Pubblicare e ritirare",
		scGuidePublishBody:
			"Il tuo modello nasce non pubblicato: costruiscilo con calma, le modifiche si salvano subito. Quando lo pubblichi vale per i tuoi atleti di quello sport al posto di quello di sistema; se lo ritiri tornano al modello di sistema. Massimali e risultati degli atleti non cambiano: cambia come vengono letti.",
		scGuideTeam: "Nel team",
		scGuideTeamBody:
			"I coach del tuo team vedono il tuo modello pubblicato ma non lo modificano. Se un atleta è seguito da due coach con due modelli diversi resta su quello di sistema, finché uno dei due non sceglie a mano dalla sua scheda.",
		scFollowedTitle: "Gli sport che segui",
		scFollowedHint: "Sono gli sport per cui puoi creare un modello tuo.",
		scShootingLocked: "Le discipline di tiro le assegna l'admin.",
		scSaveSports: "Salva",
		scSportsSaved: "Sport aggiornati",
		scNoSports: "Scegli almeno uno sport che segui per vedere i suoi modelli.",
		scYourAthletes: "{count} tuoi atleti",
		scNotFollowed: "Non lo segui più",
		scEdit: "Modifica",
		scOpen: "Apri",
		scWithdraw: "Ritira",
		scPublish: "Pubblica",
		scDelete: "Elimina",
		scNoOwnModel:
			"Non hai un modello tuo per questo sport: i tuoi atleti usano quello di sistema.",
		scCreateFromSystem: "Crea il tuo dal modello di sistema",
		scCreateEmpty: "Crea vuoto",
		scTeamConflictHint:
			"Un collega del tuo team ha già un modello pubblicato: se pubblichi anche il tuo, gli atleti che seguite insieme tornano al modello di sistema finché uno di voi non sceglie a mano.",
		scTeamModels: "Modelli del tuo team",
		scModelCreated: "Modello creato, non ancora pubblicato",
		scConfirmWithdraw:
			"Ritirando il modello, i tuoi atleti tornano al modello di sistema. Continuare?",
		scModelWithdrawn: "Modello ritirato",
		scConfirmDelete:
			"Eliminare il modello con tutti i domini e i test? I valori degli atleti restano.",
		scModelDeleted: "Modello eliminato",
		scModelPublished: "Modello pubblicato",
		scSystemModel: "Modello di sistema",
		scCoachModel: "Modello del coach",
		scSystemModelOwner: "Della piattaforma",
		scModelOf: "di {name}",
		scCounts: "{domains} domini, {exercises} test",
		scUsedBy: "lo usano {count} tuoi atleti",
		scPublished: "Pubblicato",
		scNotPublished: "Non pubblicato",
		scPublishTitle: "Pubblicare il modello?",
		scPublishUsing:
			"Pubblicandolo, {using} dei tuoi {athletes} atleti di questo sport useranno il tuo modello al posto di quello di sistema.",
		scPublishManual: "{count} restano sul modello scelto a mano per loro.",
		scPublishConflicts:
			"{count} restano sul modello di sistema perché li segue anche {owners} con un suo modello: puoi scegliere a mano dalla loro scheda.",
		scAnotherCoach: "un altro coach",
		scPublishGeneric:
			"Pubblicandolo, varrà per i tuoi atleti di questo sport al posto del modello di sistema.",
		scPublishReversible:
			"Puoi ritirarlo quando vuoi: i tuoi atleti tornano al modello di sistema, e i loro valori non cambiano.",
		scModelRenamed: "Nome aggiornato",
		scModelNotFound: "Modello non trovato, o non visibile per te.",
		scModelName: "Nome del modello",
		scReadOnlySystem:
			"Sola lettura: è il modello di sistema. Per cambiarlo creane uno tuo partendo da questo, dalla sezione Sport e modelli.",
		scReadOnlyTeam: "Sola lettura: è il modello di un collega del tuo team.",
		scDraftHint:
			"Non pubblicato: i tuoi atleti restano sul modello di sistema finché non lo pubblichi. Le modifiche si salvano subito.",
		scAthleteModelSaved: "Modello dell'atleta aggiornato",
		scEvaluatedWith: "Valutato con:",
		scChosenByHand: "scelto a mano",
		scChooseModel: "Scegli il modello",
		scAutomatic: "Automatico",
		scBadgeInfoTitle: "La tua categoria di peso",
		adminPmSport: "Disciplina",
		adminPmSelectSport: "Seleziona una disciplina",
		adminPmModelsTitle: "Modelli prestativi",
		adminPmModelsHint:
			"Il modello di sistema e quelli dei coach per questa disciplina. Seleziona una riga per aprirla.",
		adminPmColModel: "Modello",
		adminPmColOwner: "Di",
		adminPmColStatus: "Stato",
		adminPmColContent: "Contenuto",
		adminPmColAthletes: "Atleti",
		adminPmPlatform: "Piattaforma",
		adminPmAthletesUsing: "{count} lo usano · {manual} scelte a mano",
		adminPmAthletesTotal: "Atleti di questa disciplina: {count}",
		adminPmCoachModelWarning:
			"È il modello di un coach: lo stai modificando come admin, per supporto. Le modifiche valgono subito per i suoi atleti.",
		// IPF GL e classifiche col peso (docs/sport-config, D14)
		coefSinclair: "Sinclair",
		coefIpfGl: "IPF GL",
		pmCoefficient: "Coefficiente",
		pmCoefficientNone: "Nessuno",
		pmIpfGlHint:
			"L'IPF GL vale per la panca e per il totale delle tre alzate: indica sotto ogni esercizio se è lo squat, la panca o lo stacco di gara. Squat e stacco da soli non hanno punti GL.",
		pmIpfLift: "Alzata di gara",
		pmIpfLiftNone: "Non è un'alzata di gara",
		pmIpfSquat: "Squat",
		pmIpfBench: "Panca",
		pmIpfDeadlift: "Stacco",
		ipfClassic: "classic",
		ipfEquipped: "equipped",
		ipfTotalLabel: "Totale",
		ipfGlPoints: "{points} punti GL",
		ppGlValue: "GL {value}",
		lbAllClasses: "Tutte le categorie",
		lbMyClass: "La mia categoria · {label}",
		lbMyClassUnknown: "La mia categoria",
		lbAddWeightHint:
			"Aggiungi il peso nel profilo per vedere la tua categoria.",
		lbSortBy: "Ordina per",
		lbSortValue: "kg",
		// Peso corporeo: categorie e Sinclair (docs/sport-config, Fase 4)
		scGuideBodyweight: "Peso corporeo",
		scGuideBodyweightBody:
			"Negli sport dove conta, come pesistica e powerlifting, il modello può leggere i livelli per categoria di peso e mostrare il Sinclair accanto ai chili. Si accende nel modello e resta spento dove non serve, come nel CrossFit.",
		pmTablesByWeightClass: "Per categoria di peso",
		pmSinclairUpdated: "Coefficiente aggiornato",
		pmWeightClassesTitle: "Categorie di peso dello sport",
		pmManageClasses: "Gestisci categorie",
		pmNoClassesCanEdit:
			"Questo sport non ha ancora categorie di peso: aggiungile per compilare le tabelle.",
		pmNoClassesAskAdmin:
			"Questo sport non ha ancora categorie di peso: le decide chi amministra lo sport.",
		pmWeightClassHint:
			"La categoria dell'atleta si ricava dal peso del suo profilo. Una categoria senza tabella usa quella del genere.",
		pmWeightClass: "Categoria",
		pmGenderTable: "Tabella del genere (senza peso)",
		pmGenderTableHint:
			"Questa è la tabella di riserva: vale per chi non ha peso o genere nel profilo e per le categorie senza una tabella propria.",
		pmWeightClassEmptyHint:
			"Stai compilando la tabella di una categoria. Se resta vuota, gli atleti di quella categoria si leggono sulla tabella del genere.",
		wcTitle: "Categorie di peso · {sport}",
		wcHint:
			"Valgono per tutti i modelli di questo sport. Togliere una categoria non cancella le sue tabelle: rimettendola le ritrovi.",
		wcPresets: "Parti da:",
		wcPresetIwf: "Pesistica IWF (dal 2026)",
		wcPresetIpf: "Powerlifting IPF",
		wcNone: "Nessuna categoria",
		wcRemove: "Togli -{cap} kg",
		wcCapLabel: "Limite della categoria in kg",
		wcCapPlaceholder: "Es. 73",
		wcAdd: "Aggiungi",
		wcOpenClass: "Categoria aperta oltre l'ultimo limite",
		wcKeepsTables:
			"Ogni categoria si chiama col suo limite: -73 vuol dire fino a 73 kg compresi.",
		wcSaved: "Categorie salvate",
		wcInvalidCap: "Scrivi un limite in kg, maggiore di zero",
		ppSinclairValue: "Sinclair {value}",
		ppGenderTableUsed: "tabella del genere",
		lgOpen: "Come si leggono i livelli",
		lgTitle: "Come si leggono i livelli · {domain}",
		lgIntro: "Cosa vuol dire il livello di ogni esercizio, e su quali soglie si calcola.",
		lgHowTitle: "Il livello",
		lgHowScore:
			"Ogni esercizio ha una soglia per livello. Il livello si ricava dal massimale: fra due soglie si interpola, quindi 6,5 vuol dire a metà strada fra il livello 6 e il 7. Oltre l'ultima soglia resta il livello più alto, sotto la prima scende verso 0.",
		lgHowTimes: "Per i tempi vale il contrario: meno tempo, livello più alto.",
		lgWeightClass:
			"Le soglie sono quelle della categoria {class}, ricavata dal peso e dal genere del profilo: lo stesso massimale vale di più in una categoria leggera.",
		lgFallback:
			"Dove manca il peso nel profilo, o la tabella della categoria, si usano le soglie del genere.",
		lgScaleTitle: "La scala",
		lgScaleNumbers: "Da {min} a {max}: più alto è meglio.",
		lgThresholds: "Le soglie",
		lgThresholdsClass: "Le soglie della categoria {class}",
		lgThresholdsHint: "Evidenziato il livello raggiunto in ogni esercizio.",
		lgSourcesTitle: "Da dove vengono i numeri",
		scAskAssistant: "Configura con l'assistente",
		scAskAssistantRead: "Chiedi all'assistente",
		scAssistantTitle: "Assistente · {model}",
		scAssistantDescription:
			"Chiedigli di configurare il modello: domini, scale, tabelle per categoria. Scrive solo su questo modello; pubblicare e togliere chiedono il tuo sì, e puoi annullare tutto.",
		scAssistantDescriptionRead:
			"Chiedigli come funziona questo modello o di confrontarlo con un altro: qui lo legge soltanto.",
		scCreateWithAssistant: "Crea con l'assistente",
		scSportAssistantTitle: "Assistente · {sport}",
		scSportAssistantDescription:
			"Chiedigli di creare il tuo modello per questo sport, anche partendo da quello di sistema. Nasce non pubblicato.",
		ppLevel: "Livello {score}",
		ppLevelOf: "su {max}",
		ppNextLevel: "{delta} al livello {score}{label} ({value})",
		ppTopLevel: "Livello più alto della scala",
		pmScoreLabels: "Nomi dei livelli",
		pmScoreLabelsHint: "Facoltativi: compaiono nel profilo accanto al numero (es. «6 · Élite nazionale»).",
		pmScoreLabelPlaceholder: "Nome",
		pmScoreLabelsSaved: "Nome del livello salvato",
		scBadgeClass: "Categoria {label}",
		scBadgeAddWeight: "Aggiungi il peso nel profilo per la tua categoria",
		scBadgeAddGender: "Indica il genere nel profilo per la tua categoria",
		scBadgeInfoClass:
			"In questo sport i livelli dipendono dalla categoria di peso: la ricaviamo dal peso che hai scritto nel profilo. Se il peso cambia, cambia anche la categoria.",
		scBadgeInfoSinclair:
			"Accanto ai chili vedi il Sinclair: il massimale rapportato al peso corporeo, per confrontarti con atleti di peso diverso.",
		scClassOf: "Categoria",
		scClassWeight: "peso {weight} kg",
		scClassNoClasses:
			"Lo sport non ha ancora categorie di peso: livelli sulla tabella del genere",
		scClassNoWeight:
			"Peso mancante nel profilo: livelli sulla tabella del genere",
		scClassNoGender: "Genere mancante nel profilo: nessuna categoria",
		scCompareClass: "Confronta con un'altra categoria",
		scCompareWith: "Confronta con {label}",
		wccTitle: "Confronto: {base} e {other}",
		wccHint:
			"Gli stessi massimali, letti sulle tabelle delle due categorie: utile per decidere dove far gareggiare l'atleta.",
		wccNoValues: "Nessun valore da confrontare.",
		wccValue: "Valore",
		wccGenderTable: "Tabella del genere",
		wccGenderTableShort: "(genere)",
		// Catalogo sport: sport dei coach, disattivazione, promozione (docs/sport-config, Fase 3)
		scGuideNewSport: "Uno sport che non c'è",
		scGuideNewSportBody:
			"Aggiungilo tu: lo vedrete tu, i coach del tuo team e i tuoi atleti, che potranno sceglierlo dal profilo. Se è utile a tutti, l'admin può renderlo disponibile a tutta la piattaforma.",
		scAddSport: "Aggiungi uno sport che non c'è",
		scManageSportsAdmin: "Gestisci le discipline",
		scAddSportTitle: "Aggiungi uno sport",
		scAddSportConfirm: "Aggiungi",
		scSportCreated: "«{label}» aggiunto agli sport che segui",
		scSportReactivated: "«{label}» è di nuovo attivo",
		scFollowExisting: "Segui «{label}»",
		scSportMineBadge: "tuo",
		scSportTeamBadge: "di {name}",
		scSportCreatedByYou: "Creato da te",
		scSportOfTeam: "Del tuo team",
		scPersonalSportHint:
			"È uno sport aggiunto da un coach: non ha un modello di sistema. Il modello con cui valutare i tuoi atleti lo costruisci tu.",
		scCreateOwnModel: "Crea il tuo modello",
		scCreatedTitle: "Gli sport che hai creato",
		scCreatedHint:
			"Li vedete tu, i coach del tuo team e i tuoi atleti. Puoi rinominarli e disattivarli; finché nessuno li usa puoi anche correggerne l'identificativo o cancellarli. L'admin può renderli disponibili a tutti.",
		scCreatedUsage:
			"{athletes} atleti lo praticano · {models} modelli dei coach",
		scIdentifier: "Identificativo",
		scIdentifierHint: "Diventerà: {value}",
		scDelete: "Cancella",
		scDeleteTitle: "Cancellare «{label}»?",
		scDeleteBody:
			"Nessuno lo usa: lo sport viene rimosso del tutto. Non si recupera.",
		scDeleted: "«{label}» cancellato",
		scSportActive: "Attivo",
		scSportInactive: "Disattivato",
		scRename: "Rinomina",
		scSportRenamed: "Nome aggiornato: «{label}»",
		sdfLabel: "Nome",
		sdfLabelPlaceholder: "Es: Arrampicata",
		sdfCoachHint:
			"Lo vedrete tu, i coach del tuo team e i tuoi atleti. È uno sport di preparazione fisica: quelli di tiro li crea l'admin.",
		sdfSlug: "Identificativo",
		sdfSlugHint:
			"Lo usano atleti, modelli e classifiche: dopo la creazione non si cambia più. Il nome sì.",
		sdfSlugLocked:
			"Non si cambia: ci puntano atleti, coach e modelli. Puoi rinominare il nome.",
		sdfFamilies: "Ambiti",
		sdfFamiliesHint:
			"Decidono quali sezioni vedono i coach e gli atleti di questo sport. Selezionane due per uno sport ibrido (tiro con preparazione fisica).",
		sdfFamilyPhysical: "Preparazione fisica",
		sdfFamilyShooting: "Tiro",
		sdfNoFamilies: "Nessun ambito: verrà trattato come preparazione fisica.",
		sdfOrder: "Ordine",
		sdDeactivate: "Disattiva",
		sdReactivate: "Riattiva",
		sdDeactivated: "«{label}» disattivato",
		sdReactivated: "«{label}» riattivato",
		sdDeactivateTitle: "Disattivare «{label}»?",
		sdUsageAthletes: "Atleti che lo praticano",
		sdUsageCoaches: "Coach che lo seguono",
		sdUsageModels: "Modelli prestativi dei coach",
		sdUsageUnavailable: "Non riesco a leggere chi lo usa in questo momento.",
		sdDeactivateKeeps:
			"Chi lo usa non perde niente: profilo, modelli e classifiche restano. Nessuno potrà più sceglierlo, e puoi riattivarlo quando vuoi.",
		sdConflictMine:
			"Hai già creato «{label}»: lo trovi fra gli sport che hai creato.",
		sdConflictTeam:
			"«{label}» l'ha già creato un collega del tuo team: puoi seguirlo.",
		sdConflictOther:
			"Questo sport l'ha già creato un altro coach. Chiedi all'admin di renderlo disponibile a tutti.",
		sdConflictGlobal: "«{label}» esiste già: puoi seguirlo.",
		sdConflictInactive:
			"Questo sport esiste ma è disattivato: chiedi all'admin di riattivarlo.",
		sdConflictLabel: "Esiste già uno sport che si chiama «{label}».",
		sdConflictGlobalAdmin: "Esiste già «{label}»: modificalo dalla lista.",
		sdConflictPersonal:
			"«{label}» è lo sport di {owner}: rendilo globale dalla lista invece di crearne un altro.",
		adminSportsTitle: "Discipline sportive",
		adminSportsHint:
			"Gli sport della piattaforma e quelli creati dai coach. Non si cancella niente: si disattiva, e chi lo usa non perde dati. L'identificativo si sceglie solo creando.",
		adminSportsFilterAll: "Tutte",
		adminSportsFilterPersonal: "Create dai coach",
		adminSportsFilterInactive: "Disattivate",
		adminSportsEmpty: "Nessuna disciplina in questo filtro",
		adminSportsGlobal: "Globale",
		adminSportsPersonalOf: "Di {owner}",
		adminSportsActive: "Attiva",
		adminSportsInactive: "Disattivata",
		adminSportsUsage: "{athletes} atleti · {coaches} coach · {models} modelli",
		adminSportsProposedBy: "Proposta da {owner}",
		adminSportsPromote: "Rendi globale",
		adminSportsConfirmPromote:
			"Rendere «{label}» disponibile a tutti? Lo vedranno tutti i coach e gli atleti; i dati di chi lo usa già restano com'erano.",
		adminSportsPromoted: "«{label}» ora è disponibile a tutti",
		adminSportsNewTitle: "Nuova disciplina",
		adminSportsEditTitle: "Modifica disciplina",
		adminSportsCancelEdit: "Annulla modifica",
		adminSportsClear: "Svuota campi",
		adminSportsEditingPersonal:
			"È uno sport creato da {owner}: lo stai modificando come admin, per supporto.",
		adminSportsSave: "Salva modifiche",
		adminSportsCreate: "Crea disciplina",
		adminSportsCreated: "Disciplina «{label}» creata",
		adminSportsUpdated: "Disciplina «{label}» aggiornata",
		openCompetitionCalendar: "Apri calendario agonistico",
		// Competition Hub (coach)
		competitionHub: "Calendario Gare",
		competitionHubSubtitle:
			"Vista d'insieme dei calendari agonistici di tutti i tuoi atleti",
		competitionHubScopeMine: "Miei",
		competitionHubScopeAll: "Tutti (admin)",
		competitionHubEventsCount: "Eventi",
		competitionHubSharedCount: "Gare condivise",
		competitionHubLoadError: "Errore caricamento calendario gare",
		competitionHubSearchPlaceholder: "Cerca gara, città o atleta...",
		competitionHubPeriodUpcoming: "Prossime",
		competitionHubPeriodNext30: "Prossimi 30 giorni",
		competitionHubPeriodNext90: "Prossimi 90 giorni",
		competitionHubPeriodPast: "Passate",
		competitionHubPeriodAll: "Tutte",
		competitionHubAllAthletes: "Tutti gli atleti",
		competitionHubAthletesSelected: "selezionati",
		competitionHubSharedOnly: "Solo condivise",
		competitionHubResetFilters: "Azzera filtri",
		competitionHubFilters: "Filtri",
		competitionHubFilterType: "Tipo evento",
		competitionHubFilterOther: "Altri filtri",
		competitionHubLegend: "Legenda",
		competitionHubLegendTypeTitle: "Tipo evento",
		competitionHubLegendTypeBody:
			"La natura della competizione: Gara (competizione ufficiale), Qualificazione, Open, Test (prova/simulazione) o Altro.",
		competitionHubLegendPriorityA:
			"Gara obiettivo: il picco di forma è costruito attorno a questa gara.",
		competitionHubLegendPriorityB:
			"Gara secondaria: importante ma non l'obiettivo principale della stagione.",
		competitionHubLegendPriorityC:
			"Gara di rodaggio: si gareggia in allenamento, senza scarico specifico.",
		competitionHubLegendStatusIntro:
			"Stato di iscrizione della gara, impostato quando crei o modifichi l'evento:",
		competitionHubLegendStatusPlanned: "in valutazione, ancora da decidere",
		competitionHubLegendStatusConfirmed:
			"l'atleta parteciperà, iscrizione da completare",
		competitionHubLegendStatusRegistered: "iscrizione effettuata",
		competitionHubLegendStatusDone: "gara disputata",
		competitionHubLegendStatusCancelled: "gara annullata o ritiro",
		competitionHubViewList: "Lista",
		competitionHubViewShared: "Eventi condivisi",
		competitionHubViewCalendar: "Calendario",
		competitionHubViewTimeline: "Timeline",
		competitionHubKpiNext30: "Prossimi 30 giorni",
		competitionHubKpiNextRace: "Prossima gara",
		competitionHubKpiShared: "Gare condivise",
		competitionHubKpiWithoutRace: "Atleti senza gare",
		competitionHubIn: "tra",
		competitionHubNone: "Nessuna",
		competitionHubPrevMonth: "Mese precedente",
		competitionHubNextMonth: "Mese successivo",
		competitionHubAllDisciplines: "Tutte le discipline",
		competitionHubAllStatus: "Tutti gli stati",
		competitionPriority: "Priorità",
		competitionPriorityA: "A — Obiettivo",
		competitionPriorityB: "B — Secondaria",
		competitionPriorityC: "C — Rodaggio",
		competitionStatus: "Stato",
		competitionStatusPlanned: "Pianificata",
		competitionStatusConfirmed: "Confermata",
		competitionStatusRegistered: "Iscritto",
		competitionStatusDone: "Conclusa",
		competitionStatusCancelled: "Annullata",
		competitionDiscipline: "Disciplina",
		competitionDisciplinePlaceholder: "Es. Braccio di ferro, Ultra trail",
		// Sport delle gare (docs/sport-config, D16)
		competitionSport: "Sport",
		competitionSportNone: "Nessuno sport",
		competitionSportOther: "Altro: non in elenco",
		competitionSportOtherHint:
			"Le gare di sport non in elenco restano col loro testo: si trovano nel filtro, ma non contano per uno sport.",
		competitionHubAllSports: "Tutti gli sport",
		competitionHubFreeText: "testo libero",
		competitionCategory: "Categoria",
		competitionCategoryPlaceholder: "Es. Rx, Scaled, Master, -73kg",
		competitionEndDate: "Data fine (multi-giorno)",
		competitionSuggestionsTitle:
			"Gare inserite da atleti del tuo sport o del tuo gruppo",
		competitionSuggestionsHint:
			"Il numero indica quanti atleti l'hanno inserita. Sono gli atleti dei tuoi coach che praticano il tuo sport, più i compagni dei tuoi gruppi di allenamento.",
		competitionOthersTitle: "Gare degli altri atleti",
		competitionOthersHint:
			"Cosa hanno in programma gli altri atleti dei tuoi coach, anche di altri sport o gruppi",
		competitionOthersEmpty:
			"Nessuna gara in programma per gli altri atleti dei tuoi coach.",
		competitionOthersError: "Impossibile caricare le gare degli altri atleti",
		competitionOthersAdd: "Aggiungi al mio calendario",
		competitionHubNewRace: "Nuova gara",
		competitionHubConflicts: "Conflitti di calendario (gare A ravvicinate)",
		competitionHubSelectAthletes: "Seleziona almeno un atleta",
		competitionHubAssignAthletes: "Assegna agli atleti",
		competitionHubEventsCreated: "Gare create",
		competitionHubAddAthletes: "Aggiungi atleti",
		competitionHubAddAthletesTitle: "Aggiungi atleti alla gara",
		competitionHubSelectAthletesToAdd: "Seleziona gli atleti da aggiungere",
		competitionHubAthletesAdded: "Atleti aggiunti alla gara",
		competitionHubAlreadyIn: "Già iscritto",
		competitionHubParticipants: "partecipanti",
		competitionParticipantsTitle: "Chi fa questa gara",
		competitionParticipantsOpen: "Vedi chi fa questa gara",
		competitionParticipantsYou: "Tu",
		competitionParticipantsEmpty:
			"Nessun altro atleta collegato ai tuoi coach risulta iscritto.",
		competitionParticipantsError: "Impossibile caricare i partecipanti",
		competitionHubExistingRace: "Gare già a calendario",
		competitionHubApplyToGroup:
			"Applica anche agli altri atleti di questa gara",
		competitionHubApplyToGroupHint:
			"Nome, date, luogo, tipo e disciplina vengono aggiornati per tutti. Priorità, categoria, stato, risultato e note restano personali.",
		competitionHubGroupUpdated: "Gara aggiornata per tutti i partecipanti",
		competitionHubDeleteConfirm: "Eliminare le gare selezionate?",
		competitionHubBulkDone: "Operazione completata",
		competitionHubSelected: "selezionate",
		competitionHubSetStatus: "Imposta stato",
		competitionHubClearSelection: "Deseleziona",
		competitionHubEmpty: "Nessuna gara trovata con i filtri attuali",
		competitionHubToday: "Oggi",
		competitionHubDaysShort: "g",
		eventType_gara: "Gara",
		eventType_qualificazione: "Qualificazione",
		eventType_open: "Open",
		eventType_test: "Test",
		eventType_altro: "Altro",
		openAthleteAgenda: "Apri agenda risultati",
		openAthleteDetail: "Apri dettaglio atleta",
		athleteDetailCta: "Dettaglio",
		athleteProgramsPreviewCta: "Programmi",
		viewModeGrid: "Vista griglia",
		viewModeList: "Vista elenco",
		athleteProgramsPreviewTitle: "Anteprima dashboard atleta",
		noAssignedProgramsPreview: "Nessun programma assegnato all'atleta",
		coachSandboxBadge: "Modalita' supporto coach",
		coachSandboxHint:
			"Stai operando per conto dell'atleta sui suoi dati reali: risultati e storico sono i suoi, e quello che inserisci o correggi viene salvato nel suo diario.",
		coachSandboxLoggedByCoach: "Inserito dal coach",
		coachSandboxEditedByCoach: "Corretto dal coach",
		coachSandboxResultSaved: "Risultato salvato per {name}",
		coachSandboxResultUpdated: "Risultato aggiornato per {name}",
		coachSandboxResultDeleted: "Risultato eliminato per {name}",
		athletePerformanceProfile: "Profilo prestativo atleta",
		athleteCompetitionCalendar: "Calendario agonistico atleta",
		athleteAgendaResults: "Agenda risultati atleta",
		noPerformanceProfileData: "Nessun dato disponibile nel profilo prestativo",
		noCompetitionEvents: "Nessun evento nel calendario agonistico",
		noAgendaResults: "Nessun risultato presente in agenda",
		manualEntry: "Inserimento manuale",
		autoFromResults: "Calcolato dai risultati",
		calculatedFrom: "Calcolato da",
		source1rmExact: "Test 1RM da agenda",
		source1rmEstimate: "Stima da test in agenda",
		sourceManualHigher: "Manuale (superiore alla stima)",
		sourceAutoHigher: "Risultato superiore al manuale",
		sourceAutoHigherEstimate: "Stima superiore al manuale",
		performanceHistoryTitle: "Storico esercizio",
		sessionDetailButton: "Dettaglio seduta",
		sessionDetailTitle: "Dettaglio seduta",
		sessionDetailLoadError: "Impossibile caricare il dettaglio della seduta",
		sessionDetailProfileValue: "Valore del profilo",
		sessionDetailNoPrescription:
			"Risultato non collegato a una giornata di programma",
		sessionDetailNoResult: "Nessun risultato registrato",
		sessionDetailExtraResults: "Risultati fuori prescrizione",
		performanceHistoryDescription:
			"Cronologia di risultati e inserimenti manuali per questo esercizio.",
		historyLoadError: "Impossibile caricare lo storico",
		historyEmpty: "Nessuno storico disponibile per questo esercizio",
		historyFilter30Days: "Ultimi 30 giorni",
		historyFilter6Months: "Ultimi 6 mesi",
		historyFilter1Year: "Ultimo anno",
		historyFilterAll: "Tutti",
		historyWeight: "Peso",
		historyEstimated1rm: "1RM stimato",
		historySourceDiary: "Agenda",
		historySourceManual: "Manuale",
		historyLegacyManual:
			"Valore manuale storico salvato prima del tracciamento completo",
		historyDeleteConfirm: "Eliminare questo risultato dallo storico?",
		historySharedResultWarning:
			"Questo risultato è condiviso con altri movimenti del complex/EMOM.",
		historySharedEditConfirm:
			"La modifica cambierà anche il risultato degli altri movimenti del complex/EMOM. Continuare?",
		historySharedDeleteConfirm:
			"L'eliminazione rimuoverà il risultato dell'intero complex/EMOM, anche dagli altri movimenti. Continuare?",
		historyEntryPartOf: "Fatto dentro",
		historyEntryUpdated: "Risultato storico aggiornato",
		historyEntryDeleted: "Risultato storico eliminato",
		historyInvalidValue: "Inserisci un valore valido per il risultato",
		resultDate: "Data risultato",
		viewSourceWorkout: "Vedi allenamento sorgente",
		sourceWorkoutTitle: "Allenamento sorgente (valore auto)",
		exerciseLabel: "Esercizio",
		prescriptionLabel: "Prescrizione",
		resultLabel: "Risultato",
		noFeedbackLabel: "Nessun feedback inserito",
		repsLabel: "Reps",
		timeLabel: "Tempo",
		profileLoadError: "Errore caricamento profilo prestativo",
		calendarLoadError: "Errore caricamento calendario agonistico",
		agendaLoadError: "Errore caricamento agenda risultati",
		noAthletesFound: "Nessun atleta trovato",
		tryDifferentSearch: "Prova con una ricerca diversa",
		athletesWillAppear: "Gli atleti appariranno qui quando si registreranno",

		// Groups
		groups: "Gruppi",
		newGroup: "Nuovo Gruppo",
		createGroup: "Crea Gruppo",
		addAthletes: "Aggiungi Atleti",
		noGroups: "Nessun gruppo",
		createGroupHint: "Crea gruppi per organizzare i tuoi atleti",

		// Exercises (extra)
		editExercise: "Modifica Esercizio",
		exerciseImage: "Immagine Esercizio",
		clickToUpload: "Clicca per caricare un'immagine",
		noExercisesFound: "Nessun esercizio trovato",
		startCreatingExercise: "Inizia creando il tuo primo esercizio",
		removeImage: "Rimuovi immagine",
		newConditioningCircuit: "Nuovo Circuito Conditioning",
		createCircuit: "Crea Circuito",
		editConditioningCircuit: "Modifica Circuito Conditioning",
		saveCircuitChanges: "Salva Modifiche Circuito",
		managePrograms: "Crea e gestisci i programmi di allenamento",
		manageExercisesDb: "Gestisci il database degli esercizi",
		exerciseLinksTitle: "Collegamenti attivi",
		exerciseLinksHint:
			"Se rinomini da libreria, il nome viene sincronizzato nei collegamenti sotto.",
		linkedPrograms: "Programmi collegati",
		linkedOccurrences: "riferimenti",
		linkedActiveProgramsLabel: "programmi attivi",
		showLinkedProgramDetails: "vedi",
		hideLinkedProgramDetails: "nascondi",
		noProgramLinks: "Nessun programma collegato",
		linkedPerformanceProfiles: "Profili prestativi collegati",
		noPerformanceProfileLinks: "Nessun collegamento nel profilo prestativo",
		notAvailable: "n/d",
		libraryScopeLabel: "Libreria",
		libraryScopeVisible: "Libreria visibile",
		libraryScopeMine: "Solo personali",
		libraryScopeGlobal: "Solo globali",
		libraryScopeAllAdmin: "Tutti (admin)",
		libraryScopeAll: "Tutti",
		dashboardMyPersonalLibrary: "La mia libreria personale",
		dashboardGlobalLibrary: "Libreria globale",
		dashboardSharedToGlobalLabel: "Condivisi in libreria globale",
		todayCardTitle: "Oggi",
		todayCardEmpty: "Oggi nessun programma ha un allenamento per i tuoi atleti.",
		todayCardGoToPrograms: "Vai ai programmi",
		todayCardError: "Non riesco a caricare gli allenamenti di oggi.",
		todayCardRetry: "Riprova",
		todayCardShowMore: "Mostra altri {count}",
		todayCardShowLess: "Mostra meno",
		todayCardShared: "Condiviso",
		todayCardUndated: "Senza date",
		todayCardUndatedHint: "Si apre dal primo giorno",
		todayCardDayFallback: "Allenamento di oggi",
		todayCardSessions: "{count} sedute",
		todayCardAthleteOne: "1 atleta",
		todayCardAthletes: "{count} atleti",
		todayCardGroupOne: "1 gruppo",
		todayCardGroups: "{count} gruppi",
		todayCardOpenHint: "Tocca un programma per vederlo come lo vedono gli atleti.",
		todayPreviewOpenProgram: "Apri programma",
		todayPreviewEmpty: "Il programma non ha settimane visibili agli atleti.",
		todayPreviewError: "Non riesco ad aprire il programma.",
		coachShowcaseTitle: "Vista atleta",
		coachShowcaseBadge: "Vista atleta · sola lettura",
		coachShowcaseHint:
			"Il programma come lo vedono gli atleti. Risultati, storico e carichi personali sono nella scheda di ogni atleta.",
		libraryScopePersonalPlural: "Personali",
		libraryScopeGlobalPlural: "Globali",
		libraryScopePersonal: "Personale",
		libraryScopeGlobalSingle: "Globale",
		ownerFilterLabel: "Filtro coach",
		allOwners: "Tutti i coach/admin",
		globalExerciseEditAdminOnly: "Solo admin puo modificare esercizi globali",
		globalExerciseDeleteAdminOnly: "Solo admin puo eliminare esercizi globali",
		globalTemplateEditAdminOnly: "Solo admin puo modificare template globali",
		globalTemplateDeleteAdminOnly: "Solo admin puo eliminare template globali",
		addExerciseToPersonalLibrary: "Aggiungi alla libreria personale",
		addConditioningToPersonalLibrary: "Aggiungi circuito personale",
		scopePersonalLabel: "Personale",
		scopeGlobalLabel: "Globale",
		conditioningLibraryTitle: "Conditioning Library",
		conditioningLibrarySubtitle: "Gestisci i circuiti e WOD preconfigurati",
		libraryExercisesLabel: "Libreria Esercizi",
		searchExercisePlaceholder: "Cerca esercizio...",
		addExerciseButton: "Aggiungi esercizio",
		selectedExerciseLabel: "Selezionato",
		addExerciseToDomainTitle: "Aggiungi Esercizio al Dominio",
		unitOfMeasure: "Unita di misura",
		sourceAll: "Tutti",
		sourceExercises: "Esercizi",
		searchExerciseOrConditioning: "Cerca esercizio o conditioning...",
		availableItemsSuffix: "elementi disponibili",
		filteredSuffix: "(filtrati)",
		noResultsForSelectedFilters: "Nessun risultato per i filtri selezionati",
		allExercisesAlreadyAddedToDomain:
			"Tutti gli esercizi sono gia stati aggiunti a questo dominio",

		// Workouts
		logWorkout: "Registra allenamento",
		addWorkout: "Aggiungi Allenamento",
		workoutData: "Dati Allenamento",
		strengthData: "Dati Forza",
		cardioData: "Dati Cardio",
		generalData: "Dati Generici",
		durationMin: "Durata (min)",
		distanceKm: "Distanza (km)",
		totalDurationMin: "Durata totale (min)",
		avgHR: "FC Media (bpm)",
		caloriesBurned: "Calorie bruciate",
		paceLabel: "Ritmo",
		totalVolumeLabel: "Volume totale",
		restDay: "Giorno libero",
		noWorkoutsToday: "Nessun allenamento per questa data",
		sessionFallbackTitle: "Sessione di allenamento",
		moreExercises: "altri esercizi",
		resultsLogged: "Risultati registrati",
		prevWeek: "Settimana precedente",
		nextWeek: "Settimana successiva",
		workoutAdded: "Allenamento aggiunto!",
		enterTitle: "Inserisci un titolo",
		running: "Corsa",
		cycling: "Ciclismo",
		add: "Aggiungi",
		workoutTitlePlaceholder: "es. Corsa mattutina, Sessione palestra...",
		workoutDescPlaceholder: "Descrivi il tuo allenamento...",
		notesWorkoutPlaceholder: "Come ti sei sentito? Qualcosa da ricordare?",
		every: "ogni",

		// Diary
		personalDiary: "Diario Personale",
		logPersonalWorkouts: "Registra i tuoi allenamenti personali",
		newWorkout: "Nuovo Allenamento",
		saveToDiary: "Salva nel Diario",
		latestWorkouts: "Ultimi Allenamenti",
		noDiary: "Nessun allenamento nel diario",
		howDidItGo: "Come ti sei sentito? Qualcosa da ricordare?",
		noWorkoutsDate: "Non hai registrato allenamenti per questa data",
		workoutAddedDiary: "Allenamento aggiunto al diario!",
		addManualResult: "Aggiungi risultato manuale",
		manualResultDialogTitle: "Aggiungi risultato manuale",
		manualResultLoadError: "Errore nel caricamento esercizi manuali",
		manualResultSelectExercise: "Seleziona un esercizio",
		manualResultInvalidValue: "Inserisci un risultato valido",
		manualResultFillAtLeastOne: "Compila almeno un campo risultato",
		manualResultFillBeforeSave: "Inserisci un risultato prima di salvare",
		manualResultAdded: "Risultato manuale aggiunto",
		manualResultSaving: "Salvataggio...",
		manualResultSave: "Salva risultato",
		manualResultSearchPlaceholder: "Cerca esercizio o template",
		manualResultNoExercisesFound: "Nessun esercizio trovato",
		manualResultFilterAll: "Tutti",
		manualResultFilterProfile: "Nel profilo",
		manualResultQuickPicks: "Scelta rapida",
		manualResultProfileUnit: "Unità profilo",
		manualResultType: "Tipo risultato",
		manualResultSelectTypePlaceholder: "Seleziona il tipo risultato",
		manualResultFreePlaceholder: "Es. 15 rounds + 12 reps",
		manualResultNotePlaceholder: "Nota opzionale sul risultato",
		manualResultKindSchema: "Schema risultato",
		manualResultKindForTime: "For Time",
		manualResultKindTimeOrReps: "Time or Reps",
		manualResultKindScore: "Score",
		manualResultKindFreeScore: "Score libero",
		manualResultKindFreeResult: "Risultato libero",
		manualResultKindWeightReps: "Peso + reps",
		manualResultKindWeight: "Solo peso",
		manualResultKindReps: "Ripetizioni",
		manualResultKindTime: "Tempo",
		programOrderLabel: "Ordina programmi",
		programOrderTitle: "Ordina programmi assegnati",
		programOrderDescription:
			"Scegli quale programma vedere per primo. L'ordine di settimane e giorni resta invariato.",
		moveUp: "Sposta su",
		moveDown: "Sposta giu",
		noResultsForDate: "Nessun risultato registrato per questa data",
		resultSourceManual: "Manuale",
		resultSourceAssigned: "Assegnato",
		deleteResultTitle: "Elimina risultato",
		deleteResultConfirm:
			"Sei sicuro di voler eliminare questo risultato? Questa azione non puo essere annullata.",
		deleteResultConfirmBtn: "Elimina risultato",
		resultDeleted: "Risultato eliminato",
		resultValueNotAvailable: "Valore non disponibile",
		diaryHistoryEmptyTitle: "Il tuo diario è vuoto",
		diaryHistoryEmptyText:
			"Qui trovi solo quello che hai fatto: i risultati registrati negli allenamenti e quelli inseriti a mano.",
		diaryHistoryNothingBefore: "Nessuna attività registrata prima di questa data.",
		diaryHistoryLoadMore: "Mostra giorni precedenti",
		diaryHistoryEnd: "Inizio del diario",
		diaryHistoryJumpToDate: "Vai a una data",
		diaryHistoryUntil: "Fino al",
		diaryHistoryBackToToday: "Torna a oggi",
		diaryHistoryManualGroup: "Inseriti a mano",
		diaryHistoryFreeEntries: "Note di allenamento",
		diaryHistoryProgramFallback: "Programma",
		diaryHistoryOpenWorkout: "Apri l'allenamento",
		diaryHistoryLoadError: "Impossibile caricare il diario",
		resultUpdated: "Risultato aggiornato",

		// Athlete Dashboard
		noActiveProgram: "Nessun programma attivo",
		contactCoach: "Non hai programmi assegnati. Consulta il tuo coach!",
		programNotYetPublishedTitle: "Programma assegnato, nessuna settimana visibile",
		programNotYetPublishedBody: "Il tuo coach ti ha assegnato un programma, ma al momento nessuna settimana è pubblicata per te. Appena la pubblica, la trovi qui.",
		programVisibleFrom: "Il tuo coach ti ha assegnato un programma: lo vedrai qui da",
		weekNotesLabel: "Note Settimana",
		dayNotesLabel: "Note del Giorno",
		selectSession: "Seleziona una sessione",
		chooseDay: "Scegli un giorno dalla lista sopra",
		noSessionsWeek: "Nessuna sessione questa settimana",
		noWeeksAvailable: "Nessuna settimana disponibile",
		weeksNotPublished: "Il coach non ha ancora pubblicato le settimane",
		emptyWeek: "Settimana vuota",
		noDaysWeek: "Nessun giorno configurato per questa settimana",
		sessionLabel: "Sessione",
		noExercisesInSession: "Nessun esercizio in questa sessione",
		unassignedExercisesLabel: "Extra",
		complexMethodLabel: "Complex",
		coachNotes: "Note Coach",
		programLabel: "Programma",
		weekShort: "Sett.",
		exerciseCountLabel: "esercizi",
		intervalsLabel: "intervalli",
		setsShort: "serie",
		repsShort: "reps",
		swimLabel: "Nuoto",
		bikeLabel: "Ciclismo",
		timeCapLabel: "Time Cap",
		timeOrRepsLabel: "Time or Reps",
		timeOrRepsPlaceholder: "mm:ss oppure reps totali",
		timeOrRepsTimecapBadge: "TIMECAP",
		timeOrRepsHintTime: "Inserisci il tempo (mm:ss) se hai completato il WOD",
		timeOrRepsHintReps:
			"Oppure inserisci le reps totali raggiunte se non hai concluso in tempo",
		roundLabel: "round",
		roundsLabel: "rounds",
		hiitWorkLabel: "Lavoro",
		hiitRecoveryLabel: "Recupero",
		hiitRatioLabel: "Lavoro/Recupero",
		mediaLabel: "Media",
		setLabel: "Set",
		restLabel: "Rest",
		jogLabel: "(corsa)",
		blockLabel: "blocco",
		indoorLabel: "Indoor",
		outdoorLabel: "Outdoor",
		mixedLabel: "Misto",
		weightKgLabel: "Peso (kg)",
		generalRpeLabel: "RPE Generale",
		rpePlaceholder: "RPE",
		rirPlaceholder: "RIR",
		rpeInfoOpenAria: "Apri spiegazione RPE",
		rpeInfoTitle: "Che cos'e RPE?",
		rpeInfoDescription:
			"RPE (Rate of Perceived Exertion) indica quanto la serie ti e sembrata difficile.",
		rpeInfoEasy: "molto facile",
		rpeInfoHard: "duro ma controllato",
		rpeInfoMax: "massimale (0 reps in riserva)",
		exerciseNoteLabel: "Nota Esercizio",
		exerciseNotePlaceholder: "Descrivi come hai eseguito l'esercizio...",
		repeatShortLabel: "reps",
		editResultTitle: "Modifica Risultato",
		logResultTitle: "Registra Risultato",
		freeScoreLabel: "Score libero",
		emomScorePlaceholder: "Es: completato 8/10 round, tecnicamente pulito",
		repeatScoresLabel: "Ripetute",
		repeatResultPlaceholder: "es. 1:32 / 4:05/km",
		cardioRepeatResultPlaceholder: "es. 1:42 / 2:05/500m / 250m",
		cardioRepeatResultHint:
			"Inserisci il tempo o la distanza per ogni ripetuta.",
		customRunningResultLabel: "Risultato",
		customRunningResultPlaceholder: "es. 10km in 50min, come è andata...",
		segmentScoresLabel: "Tratti",
		segmentResultPlaceholder: "es. 25:00 / 3.66 km / 6:50/km",
		runningTotalsLabel: "Totale uscita",
		runningTotalsHint:
			"Tempo e distanza di tutta la corsa, parziali compresi. Lascia vuoto ciò che non hai.",
		avgHeartRateLabel: "FC media",
		maxHeartRateLabel: "FC max",
		minShort: "Min",
		secShort: "Sec",
		distanceMetersLabel: "Distanza (m)",
		distanceKmLabel: "Distanza (km)",
		completedRepsLabel: "Reps completate",
		amrapTotalRepsPlaceholder: "Es: 120 (somma totale reps)",
		amrapTotalRepsHint: "Inserisci il totale reps, non il numero di rounds",
		scoreLabel: "Score",
		emomRoundsPlaceholder: "Es: completati 7 round + 5 reps",
		notesResultPlaceholder: "Come è andata?",
		scalingLabel: "Scalature",
		scalingPlaceholder: "Scalature (opz., vuoto = RX)",
		scalingRxLabel: "RX",
		scalingScaledLabel: "SCALED",
		insertResultLabel: "Inserisci Risultato",
		viewLeaderboardLabel: "Vedi Classifica",
		youLabel: "Tu",
		leaderboardEmptyLabel: "Nessun risultato pubblico per questo esercizio",
		leaderboardLoadError: "Impossibile caricare la classifica",
		cancelEditLabel: "Chiudi",
		saveResultLabel: "Salva Risultato",
		updateResultLabel: "Aggiorna Risultato",
		resultLoggedChip: "Registrato",
		resultDraftChip: "Bozza",
		resumeDraftLabel: "Riprendi la bozza",
		actionResumeDraftShort: "Riprendi",
		resultDraftKeptToast:
			"Non salvato: i valori restano sull'esercizio come bozza. Riaprila con «Riprendi».",
		dayResultsProgress: "{done} di {total} registrati",
		resultRecordedLabel: "Risultato Registrato",
		everyLabel: "Ogni",
		customWodLabel: "WOD Custom",
		distanceLabel: "Distanza",
		watchVideo: "Guarda Video",
		viewGuide: "Vedi Guida",
		paceShort: "Passo",
		equipment: "Attrezzatura",
		targetPower: "Target potenza",
		targetCadence: "Target cadenza",
		loadLabel: "Carico",
		exerciseUpdated: "Esercizio aggiornato",
		exerciseCreatedSuccess: "Esercizio creato con successo",
		exerciseDeleted: "Esercizio eliminato",
		exerciseAddedToLibrary: "aggiunto alla libreria!",
		updateError: "Errore nell'aggiornamento",
		createError: "Errore nella creazione",
		uploadError: "Errore upload",
		circuitName: "Nome circuito",
		wodDescription: "Descrizione WOD",
		exercisesInWod: "Esercizi nel WOD",
		exerciseName: "Nome Esercizio",
		exerciseNamePlaceholder: "Nome dell'esercizio",
		exerciseDescriptionPlaceholder: "Descrizione dell'esercizio...",
		exerciseTechniquePlaceholder: "Descrizione dell'esercizio e tecnica...",
		searchExercise: "Cerca esercizio...",
		searchExercises: "Cerca esercizi...",
		saveProfile: "Salva Profilo",
		savingLabel: "Salvataggio...",
		newEvent: "Nuovo Evento",
		editEvent: "Modifica Evento",
		locationLabel: "Località",
		addEvent: "Aggiungi Evento",
		performanceProfilePending:
			"Il tuo profilo prestativo verrà configurato dal coach",
		programTitleRequired: "Il titolo del programma è obbligatorio!",
		programSaved: "Programma salvato!",
		saveError: "Errore nel salvataggio",
		intervalDurationRequired: "Inserisci la durata dell'intervallo",
		noNextWeek: "Non esiste una settimana successiva",
		noDaysNextWeek: "La settimana successiva non ha giorni",
		publishWeekAuto: "La settimana verrà pubblicata automaticamente alla data scelta",
		programAutoDisableLabel: "Disattivazione automatica",
		programAutoDisableHint:
			"Ogni settimana si nasconde da sola dal lunedì dopo la sua domenica. Spegnila per tenere tutto visibile finché non scegli tu una data.",
		pbCalendarRulesTitle: "Settimane e calendario",
		programAutoPublishLabel: "Pubblicazione automatica",
		programAutoPublishHint:
			"Ogni settimana compare agli atleti da sola, in base alle date dei suoi giorni. Una settimana senza giorni datati resta non visibile finché non la pubblichi tu.",
		programAutoPublishUndated: "Solo per i programmi datati: qui le settimane le pubblichi tu.",
		programAutoPublishLeadLabel: "Compare",
		programAutoPublishLead1: "la domenica prima",
		programAutoPublishLead0: "il lunedì della settimana",
		programAutoPublishLead2: "il sabato prima",
		programCalendarBothHint:
			"Con entrambe attive gli atleti vedono solo la settimana in corso, e la prossima dalla domenica sera.",
		weekDisableAutoHint:
			"Scegli l'ultimo giorno in cui gli atleti la vedono: dal giorno dopo non la vedono più. Senza una scelta resta visibile fino alla domenica che chiude la settimana.",
		weekDisableManualHint:
			"La disattivazione automatica è spenta per questo programma (vedi Dettagli). Scegli l'ultimo giorno in cui la vedono solo se vuoi nascondere questa settimana.",
		weekDisableAutoReset: "Ripristina data automatica",
		weekKeepVisibleHint:
			"Riattivata a mano: non si disattiva più da sola. Scegli una data se vuoi nasconderla, o ripristina quella automatica.",
		weekGuidancePlaceholder:
			"Indicazioni generali della settimana (focus, obiettivi, volume, recovery...)",
		newDay: "Nuovo Giorno",
		workoutDescription: "Descrizione allenamento",
		intensity: "Intensità",
		speedPace: "Velocità/Passo",
		currentExerciseLoadReference: "Esercizio corrente",
		athleteBodyweightReference: "Peso corporeo atleta",
		loadReferenceExercise: "Percentuale riferita a",
		loadReferenceSummary: "Basata su",
		complexLoadReferenceMissing:
			"Scegli su quale massimale calcolare la %: un complex non ha un massimale suo",
		complexLoadReferenceLabel: "% sul massimale di",
		complexLoadReferenceOther: "Altro esercizio…",
		complexLoadReferenceRequired:
			"Il complex ha una % senza riferimento: scegli su quale massimale calcolarla",
		complexLoadReferenceToSet: "Riferimento da scegliere",
		loadMissingMaxInProfile: "Massimale non presente nel profilo",
		allowResultEntry: "Inserimento risultato atleta",
		resultEntryEnabledHint: "L'atleta puo inserire il punteggio",
		resultEntryDisabledHint: "Esercizio in sola lettura (niente punteggio)",
		resultEntryOpen: "Attivo",
		resultEntryLocked: "Sola lettura",
		leaderboardEnabledHint: "L'esercizio compare nella leaderboard del gruppo",
		leaderboardDisabledHint: "Leaderboard nascosta per questo esercizio",
		leaderboardVisible: "Visibile",
		leaderboardHidden: "Nascosta",
		resultEntryBlocked: "Punteggio non richiesto per questo esercizio",
		resultAlreadyLogged: "Punteggio inserito",
		orCreateManually: "Oppure crea manualmente",
		supersetExercises: "Esercizi nel superset",
		addFirstDayWeek: "Aggiungi il primo giorno alla settimana",
		profileUpdated: "Profilo aggiornato",
		eventAdded: "Evento aggiunto",
		eventDeleted: "Evento eliminato",
		eventUpdated: "Evento aggiornato",
		enterValidNumeric: "Inserisci un valore numerico valido",
		valueSaved: "Valore salvato",
		manualValueRemoved: "Valore manuale rimosso",
		performancePublicLabel: "Performance pubblica",
		performancePublicDescription:
			"Rendi visibili le tue performance agli atleti del tuo stesso sport e abilita le leaderboard del profilo prestativo.",
		resultsPublicLabel: "Risultati pubblici",
		resultsPublicDescription:
			"Rendi i tuoi risultati allenamento visibili nella leaderboard degli esercizi di gruppo.",
		performancePublicLeaderboardHint:
			"Attiva Performance pubblica nel tab Profilo per usare la leaderboard del profilo prestativo.",
		performanceLeaderboardTitle: "Leaderboard profilo prestativo",
		performanceLeaderboardSportScope: "Tutti nello sport",
		performanceLeaderboardEmpty:
			"Nessun atleta pubblico con risultato disponibile per questo esercizio.",
		performanceLeaderboardLoadError:
			"Impossibile caricare la leaderboard del profilo prestativo",
		leaderboardGenderAll: "Tutti",
		bodyweightShort: "BW",
		bodyweightRatioShort: "x BW",
		performanceGeneralTab: "Generale",
		performanceRadarTitle: "Radar",
		performanceRadarMissingConfig:
			"Configura almeno 3 esercizi con valori scala per vedere il radar.",
		profileUnsavedChangesWarning:
			"Hai modifiche non salvate nel profilo. Vuoi uscire senza salvare?",
		updatedOnLabel: "Ultima modifica",

		// Athlete Detail / Mesocycles
		mesocyclePlanning: "Pianificazione",
		resultsAnalysis: "Risultati",
		athleteInfo: "Anagrafica",
		performanceProfile: "Profilo Prestativo",
		mesocycles: "Mesocicli",
		addMesocycle: "Aggiungi Mesociclo",
		// Vista atleta sola lettura del piano di preparazione
		preparationPlan: "Piano di preparazione",
		mesocycleInProgress: "In corso",
		mesocycleUpcoming: "In arrivo",
		mesocycleCompleted: "Concluso",
		mesocycleStartsIn: "Inizia tra",
		editMesocycle: "Modifica Mesociclo",
		mesocycleCreated: "Mesociclo creato",
		mesocycleUpdated: "Mesociclo aggiornato",
		mesocycleDeleted: "Mesociclo eliminato",
		mesocycleInvalidDates:
			"La data di fine deve essere successiva alla data di inizio",
		mesocycleNamePlaceholder: "es. Preparazione Generale",
		mesocycleDescPlaceholder: "Obiettivi e note del mesociclo...",
		startDate: "Data Inizio",
		endDate: "Data Fine",
		color: "Colore",
		athleteNotFound: "Atleta non trovato",
		personalInfo: "Informazioni Personali",
		recentResults: "Risultati Recenti",
		athleteCompetitions: "Calendario Gare",
		noEventsThisDay: "Nessun evento",
		monthsVisible: "Mesi visibili",
		monthSingular: "mese",
		monthsPlural: "mesi",
		weeksVisible: "Settimane visibili",
		weekSingular: "settimana",
		weeksPlural: "settimane",
		coachAddCompetitionEvent: "Forza Evento Gara",
		coachCompetitionInsertHint:
			"Puoi forzare un evento con il pulsante evento nella pianificazione",
		competitionTypePlaceholder: "gara, test, open...",
		noResultsLoadedShort: "Non caricato",
		mesocycleDragHint:
			"Trascina sui giorni del calendario per creare un mesociclo, oppure clicca un mesociclo per modificarlo",
		selectedRangeLabel: "Selezione",
		mesocycleSelectionActive: "Selezione mesociclo:",
		dateOfBirth: "Data di Nascita",
		height: "Altezza",
		weight: "Peso",
		assignedPrograms: "Programmi Assegnati",
		programActiveShort: "Attivo",
		programInactiveShort: "Nessun attivo",
		programActiveStatus: "Attivo",
		programArchivedStatus: "Archiviato",
		programWeeksShort: "sett.",
		autoDetected: "Auto-rilevato",
		manual: "Manuale",

		// Mobile
		installApp: "Installa App",
		offlineReady: "Disponibile offline",
		installPromptTitle: "Installa Kraveon",
		installPromptSubtitle:
			"Aggiungi l'app alla schermata Home per accesso rapido e esperienza full-screen.",
		installPromptIosStep1: "Tocca Condividi nel browser",
		installPromptIosStep2: "Seleziona Aggiungi a schermata Home",
		installPromptAndroidFallback:
			"Se non appare il popup, apri il menu del browser e scegli Installa app o Aggiungi a schermata Home.",
		installPromptLater: "Più tardi",

		// Aggiornamento dell'app aperta (lib/appVersion.js)
		appUpdateTitle: "È pronta una nuova versione di Kraveon",
		appUpdateBody: "Aggiorna per avere le ultime novità e correzioni.",
		appUpdateAction: "Aggiorna",

		// Assegnazioni (tab Profilo)
		assignmentsTab: "Gruppi",
		assignmentsTabShort: "Gruppi",
		myCoachesTitle: "Coach assegnati",
		noCoachesAssigned: "Nessun coach assegnato",
		trainingGroupsTitle: "Gruppi di allenamento",
		noTrainingGroupsAssigned: "Non sei inserito in gruppi di allenamento",
		viewGroupDetails: "Dettagli",
		groupDetailsTitle: "Dettaglio gruppo",
		leaveTrainingGroupAction: "Esci dal gruppo",
		leaveTrainingGroupConfirm: "Vuoi uscire da questo gruppo di allenamento?",
		leftTrainingGroupSuccess: "Sei uscito dal gruppo di allenamento",
		leaveTrainingGroupError: "Impossibile uscire dal gruppo",
		activeProgramsTitle: "Programmi attivi",
		noActiveProgramsInGroup: "Nessun programma attivo per questo gruppo",
		teammatesTitle: "Compagni di allenamento",
		noTeammatesInGroup: "Nessun compagno di allenamento nel gruppo",
		activeProgramsCountLabel: "programmi",
		teammatesCountLabel: "compagni",
		// Program Builder - exercise/discipline option labels
		ergTypeRowerg: "RowErg",
		ergTypeBikeerg: "BikeErg",
		ergTypeSkierg: "SkiErg",
		ergTypeAssaultBike: "AssaultBike",
		ergTypeMixedErg: "Misto",
		ergTypeCustom: "Personalizzato",
		ergTypeBenchmark: "Benchmark",
		exTypeStrength: "Forza",
		exTypeRunning: "Running",
		exTypeSwim: "Swim",
		exTypeBike: "Bike",
		exTypeErg: "Erg",
		exTypeConditioning: "Conditioning",
		exTypeDryFire: "Dry Fire",
		exTypeLiveFire: "Live Fire",
		shootTargetIpsc: "Sagoma IPSC",
		shootTargetMiniIpsc: "Mini IPSC",
		shootTargetIdpa: "Sagoma IDPA",
		shootTargetNoShoot: "No-shoot IPSC",
		shootTargetNoShootIdpa: "No-shoot IDPA",
		shootTargetBobber: "Bobber",
		shootTargetPopper: "Popper",
		shootTargetMiniPopper: "Mini popper",
		shootTargetPopperLarge: "Popper grande",
		shootTargetPlate: "Piatto tondo",
		shootTargetPlateLarge: "Piatto grande",
		shootTargetCustom: "Altro",
		shootFocusDraw: "Estrazione",
		shootFocusTransitions: "Transizioni",
		shootFocusReload: "Ricarica",
		shootFocusMovement: "Movimento",
		shootFocusAccuracy: "Precisione",
		shootFocusStage: "Sequenza / stage",
		shootFocusManipulation: "Maneggio",
		runTypeLungo: "Lungo",
		runTypeProgressivo: "Progressivo",
		runTypeRipetute: "Ripetute",
		runTypeFartlek: "Fartlek",
		runTypeSalite: "Salite",
		runTypeBenchmark: "Benchmark",
		runTypeCustom: "Personalizzato",
		swimTypeIntervals: "Serie",
		swimTypeEndurance: "Aerobica",
		swimTypeTechnique: "Tecnica",
		swimTypeDrill: "Esercitazioni",
		swimTypeThreshold: "Soglia",
		swimTypeSprint: "Sprint",
		swimTypeMixed: "Completo",
		swimTypeRecovery: "Recupero",
		swimTypeBenchmark: "Benchmark",
		swimTypeCustom: "Personalizzato",
		swimStrokeStileLibero: "Stile Libero",
		swimStrokeDorso: "Dorso",
		swimStrokeRana: "Rana",
		swimStrokeDelfino: "Delfino",
		swimStrokeMisto: "Misto",
		swimGearPullbuoy: "Pullbuoy",
		swimGearPalette: "Palette",
		swimGearPinne: "Pinne",
		swimGearTavoletta: "Tavoletta",
		swimGearSnorkel: "Snorkel",
		swimGearElastico: "Elastico",
		bikeTypeEndurance: "Fondo",
		bikeTypeTempo: "Tempo",
		bikeTypeThreshold: "Soglia (FTP)",
		bikeTypeIntervals: "Intervalli",
		bikeTypeVo2max: "VO2max",
		bikeTypeHillRepeats: "Salite",
		bikeTypeSprint: "Sprint",
		bikeTypeRecovery: "Recupero",
		bikeTypeBenchmark: "Benchmark",
		bikeTypeCustom: "Personalizzato",
		// Program Builder - discipline forms (shared)
		pbSelectBenchmark: "Seleziona Benchmark",
		pbReferenceBenchmark: "Benchmark di riferimento",
		pbPaceReference: "Riferimento Passo",
		pbPacePercent: "% del passo",
		pbPaceRefAt: "Al",
		pbPaceRefOfPace: "% del passo di",
		pbExtraNotesPlaceholder: "Note aggiuntive...",
		pbTargetTime: "Tempo target",
		pbEg85: "Es: 85",
		pbNoBenchmarkSwim:
			"Nessun benchmark configurato per il nuoto. Configurali dal pannello Admin.",
		pbNoBenchmarkRunning:
			"Nessun benchmark configurato per il running. Configurali dal pannello Admin.",
		pbNoBenchmarkRunningShort: "Nessun benchmark running disponibile",
		pbSwimTypeLabel: "Tipo di nuoto",
		pbSwimStrokeLabel: "Stile",
		pbSwimGearLabel: "Attrezzi",
		pbSwimPacePer100: "Passo/100m",
		pbSwimWarmupPlaceholder: "Es: 400m misto, 200m gambe...",
		pbSwimCooldownPlaceholder: "Es: 200m defaticamento misto...",
		pbSwimFreePlaceholder: "Descrivi liberamente l'allenamento di nuoto...",
		pbSwimGearSetPlaceholder: "palette, pinne...",
		pbSwimGearSessionPlaceholder: "tavoletta, pinne, pullbuoy...",
		// Program Builder - running form
		pbRunTypeLabel: "Tipo di corsa",
		pbRunWarmupPlaceholder: "Es: 15' corsa lenta, 2km easy...",
		pbRunCooldownPlaceholder: "Es: 10' corsa lenta, stretching...",
		pbRunFreePlaceholder: "Descrivi liberamente l'allenamento di corsa...",
		pbPaceTarget: "Passo target",
		pbBenchmarkModifier: "Modificatore benchmark",
		pbBenchmarkModifierPlaceholder: "Es: 85% | +10s | -15s",
		pbRestType: "Tipo Rest",
		pbBlockReps: "Ripetizioni blocco",
		pbTimes: "volte",
		pbSegments: "Segmenti",
		pbSegment: "Segmento",
		pbProgressiveSegments: "Segmenti progressivi",
		pbDurationOrDistance: "Durata / Distanza",
		pbTotalDistance: "Distanza totale",
		pbAiWand: "Bacchetta AI",
		pbAiParsing: "Parsing...",
		// Program Builder - bike/erg form
		pbTypologyLabel: "Tipologia",
		pbErgMode: "Modalita",
		pbErgMixedConfig: "Configurazione Misto",
		pbErgModeEndurance: "Fondo",
		pbErgModeConditioning: "Ripetute",
		pbBikeWarmupPlaceholder: "Es: 20' Z1-Z2 progressivo...",
		pbBikeCooldownPlaceholder: "Es: 15' Z1 defaticamento...",
		pbErgFreePlaceholder:
			"Descrivi liberamente l'allenamento agli ergometri...",
		pbBikeFreePlaceholder: "Descrivi liberamente l'allenamento in bici...",
		pbCadence: "Cadenza",
		pbPower: "Potenza",
		// Program Builder - shooting form
		pbShootFirearmHandgun: "Pistola",
		pbShootFirearmRifle: "Carabina",
		pbShootFirearmShotgun: "Fucile",
		pbShootFirearmPcc: "PCC",
		pbShootFormatStructured: "Strutturato",
		pbShootFormatStructuredHint: "misurabile",
		pbShootFormatFree: "Libero",
		pbShootFormatFreeHint: "descritto a parole",
		pbShootFreeTitlePlaceholder: "Es: Messa a fuoco sulle mire",
		pbShootWhatToDo: "Cosa fare",
		pbShootWhatToDoPlaceholder:
			"Traguarda le mire e concentrati sulla messa a fuoco, alternando fuoco sulla tacca e sul bersaglio.",
		pbShootFirearm: "Arma",
		pbShootFirearmUnset: "Non specificata",
		pbShootFirearmUnsetLong: "Arma: non specificata",
		pbShootFocus: "Focus",
		pbShootFocusUnset: "Focus: non specificato",
		pbShootPickFromLibrary: "Riprendi un drill dalla libreria",
		pbShootDrillSection: "Il drill",
		pbShootHowMuch: "Quanto",
		pbShootHowMuchHint: "Ripetizioni e tempo massimo per ciascuna.",
		pbShootParTime: "Par time (s)",
		pbShootSeries: "Serie",
		pbShootExpectedShots: "Colpi previsti",
		pbShootStageSection: "Stage",
		pbShootStageHint:
			"La distanza sta sul bersaglio: un drill a tre sagome a 5, 10 e 15 metri non ha una distanza sola.",
		pbShootTarget: "Bersaglio",
		pbShootNoTarget: "Nessun bersaglio indicato.",
		pbShootStageMap: "Piantina dello stage",
		pbShootCloseDrawing: "Chiudi il disegno",
		pbShootDrawStage: "Disegna lo stage",
		pbShootUploadImage: "Carica immagine",
		pbShootHowJudged: "Come si giudica",
		pbShootHowJudgedHint:
			"Il sistema di punteggio decide le zone che l'atleta compilerà e come si calcola il risultato.",
		pbShootScoringSystem: "Sistema di punteggio",
		pbShootNoScoringWarning:
			"Senza sistema di punteggio l'atleta non può registrare un risultato a fuoco.",
		pbShootSuccessCriteriaLive: "Criterio di riuscita — es: HF > 5.0 con 90% A",
		pbShootSuccessCriteriaDry: "Criterio di riuscita — 80% dentro il par time",
		pbShootOtherDetails: "Altri dettagli",
		pbShootStartPosition:
			"Posizione di partenza — arma in fondina, mani sopra le spalle",
		pbShootSetupNotes: "Note sul setup — coperture, attivatori, angoli",
		pbShootStageSector:
			"Settore dello stage — se usi l'allestimento della giornata",
		// ── Tiro: condizioni di partenza, obiettivi, serie (FITDS 8.1-8.2) ──
		// ── Libreria riscaldamenti ──
		pbWarmupFromLibrary: "Libreria",
		pbWarmupSaveToLibrary: "Salva questo riscaldamento in libreria",
		pbWarmupSavePrompt: "Come lo chiami?",
		pbWarmupSaved: "Riscaldamento salvato in libreria",
		pbShootStartSection: "Condizioni di partenza",
		pbShootStartSectionHint:
			"Com'\u00e8 l'arma e com'\u00e8 il tiratore al segnale di start",
		pbShootStartFirearm: "Condizione di partenza dell'arma",
		pbShootStartFirearmHint: "Regola 8.1 — com'è l'arma al segnale di start",
		pbShootStartShooter: "Condizione di partenza del tiratore",
		pbShootStartShooterHint:
			"Regola 8.2 — la posizione; il default è eretto, braccia lungo i fianchi",
		pbShootGoalSection: "Obiettivo e registrazione",
		pbShootAthleteGoal: "Obiettivo per l'atleta",
		pbShootAthleteGoalHint: "Cosa deve ottenere. Lo vede nel diario.",
		pbShootScoringInstructions: "Cosa deve registrare",
		pbShootScoringInstructionsHint:
			"Se il punteggio va preso in un modo particolare, dillo qui.",
		pbShootScoringInstructionsPlaceholder:
			"Es: segna solo lo split fra i due colpi",
		pbShootCoachNotes: "Note tecniche del coach",
		pbShootCoachNotesHint: "Per te e per chi legge il programma.",
		pbShootCoachNotesPlaceholder: "Errori tipici, su cosa insistere",
		pbShootAthleteNotesHint: "Il messaggio per l'atleta su questa giornata.",
		pbShootSetupNotesHint:
			"Quello che la lista dei bersagli non dice: angoli, coperture, attivatori.",
		pbShootStageSectorHint:
			"Quale porzione dell'allestimento usa questo drill.",
		pbShootSeriesSection: "Serie previste",
		pbShootSeriesHint:
			"Una serie è una ripetizione dell'esercizio. Definiscile per avere un punteggio per distanza.",
		pbShootSeries: "Serie",
		pbShootNoSeries:
			"Nessuna serie definita: l'atleta ne aggiunge quante ne spara.",
		pbShootSeriesLabelPlaceholder: "Facoltativa — es: in ginocchio",
		pbShootTargets: "Bersagli",
		pbShootFromLibrary: "Drill di libreria",
		pbShootFromLibraryHint: "Configurato nella libreria: qui si consulta.",
		pbShootViewStage: "Apri la piantina",
		pbShootUnlink: "Scollega",
		pbShootUnlinkHint:
			"Scollega dal drill per poter modificare bersagli e piantina qui",
		pbShootAthleteNotes: "Note per l'atleta",
		pbShootAthleteWillSee: "L'atleta vedrà",
		pbShootToFill: "da compilare",
		pbShootUploadFailed: "Caricamento fallito",
		pbShootStandardSuffix: "standard",
		// Program Builder - shooting form (live fire hint)
		pbShootHowMuchHintLive: "Serie da sparare e munizioni da portare.",
		// ── Tiro: seconda sessione di test (docs/shooting/15) ──
		pbUnsavedLeaveConfirm:
			"Hai modifiche non salvate. Vuoi uscire senza salvare?",
		pbShootLibraryPickerTitle: "Riprendi un drill dalla libreria",
		pbShootLibraryPickerHint:
			"Bersagli, piantina e punteggio arrivano già configurati.",
		pbShootLibraryCount: "drill in libreria",
		pbShootLibraryEmptyHint:
			"Nessun drill in libreria: creane uno dalla Libreria drill e lo ritroverai qui.",
		pbShootDrillName: "Nome del drill",
		pbShootDiscipline: "Disciplina",
		pbShootAllDisciplines: "Tutte",
		pbShootVideo: "Video dimostrativo",
		pbShootVideoPlaceholder: "Link YouTube o video",
		pbShootDescription: "Descrizione",
		pbShootDescriptionPlaceholder:
			"Come si esegue, su cosa concentrarsi, errori tipici.",
		pbShootBenchmark: "Drill di riferimento per il profilo prestativo",
		pbShootSeriesCount: "Quante serie",
		pbShootSeriesCountHint:
			"Una serie è una ripetizione dell'esercizio, con il suo punteggio.",
		pbShootSeriesDetail: "Dettaglio per serie",
		pbShootSeriesDetailHint:
			"Solo se qualcosa cambia da una serie all'altra — tipicamente la distanza (5, 10, 15 m). Su uno stage con il box di partenza non serve.",
		pbShootSeriesDistance: "Distanza",
		pbShootSeriesLabel: "Etichetta",
		pbShootRoundsPerSeries: "Colpi per serie",
		pbShootRoundsPerSeriesHint:
			"I colpi di una serie. Con i bersagli in piantina si contano da soli.",
		pbShootRoundsFromTargets: "dai bersagli",
		pbShootRoundsTotal: "Munizioni da portare",
		pbShootRoundsMismatch:
			"Hai scritto {declared} colpi, ma i bersagli ne contano {fromTargets}: il tiratore potrà registrarne solo {fromTargets}.",
		pbShootRoundsApply: "Imposta {declared} colpi sui bersagli",
		pbShootRoundsApplyManual:
			"Imposta i colpi bersaglio per bersaglio nella colonna «Colpi».",
		pbShootRoundsApplied: "Colpi aggiornati sui bersagli",
		pbShootTargetTableHint:
			"La tabella è ciò che il tiratore compila: una riga di punteggio per ogni T. Puoi scriverla a mano o farla produrre dal disegno.",
		pbShootColQty: "Qta",
		pbShootColTarget: "Bersaglio",
		pbShootColDistance: "Distanza",
		pbShootColHits: "Colpi",
		pbShootColHitsHint:
			"Colpi che contano su quel bersaglio. Vuoto = regolamento (carta 2, metallo 1).",
		pbShootAttachments: "Altri file",
		pbShootAttachmentsHint:
			"La foto del bersaglio, un dettaglio dello stage: tutto ciò che non è la piantina.",
		pbShootAddAttachment: "Aggiungi immagine",
		pbShootAttachmentLabelPlaceholder: "Es: bersaglio, posizione 2",
		pbShootGenerateImage: "Genera immagine dal disegno",
		pbShootImageGenerated: "Immagine generata dal disegno",
		pbShootZoom: "Ingrandisci",
		pbShootMissing: "Manca",
		pbShootMissingName: "il nome del drill",
		pbShootMissingScoring: "il sistema di punteggio",
		pbShootScoringZones: "Zone e penalità",
		pbShootReps: "Ripetizioni",
		pbShootDryQuantityHint: "Ripetizioni e tempo massimo per ciascuna.",
		pbShootPrintSheet: "Stampa scheda",
		pbShootPrintStage: "Stampa piantina",
		pbShootScoreTimeOptional: "Aggiungi il tempo",
		pbShootScorePickSystem: "Sistema di punteggio",
		pbShootScorePickSystemHint:
			"Il drill non ne ha uno: scegli con quale tabella registrare.",
		shootTargetMicroIpsc: "Micro IPSC",
		shootTargetPlateRect: "Piatto 15×15",
		shootTargetPlateRectLarge: "Piatto 30×30",
		shootTargetPlateRack: "Plate rack",
		shootTargetNoShootMetal: "No-shoot metallo",
		pbRxShotsPerSeries: "colpi/serie",
		pbShootNotIndicated: "Non indicata",
		pbShootCustomOption: "Altro — scrivi tu",
		pbShootDescribeCondition: "Descrivi la condizione",
		pbShootDrillSaved: "Drill salvato",
		pbShootDrillCopied: "Copiato nella tua libreria",
		pbShootDrillDeactivated: "Drill disattivato",
		pbShootEditDrill: "Modifica drill",
		pbShootNewDrill: "Nuovo drill",
		pbShootSaveDrill: "Salva drill",
		pbShootNoDrills: "Nessun drill in libreria.",
		pbShootNoDrillsHint:
			"Creane uno e lo ritroverai nel ProgramBuilder senza ridigitarlo.",
		pbShootCopyToLibrary: "Copia nella mia libreria",
		// Program Builder - conditioning form
		conditioningNameAutoHint:
			"Opzionale. Se lo lasci vuoto, il titolo verrà generato dal tipo di conditioning.",
		pbEnduranceNameAutoHint:
			"Finché non lo cambi segue la tipologia scelta. Se lo lasci vuoto, viene generato dal tipo.",
		pbCondUseLibraryTemplate: "Usa template da libreria",
		pbCondTemplatesAvailable: "disponibili",
		pbCondSearchTemplate: "Cerca template...",
		pbCondSavingToLibrary: "Salvataggio in libreria...",
		pbCondSaveToLibrary: "Salva in libreria personale",
		pbCondLinkedToLibrary: "Template collegato alla libreria personale",
		pbKeepCurrent: "Mantieni attuale",
		// Program Builder - conditioning template editor
		pbCondNamePlaceholder: "es. Fran, Cindy, Hero WOD...",
		pbWodType: "Tipo WOD",
		pbTimeMin: "Tempo (min)",
		pbEnterDurationMin: "Inserisci durata (min), es. 12",
		pbEnterRoundsOrScheme: "Inserisci rounds o schema (es. 3 o 21-15-9)",
		pbTimeCapMin: "TC (min)",
		pbEg20: "Es. 20",
		pbRoundDuration: "Durata round",
		pbEmomRoundBuilder: "Round Builder EMOM",
		pbAddRound: "Aggiungi round",
		pbMoveRoundUp: "Sposta round su",
		pbMoveRoundDown: "Sposta round giù",
		pbEmomOddRound: "Round dispari",
		pbEmomEvenRound: "Round pari",
		pbEmomSpecificRound: "Round specifico",
		pbCustomLabel: "Custom",
		pbRoundTitlePlaceholder: "Titolo round (facoltativo)",
		pbLibraryLabel: "Library",
		pbLoadMaleFemale: "Carico Uomo/Donna",
		pbRoundContentPlaceholder:
			"Contenuto round (es: 10 thruster @40kg + 8 burpees oppure 40s work / 20s rest)",
		pbEmomNotes: "Note EMOM",
		pbEmomNotesPlaceholder: "Note aggiuntive sull'EMOM...",
		pbCycles: "Cicli",
		pbWorkBlockPlaceholder: "Es. 5 burpees + 10 double unders + 30m sled push",
		pbHiitScheme: "Schema",
		pbHiitSchemePlaceholder: "21-15-9 o 3 rounds",
		pbHiitTimeCap: "Time cap",
		pbHiitDuration: "Durata",
		pbHiitRestFixed: "Fisso",
		pbHiitRestRatio: "Rapporto",
		pbHiitRatioField: "Lavoro : Recupero",
		pbHiitRatioResult: "Risulta",
		pbHiitDescribeBlock: "Descrivi il blocco",
		pbHiitPreview: "Anteprima",
		pbHiitPreviewEmpty: "Compila i campi qui sopra",
		pbHiitCycleOne: "ciclo",
		pbHiitCycleMany: "cicli",
		pbHiitTotalApprox: "totali",
		pbHiitMissingWork: "manca la durata del lavoro",
		pbHiitMissingRest: "manca il recupero",
		pbHiitInvalidRatio: "rapporto non valido",
		pbWodCustomDescription: "Descrizione WOD (formato custom)",
		pbStartTypingToSearch: "Inizia a digitare per cercare",
		pbDescriptionOptional: "Descrizione (opzionale)",
		pbVideoUrlOptional: "URL Video (opzionale)",
		pbWodNotes: "Note WOD",
		pbWodNotesPlaceholder: "Note aggiuntive sul WOD...",
		pbAiWandDisabledForCoach:
			"Bacchetta AI visibile ma momentaneamente disattivata per questo coach.",
		pbAiDisabledForCoach:
			"Funzionalita AI momentaneamente disattivata per questo coach dall'amministratore.",
		pbAiWriteConditioningFirst: "Scrivi prima il conditioning da interpretare",
		pbAiWriteExerciseFirst: "Scrivi prima l'esercizio da interpretare",
		pbAiWriteWorkoutFirst: "Scrivi prima l'allenamento da interpretare",
		pbAiParseFailed: "AI non è riuscita a interpretare il testo",
		pbAiParseError: "Errore nel parsing AI",
		pbAiConvertedTo: "Convertito in",
		pbVideoUnavailable: "Video non disponibile per questo esercizio",
		// Program Builder - shared toasts
		pbEnterExerciseName: "Inserisci un nome per l'esercizio",
		pbExerciseAddedToPersonalLibrary: "aggiunto alla libreria personale!",
		pbVideoPreviewOf: "Anteprima video",
		// Program Builder - conditioning result schema editor
		pbSchemaTitle: "Schema risultato (opzionale)",
		pbSchemaEmpty:
			"Nessuno schema configurato — verrà usato l'input di default del tipo di conditioning.",
		pbSchemaFieldTitlePlaceholder: "Titolo risultato (es. Tempo totale)",
		pbSchemaRemoveField: "Rimuovi campo",
		pbSchemaOrderHint:
			"Ordine: i tipi reps/kg/meters/points → higher is better. seconds/minutes/MM:SS → lower is better.",
		pbMoveUp: "Sposta su",
		pbMoveDown: "Sposta giù",
		// Program Builder - result unit types
		resultUnitKg: "Peso (kg)",
		resultUnitReps: "Ripetizioni",
		resultUnitSeconds: "Secondi",
		resultUnitMinutes: "Minuti",
		resultUnitMinutesSeconds: "MM:SS",
		resultUnitTimeOrReps: "Time or Reps (mm:ss o reps)",
		resultUnitMeters: "Metri",
		resultUnitPoints: "Punti",
		resultUnitHitFactor: "Hit factor",
		pbSchemaLockedHint:
			"Schema bloccato: questo conditioning ha già risultati inseriti. Puoi modificare solo le etichette dei campi, non la tipologia.",
		// Program Builder - result schema editor hint
		pbSchemaConfiguredHint:
			"Se configurato, l'atleta inserirà questi valori al posto dell'input di default. La leaderboard userà questi campi e ordinerà per tipo.",
		// Program Builder - page: toasts
		pbLoadError: "Errore nel caricamento",
		pbSchemaLockedToastFull:
			"Schema risultato bloccato: questo conditioning ha già risultati inseriti. Puoi cambiare solo le etichette dei campi, non la tipologia (unità) né aggiungere/rimuovere campi. Le modifiche allo schema non sono applicate.",
		pbWeekLoadFailed: "Impossibile caricare la settimana",
		pbSaveBeforeSharing:
			"Salva prima il programma, poi avvia la condivisione per evitare incongruenze.",
		pbSaveSourceBeforeSharing:
			"Salva prima il programma sorgente per poter condividere",
		pbSelectedProgramLoadError:
			"Errore nel caricamento del programma selezionato",
		pbSelectTargetWeek: "Seleziona una settimana di destinazione",
		pbSelectTargetDay: "Seleziona una giornata di destinazione",
		pbExportError: "Errore esportazione",
		pbDayAdded: "Giorno aggiunto",
		pbDayRemoved: "Giorno rimosso",
		pbDayDuplicated: "Giorno duplicato",
		pbSharedExerciseSourceOnly:
			"Esercizio condiviso: modificabile solo dal programma sorgente",
		pbSharedExerciseLockedTarget:
			"Esercizio condiviso: impostazioni bloccate nel programma target",
		pbAiInterpretedAs: "Interpretato come",
		pbNameTheDrill: "Dai un nome al drill",
		pbComplexNeedsTwo: "Il complex richiede almeno 2 esercizi",
		pbSupersetNeedsTwo: "Il superset richiede almeno 2 esercizi",
		pbEnterSetCount: "Inserisci il numero di set",
		pbAddAtLeastOneEmomRound: "Aggiungi almeno un round EMOM",
		pbEnterCustomDescription: "Inserisci una descrizione custom",
		pbSelectConditioningType: "Seleziona il tipo di conditioning",
		pbSavedWithoutSchema:
			"Salvataggio confermato senza schema risultato: gli atleti inseriranno un risultato libero e il ranking potra essere meno confrontabile.",
		pbEnterNameBeforeSaving: "Inserisci un nome prima di salvare in libreria",
		pbConditioningSavedToLibrary:
			"Conditioning salvato nella libreria personale",
		pbDuplicatedIn: "Duplicato in",
		pbNextWeekShort: "sett. successiva",
		pbSelectCoach: "Seleziona un coach",
		pbSelectCoachTeam: "Seleziona un coach team",
		pbConfigureSchemaNow:
			"Configura ora lo schema risultato: lo trovi nella sezione in basso evidenziata.",
		// Program Builder - page: UI chrome
		pbDetails: "Dettagli",
		pbEditing: "In modifica",
		pbProgramLabel: "Programma",
		pbNoExercises: "Nessun esercizio",
		pbSelectExercise: "Seleziona un esercizio",
		pbMethodStandard: "Standard",
		pbRoundLabel: "Round",
		pbPreviewRendering: "Anteprima visualizzazione",
		pbPreviewRenderingHint:
			"Simula la schermata mobile dell'atleta per verificare il rendering degli esercizi prima della pubblicazione.",
		pbNoGroupCreated: "Nessun gruppo creato",
		pbCoachTeamAccess: "Accesso Coach Team",
		pbCoachesWithAccess: "Coach con accesso",
		pbSelectCoachPlaceholder: "Seleziona coach",
		pbCoachTeamsWithAccess: "Coach Team con accesso",
		pbNoCoachTeamAssigned: "Nessun coach team assegnato",
		pbSelectCoachTeamPlaceholder: "Seleziona coach team",
		pbCoachAiDisabledTitle: "AI del coach momentaneamente disattivata",
		pbCoachAiDisabledBody:
			"La bacchetta AI e l'assistente restano visibili nel builder, ma non sono operativi per questo coach.",
		pbRemoveDate: "Rimuovi data",
		pbPreviewAthletes: "Anteprima atleti",
		pbPublishPreviewOnlyFor: "Pubblica in preview solo per",
		pbWeekName: "Titolo settimana",
		pbDuplicateWeek: "Duplica Settimana",
		pbShareWeek: "Condividi Settimana",
		pbExportWeek: "Esporta Settimana",
		pbEditDayTitleAndDate: "Modifica titolo e data giornata",
		pbSectionOpenHintEsc:
			'Questa sezione e aperta. Premi ESC o clicca "Chiudi" per uscire.',
		pbSectionOpenHintShort: 'Sezione aperta. Premi ESC o clicca "Chiudi".',
		pbDayTitle: "Titolo giornata",
		pbDayDate: "Data giornata",
		pbDayDetails: "Dettagli giornata",
		pbConfigured: "Configurato",
		pbEditDayDetails: "Modifica dettagli giornata",
		pbWarmup: "Warm-up",
		pbWarmupPlaceholder: "Warm-up rapido...",
		pbCooldown: "Defaticamento",
		pbCooldownPlaceholder: "Defaticamento rapido...",
		pbDayNotes: "Note Giornata",
		pbQuickNotesPlaceholder: "Note rapide...",
		pbSessions: "Sessioni",
		pbMoveSessionUp: "Sposta sessione su",
		pbMoveSessionDown: "Sposta sessione giu",
		pbRemoveSession: "Rimuovi sessione",
		pbNewSession: "Nuova sessione",
		pbSharedExerciseReadonly: "Esercizio condiviso (sola lettura)",
		pbDragToReorderExercise: "Trascina per riordinare esercizio",
		pbNoSession: "Senza sessione",
		pbLocalNote: "Nota locale (solo questo programma)",
		pbLocalNotePlaceholder:
			"Aggiungi una nota locale per questo esercizio condiviso",
		pbSetRowNote: "Nota serie",
		pbRemoveSetRowNote: "Rimuovi la nota di questa serie",
		pbMovementNote: "Nota movimento",
		pbRemoveMovementNote: "Rimuovi la nota di questo movimento",
		pbSequence: "Sequenza",
		pbPercentOrLoad: "% o carico",
		pbEg230: "Es. 2:30",
		pbMethodology: "Metodica",
		pbMethodSuperset: "Superset",
		pbMethodEmom: "EMOM",
		pbSearchOrAddExercise: "Cerca o inserisci nuovo esercizio...",
		pbAddRow: "Aggiungi riga",
		pbExerciseNotes: "Note esercizio",
		pbExerciseNotesPlaceholder:
			"Note per l'esercizio (tempo, tecnica, indicazioni...)",
		pbExerciseSequence: "Sequenza esercizi",
		pbChangeExercise: "Cambia esercizio",
		pbAddExerciseToSequence: "Aggiungi esercizio alla sequenza...",
		pbComplexNotes: "Note complex",
		pbComplexNotesPlaceholder: "Note per il complex...",
		pbComplexNamePlaceholder: "Es: Back Squat - variante tecnica",
		pbAiFreeTextPlaceholder:
			"Es: 5x5 BS @75% rec 2' / E2MOM 10' 3 PC @80% / A1 BS 4x8 + A2 RDL 4x10",
		pbAthleteCuesPlaceholder: "Indicazioni aggiuntive per l'atleta...",
		pbTotalRounds: "Round totali",
		pbRestBetweenRounds: "Recupero tra round",
		pbSupersetNotes: "Note superset",
		pbSupersetNotesPlaceholder: "Note per il superset...",
		pbExerciseNotesShortPlaceholder: "Note esercizio...",
		pbSearchExerciseToAdd: "Cerca esercizio da aggiungere...",
		pbNoDay: "Nessun giorno",
		pbAthletePreview: "Anteprima visualizzazione atleta",
		pbPreviewContext: "Contesto anteprima",
		pbConfigureConditioningResult: "Configura risultato conditioning",
		pbConfigureConditioningResultBody:
			"Questo conditioning custom non ha ancora uno schema risultato. Configurarlo ora rende inserimento risultati e ranking piu coerenti.",
		pbContinueWithoutSchema: "Continua senza schema",
		pbConfigureSchemaNowCta: "Configura schema ora",
		pbLoadingPrograms: "Caricamento programmi...",
		pbParentFolder: "Cartella superiore",
		pbNoProgramInFolder: "Nessun programma trovato in questa cartella",
		pbTargetProgram: "Programma destinazione",
		pbTargetWeek: "Settimana destinazione",
		pbPickWeek: "Scegli settimana",
		pbTargetDay: "Giornata destinazione",
		pbPickDay: "Scegli giornata",
		pbShared: "condivisi",
		pbShareWeekExplain:
			"nella settimana di destinazione. Le giornate verranno abbinate automaticamente per giorno della settimana (o per numero giornata per i programmi non datati). Gli esercizi condivisi resteranno sincronizzati.",
		pbUnsavedBeforeSharing:
			"Sono presenti modifiche non salvate. Salva il programma prima di condividere.",
		pbWarmupShort: "WU:",
		pbCooldownShort: "CD:",
		// Program Builder - page: misc
		pbUnknownError: "errore sconosciuto",
		pbErrorShort: "errore",
		pbSchemaLockedToastSaved:
			"Schema risultato bloccato: questo conditioning ha già risultati inseriti. Puoi cambiare solo le etichette dei campi, non la tipologia (unità) né aggiungere/rimuovere campi. Le modifiche allo schema non sono state salvate.",
		pbAiCoachAssistant: "AI Coach Assistant",
		// Program Builder - page: wrapped texts
		pbShareWeekExplainFull:
			"Tutti gli esercizi della settimana verranno condivisi nella settimana di destinazione. Le giornate verranno abbinate automaticamente per giorno della settimana (o per numero giornata per i programmi non datati). Gli esercizi condivisi resteranno sincronizzati con l'originale.",
		pbUntitled: "Senza titolo",
		// Program Builder - rounds placeholder
		pbRoundsPlaceholder: "3 o 3/4",
		// Program Builder - week status, plurals, day label
		day: "Giorno",
		dayOne: "giorno",
		daysLower: "giorni",
		pbWeekReactivate: "Riattiva",
		pbSchedulePublish: "Pubblica il...",
		pbPublishOn: "Pubblica il",
		pbPublishNowInstead: "Pubblica subito, senza aspettare",
		pbWeekConflictFirstDay: "attenzione: gli allenamenti iniziano",
		pbWeekConflictPublish: "attenzione: si pubblica",
		pbWeekConflictButHidden: "ma gli atleti la vedono solo fino a",
		pbPublishNow: "Pubblica ora",
		pbVisibleUntil: "Visibile fino a",
		pbVisibleUntilPick: "Visibile fino a…",
		pbStaysVisible: "Resta visibile",
		pbWeekMoreActions: "Altre azioni sulla settimana",
		pbDeleteWeekAction: "Elimina Settimana",
		pbWeekStatusVisible: "Visibile agli atleti",
		pbWeekStatusVisibleSince: "Visibile dal",
		pbWeekStatusScheduled: "Si pubblica",
		pbWeekStatusHidden: "Nascosta dal",
		pbWeekStatusDraft: "Non visibile agli atleti",
		pbFirstDayQuestion: "Da quando parte?",
		pbFirstDayToday: "Oggi",
		pbFirstDayNextMonday: "Lunedì prossimo",
		pbFirstDayCustom: "Altra data",
		pbFirstDaySentence: "Settimana 1 da {date}.",
		pbWeekVisibleUntil: "visibile fino a",
		pbWeekStaysVisible: "resta visibile",
		pbWeekHideAuto: "automatico",
		pbWeekHideManual: "data scelta",
		pbWeekPreviewFor: "in anteprima per",
		pbWeekSeenBy: "la vedono",
		pbWeekSeenByOne: "la vede",
		pbWeekNoAthletes: "nessun atleta assegnato",
		pbWeekAfterSave: "dopo il salvataggio",
		pbWeekHeld: "Trattenuta: non si pubblica finché non la rilasci",
		pbWeekHeldStarts: "gli allenamenti iniziano",
		pbWeekNoDatedDays: "senza giorni datati non si pubblica da sola",
		pbWeekConflictEmpty: "ed è ancora vuota",
		pbHoldWeek: "Trattieni",
		pbReleaseWeek: "Rilascia",
		pbSavedWeekScheduled: "si pubblica",
		pbSavedAutoPublishOn: "Pubblicazione automatica attiva",
		pbSavedAutoPublishOff: "Pubblicazione automatica spenta",
		pbAutoPublishDialogTitle: "Attivare la pubblicazione automatica?",
		pbAutoPublishDialogBody:
			"Queste settimane oggi sono visibili agli atleti (o programmate prima del loro turno). Con la pubblicazione automatica ognuna comparirà da sola:",
		pbAutoPublishDialogFooter:
			"Le settimane passate e quella in corso non cambiano. Vale dal salvataggio: lo leggi nella riga di stato di ogni settimana.",
		pbAutoPublishActivate: "Attiva",
		pbSavedWeekPublished: "pubblicata a",
		pbSavedWeekPublishedNoAthletes: "pubblicata, nessun atleta assegnato",
		pbSavedWeekHidden: "nascosta agli atleti",
		pbSavedAthleteAdded: "1 atleta aggiunto",
		pbSavedAthletesAdded: "atleti aggiunti",
		pbHideWeekTitle: "Nascondere la settimana",
		pbHideWeekTo: "a",
		pbHideWeekBody: "Gli atleti assegnati non la vedranno più dal prossimo salvataggio. I risultati già inseriti restano.",
		pbAthletesSeeWeeks: "Vedono",
		pbAthletesSeeNothing: "Non vedono ancora nulla: nessuna settimana pubblicata",
		pbAssignSelectedCount: "selezionati",
		pbAssignAllAssigned: "Tutti i tuoi atleti sono già assegnati",
		assignedGroups: "Gruppi assegnati",
		pbVisibleWeeksShort: "visibili",
		pbNoVisibleWeeks: "nessuna visibile",
		pbDeleteDayConfirm: "Eliminare questo giorno?",
		// Program Builder - date picker
		pbSelectDate: "Seleziona data",
		// Program Builder - cadence and pace modifier
		pbEvery: "ogni",
		pbMinuteOne: "minuto",
		pbMinuteMany: "minuti",
		pbPaceModifierSyntax: "Sintassi: 85% oppure +10s / -15s",
		pbPaceModifierInvalid: "Formato non valido. Esempi: 85% | +10s | -15s",
		pbBenchmarkPercentage: "Percentuale benchmark",
		// Program Builder - compact prescription tokens
		pbRxRec: "rec",
		pbRxSegments: "segmenti",
		pbRxSegFast: "veloce",
		pbRxSegMedium: "medio",
		pbRxSegSlow: "lento",
		pbRxCap: "cap",
		pbRxRound: "round",
		pbRxCycles: "cicli",
		pbRxWork: "work",
		pbRxReps: "rip",
		pbRxSeries: "serie",
		pbRxShots: "colpi",
		pbRxFree: "libero",
		pbRxHandgun: "pistola",
		pbRxRifle: "carabina",
		pbRxShotgun: "fucile",
		pbRxPcc: "PCC",
		// Program Builder - interval section headings
		pbHillRepeats: "Ripetute in salita",
		pbThresholdBlocks: "Blocchi soglia",
		pbVo2maxIntervals: "Intervalli VO2max",
		pbErgConditioningBlocks: "Blocchi Erg Conditioning",
		pbIntervals: "Intervalli",
		pbIntervalSeries: "Serie di intervalli",
		// Program Builder - sharing, tooltips, dialogs
		pbSourceWeekNotFound: "Settimana sorgente non trovata",
		pbSourceDayNotFound: "Giornata sorgente non trovata",
		pbTargetWeekNotFound: "Settimana di destinazione non trovata",
		pbSourceExerciseNotFound: "Esercizio sorgente non trovato",
		pbInvalidTarget: "Destinazione non valida",
		pbSaveSourceToShareExercises:
			"Salva prima il programma sorgente per condividere esercizi",
		pbSaveSourceToShareWeek:
			"Salva prima il programma sorgente per condividere la settimana",
		pbCannotUpdateSource: "Impossibile aggiornare il sorgente",
		pbCannotShareWeekWithItself:
			"Impossibile condividere una settimana con se stessa",
		pbSourceWeekHasNoExercises:
			"La settimana sorgente non contiene esercizi da condividere",
		pbExerciseShareDone: "Condivisione esercizio completata",
		pbWeekShareDone: "Condivisione settimana completata",
		pbExportDone: "Esportazione completata",
		pbExerciseUpdated: "Esercizio aggiornato",
		pbExerciseAdded: "Esercizio aggiunto",
		pbTemplateNotCreated: "Template non creato correttamente",
		pbLibrarySaveError: "Errore nel salvataggio in libreria",
		pbUntitledProgram: "Programma senza titolo",
		pbDatedProgramDragHint: "Programma datato: ordinamento automatico per data",
		pbDragToReorderDay: "Trascina per riordinare la giornata",
		pbHasTitle: "Titolo",
		pbNoTitle: "Senza titolo",
		pbNoWarmup: "No warm-up",
		pbNoCooldown: "No defaticamento",
		pbHasNotes: "Note",
		pbNoNotes: "No note",
		pbSourceProgramFallback: "programma sorgente",
		pbSessionPrefix: "Sessione",
		pbSharedWith: "Condiviso con",
		pbProgramOne: "programma",
		pbProgramMany: "programmi",
		pbSharingActive: "Condivisione attiva",
		pbSharingActiveNoTarget:
			"Condivisione attiva - nessun programma destinazione",
		pbExerciseGlobalLibrary: "Esercizio della libreria globale",
		pbExercisePersonalLibrary: "Esercizio della libreria personale",
		supersetNameAutoHint:
			"Opzionale. Se lo lasci vuoto, il nome verrà generato dagli esercizi selezionati.",
		emomNameAutoHint:
			"Opzionale. Se lo lasci vuoto, il nome verrà generato da round e cadenza.",
		pbCaloriesMaleFemale: "Calorie Uomo/Donna (es. 20/16)",
		pbAddToPersonalLibrary: "alla libreria personale",
		pbExportWeekTitle: "Esporta settimana",
		pbShareWeekTitle: "Condividi settimana",
		pbExportDayTitle: "Esporta giornata",
		pbShareExerciseTitle: "Condividi esercizio",
		pbExportExerciseTitle: "Esporta esercizio",
		pbExportToOtherProgram: "Esporta in altro programma",
		pbSelectAProgram: "Seleziona un programma",
		pbSharingInProgress: "Condivisione in corso...",
		pbExportInProgress: "Esportazione in corso...",
		pbConfirmShare: "Conferma condivisione",
		pbConfirmExport: "Conferma esportazione",
		pbVideoPreviewOfLabel: "Anteprima video",
		// Program Builder - day summary chips
		pbCreateAndSelect: "Crea e Seleziona",
		pbSaving: "Salvataggio...",
		// Program Builder - generated label suffix
		pbCopySuffix: "copia",
		// Monitoraggio atleti (docs/monitoring/)
		monitoring: "Monitoraggio",
		monTitle: "Monitoraggio atleti",
		monSubtitle: "Chi si allena, che cosa era programmato e che cosa ha registrato, sul periodo scelto.",
		monViewOverview: "Panoramica",
		monViewAttendance: "Registro giornate",
		monViewAttendanceShort: "Registro",
		monSortBy: "Ordina per",
		monSortAscending: "Ordine crescente: tocca per invertire",
		monSortDescending: "Ordine decrescente: tocca per invertire",
		monOverviewHintTouch: "Tocca un atleta per aprire la scheda del periodo.",
		monUndatedShort: "Programmi non datati",
		monAttendanceTapHint: "Tocca un giorno o il nome per aprire la scheda dell'atleta.",
		monHowToRead: "Come si leggono questi grafici",
		monPeriod: "Periodo",
		monPeriod7d: "Ultimi 7 giorni",
		monPeriod14d: "Ultimi 14 giorni",
		monPeriod28d: "Ultimi 28 giorni",
		monPeriodThisWeek: "Settimana corrente (lun-dom)",
		monPeriodLastWeek: "Settimana scorsa (lun-dom)",
		monGroupFilter: "Gruppo",
		monAllGroups: "Tutti gli atleti",
		monProgramFilter: "Programma",
		monAllPrograms: "Tutti i programmi",
		monSearchAthlete: "Cerca atleta (nome o email)",
		monColAthlete: "Atleta",
		monColLastActivity: "Ultima attività",
		monColOutcome: "Esito sulle giornate assegnate",
		monColExtra: "Extra",
		monColWellness: "Benessere",
		monColFlags: "Avvisi",
		monCompleteShort: "complete",
		monPartialShort: "parziali",
		monMissingShort: "senza esito",
		monOutOf: "su",
		monAssignedShort: "assegnate",
		monUpcomingShort: "in programma",
		monNoAssignedDays: "Nessuna giornata assegnata nel periodo",
		monNoActivityLookback: "Nessuna attività negli ultimi 90 giorni",
		monDaysAgo: "giorni fa",
		monDaysWord: "giorni",
		monExtraDays: "giorni con attività extra",
		monWellnessOff: "Diario non attivo",
		monWellnessCheckins: "check-in",
		monWellnessLast: "ultimo",
		monUndatedPrograms: "Ha programmi non datati: quei risultati compaiono alla data di registrazione come attività, non come giornate assegnate.",
		monFlagMissingLogs: "giornate senza esito su",
		monFlagInactive: "Nessuna attività da",
		monFlagInactiveOver: "Nessuna attività da oltre",
		monFlagHighRpe: "risultati con RPE ≥",
		monFlagWellnessLow: "Benessere basso il",
		monFlagWellnessGap: "Diario benessere attivo ma senza compilazioni nel periodo",
		monFlagNoData: "Dati insufficienti: nessuna giornata assegnata e nessuna attività",
		monWellnessSleep: "sonno",
		monWellnessEnergy: "energia",
		monWellnessMood: "umore",
		monWellnessSoreness: "indolenzimento",
		monWellnessStress: "stress",
		monStatusComplete: "Esito completo",
		monStatusPartial: "Esito parziale",
		monStatusNone: "Esito non registrato",
		monStatusUpcoming: "In programma",
		monStatusRest: "Nessuna programmazione",
		monDayEarly: "Fatta in anticipo",
		monEarlyShort: "in anticipo",
		monLegend: "Legenda",
		monLegendExtra: "Attività extra (manuale o diario)",
		monLegendDiary: "Voce di diario",
		monLegendSessions: "sedute",
		monPresenceNote: "La presenza non è verificata: la piattaforma non ha prenotazioni né check-in. «Attività dichiarata» vuol dire che l'atleta ha registrato qualcosa quel giorno; «esito non registrato» non vuol dire «non svolto».",
		monPresenceDeclared: "attività dichiarata",
		monPresenceUnknown: "presenza non disponibile",
		monBackToList: "Monitoraggio",
		monOpenAthlete: "Scheda atleta",
		monSectionDays: "Giorno per giorno",
		monSectionWellness: "Benessere",
		monPlanned: "Programmato",
		monDone: "Eseguito",
		monNotLogged: "non registrato",
		monLoggedWithoutQuantity: "registrato, quantità non determinabile",
		monExercisesLogged: "esercizi con esito",
		monRestRun: "giorni senza programmazione né attività",
		monUnmatched: "Risultati non abbinati a una riga del programma",
		monExtraResults: "Attività extra",
		monDiaryEntry: "Diario",
		monColMovement: "Movimento",
		monColDays: "Giorni",
		monColQuantity: "Quantità",
		monColSets: "Serie",
		monColPlanned: "Programmato",
		monColQuality: "Qualità del dato",
		monColCoverage: "Copertura",
		monQuantified: "con quantità",
		monNoMovements: "Nessun risultato nel periodo",
		monTotalsReps: "Ripetizioni di movimento",
		monTotalsTonnage: "Tonnellaggio (carico come registrato)",
		monTotalsMeters: "Metri",
		monTotalsSeconds: "Tempo registrato",
		monTotalsCalories: "Calorie macchina",
		monTotalsNote: "Ogni ripetizione conta una volta sola e il contenitore di un complex non conta. Il tonnellaggio è una quantità registrata, non un indice di difficoltà: non confronta esercizi diversi. Questo è il volume del lavoro registrato, non il profilo prestativo: lì la ginnastica vale il massimo unbroken di una serie.",
		monQualityRecorded: "registrato",
		monQualityFromPrescription: "da prescrizione",
		monQualityFromConfirmation: "da conferma",
		monQualityFromScore: "dallo score",
		monQualityPartial: "parziale",
		monQualityIndeterminate: "non determinabile",
		monScaled: "scalati",
		monEmpty: "Nessun atleta nel perimetro selezionato",
		monLoadError: "Impossibile caricare il monitoraggio",
		monWellnessOffPanel: "Il diario benessere non è attivo per questo atleta.",
		monOverviewHint: "Clicca un atleta per aprire la scheda del periodo.",
		monLoggedOn: "registrato il",
		monUndatedProgramResult: "Programma non datato",
		monOtherDayProgramResult: "Programma, altra giornata",
		monAlertSettingsButton: "Avvisi",
		monAlertCustomized: "personalizzati",
		monAlertSettingsTitle: "I tuoi avvisi",
		monAlertSettingsIntro: "Gli avvisi compaiono accanto agli atleti nel Monitoraggio. Sono tuoi: scegli quali tenere accesi e con quali limiti. Non cambiano quelli dei colleghi e non sono una diagnosi, solo un invito a guardare.",
		monAlertMissingTitle: "Giornate senza esito",
		monAlertMissingSentence: "Avvisami quando un atleta ha almeno {min} giornate assegnate senza nessun risultato registrato nel periodo.",
		monAlertMissingExplain: "Conta le giornate del programma già passate in cui l'atleta non ha registrato nemmeno un esercizio. Non vuol dire che non si sia allenato: può aver dimenticato di registrare. Utile per capire con chi parlare prima di leggere i suoi numeri.",
		monAlertInactiveTitle: "Nessuna attività",
		monAlertInactiveSentence: "Avvisami quando un atleta non registra niente da almeno {days} giorni.",
		monAlertInactiveExplain: "Considera risultati di programma, risultati inseriti a mano e voci di diario. Il check-in del diario benessere non conta come allenamento. Si guarda indietro fino a 90 giorni.",
		monAlertRpeTitle: "Fatica percepita alta",
		monAlertRpeSentence: "Avvisami quando un atleta ha almeno {count} risultati con RPE uguale o superiore a {threshold} nel periodo.",
		monAlertRpeExplain: "L'RPE è quello che l'atleta scrive sul singolo esercizio (scala 1-10), non quello dell'intera seduta. Più risultati molto faticosi ravvicinati possono valere una chiacchierata o un ritocco ai carichi.",
		monAlertWellnessLowTitle: "Benessere basso",
		monAlertWellnessLowSentence: "Avvisami quando, nell'ultimo check-in di non più di {max_age_days} giorni fa, almeno {fields} voci tra sonno, energia, umore, indolenzimento e stress sono ai due livelli peggiori.",
		monAlertWellnessLowExplain: "Vale solo per gli atleti con il diario benessere attivo. Si guardano le voci soggettive della scala 1-5: sonno, energia e umore a 1-2, indolenzimento e stress a 4-5. Nessun punteggio sintetico: l'avviso dice quali voci l'hanno fatto scattare.",
		monAlertWellnessGapTitle: "Diario benessere vuoto",
		monAlertWellnessGapSentence: "Avvisami quando il diario benessere è attivo ma non ha compilazioni in un periodo di almeno {days} giorni.",
		monAlertWellnessGapExplain: "Serve a sapere che i grafici del benessere di quell'atleta non dicono niente, perché non ci sono dati. È un avviso sul dato, non sull'atleta.",
		monAlertRange: "Valore ammesso:",
		monAlertDefault: "Predefinito",
		monAlertReset: "Ripristina predefiniti",
		monAlertSaved: "Avvisi salvati",
		monAlertSaveError: "Impossibile salvare gli avvisi",
		monSectionTrends: "Andamenti",
		monAllMovements: "Tutto il lavoro registrato",
		monLastWeeks: "Ultime settimane:",
		monBucket: "Raggruppa per",
		monBucketWeek: "Settimana",
		monBucketSession: "Seduta",
		monBucketMonth: "Mese",
		monBucketProgram: "Programma",
		monMetric: "Misura",
		monMetricReps: "Ripetizioni",
		monMetricSets: "Serie",
		monMetricTonnage: "Tonnellaggio",
		monMetricTopLoad: "Carico massimo",
		monMetricAvgLoad: "Carico medio per ripetizione",
		monMetricRpe: "RPE medio",
		monMetricSessions: "Sedute",
		monMetricMeters: "Metri",
		monMetricSeconds: "Tempo",
		monMetricCalories: "Calorie",
		monTrendWindowNote: "Settimane intere, da lunedì a domenica, chiuse sulla settimana corrente. Ogni barra dice da quali date viene.",
		monTrendAllMovementsNote: "Con tutto il lavoro insieme contano solo le misure additive: ripetizioni, serie, tonnellaggio, sedute.",
		monTrendLoadNote: "Carico come registrato dall'atleta, senza convenzione sull'attrezzo. La serie più pesante è il carico massimo del periodo, il medio è tonnellaggio diviso ripetizioni con carico noto.",
		monTrendAdherence: "Giornate con esito sulle assegnate",
		monAssignedDays: "Giornate assegnate",
		monDaysWithOutcome: "Giornate con esito",
		monTrendAdherenceNote: "Aderenza dell'atleta a tutte le giornate consegnate nel periodo, non del solo movimento scelto. «Con esito» vuol dire almeno un esercizio registrato.",
		monTrendTotals: "Totali del periodo",
		monSportIntro: "Gli esercizi sono quelli del profilo prestativo attivo per questo sport: il modello decide che cosa si monitora. Ogni card legge lo stesso periodo in settimane intere.",
		monSportModel: "Modello",
		monSportOpenTrend: "Andamenti",
		monSportAttempts: "tentativi",
		monSportBest: "Miglior risultato",
		monSportNoResults: "Nessun risultato nel periodo",
		monSportNoExercises: "Il modello prestativo di questo sport non ha esercizi configurati.",
		monSportNoSports: "Nessuno sport configurato per questo atleta: le dashboard per sport nascono dagli sport della sua scheda. Qui sotto tutto il lavoro registrato.",
		monSportOtherExercises: "Altri esercizi del modello",
		monSportExtraNote: "Per un esercizio fuori dal profilo scegli",
		monFamiliesGroup: "Alzate con le varianti",
		monMovementsGroup: "Movimenti",
		monFamilySnatch: "Snatch e varianti",
		monFamilyCleanJerk: "Clean & Jerk e varianti",
		monFamilyMembers: "Varianti nel periodo",
		monFamilyMembersNote: "Clicca una variante per toglierla o rimetterla nel conteggio. Restano fuori per regola tirate, stacchi, bilanciamenti, pressate e le versioni con manubri o kettlebell: non sono l'alzata.",
		monFamilyNoMembers: "Nessuna variante registrata nel periodo.",
		monFamilyHint: "Fa parte di",
		monFamilyOpen: "Vedi con le varianti",
		monBandsPrograms: "Programmi",
		monBandsPhases: "Mesocicli",
		monBandsNoPhases: "Nessun mesociclo pianificato nel periodo",
		monChartsTitle: "Volume e intensità nel periodo",
		monChartsNote: "Un grafico per misura, stesso asse del tempo: due misure con scale diverse non stanno mai sullo stesso asse. Passando su un periodo lo leggi su tutti i grafici insieme. Le bande in alto dicono programma e mesociclo di ogni periodo.",
		monChartLoad: "Carico (kg)",
		monLoadTop: "Serie più pesante",
		monLoadAvg: "Medio per ripetizione",
		monMetricIntensity: "Intensità (% del massimale)",
		monIntensityRealized: "Realizzata",
		monIntensityRealizedAvg: "Realizzata, media",
		monIntensityPlanned: "Prescritta",
		monIntensityPlannedAvg: "Prescritta, media",
		monIntensityReference: "Massimale di riferimento",
		monIntensityNoReference: "Nessun massimale per questo movimento, né nel profilo né in agenda: la % realizzata non si calcola. La % prescritta, se c'è, viene dal programma.",
		monIntensityNote: "La % prescritta è quella scritta nel programma: media pesata sulle ripetizioni, con l'intervallo tra parentesi. La % realizzata è il carico registrato diviso il massimale di riferimento com'è oggi: il massimale del profilo prestativo o, se più alto, la miglior stima d'agenda, lo stesso con cui l'app traduce le % in kg. Per una famiglia il riferimento è l'alzata completa.",
		monRefManual: "massimale manuale del profilo",
		monRefTest: "test 1RM in agenda",
		monRefEstimate: "stima da agenda (Epley)",
		monRpeMax: "RPE massimo",
		monColPeriod: "Periodo",
		monColSessionsShort: "Sedute",
		monColSetsShort: "Serie",
		monColRepsShort: "Rip.",
		monColTonnageShort: "Tonn. (kg)",
		monColTopLoadShort: "Max (kg)",
		monColAvgLoadShort: "Medio (kg)",
		monColPlannedPctShort: "% prescr.",
		monColIntensityShort: "% max",
		monColRpeShort: "RPE",
		monColOutcomeShort: "Esiti",
		monTableNote: "Serie e ripetizioni: fatte / programmate. Esiti: giornate con esito su quelle assegnate, di tutto il lavoro. Le colonne senza valori nel periodo non compaiono.",
		monSportOpenFamily: "Con le varianti",
		monAboutData: "Come si leggono questi dati",
		monAboutDataText: "Un dato mancante resta mancante: non diventa zero e non diventa un'assenza. I numeri sono letti ora dai risultati registrati; le date sono quelle del calendario, nel tuo fuso orario.",
		monSummaryAthletes: "atleti",
		monSummaryWithActivity: "con attività registrata",
		monSummaryDaysWithOutcome: "giornate con esito",
		monFlaggedCount: "con avvisi",
		monFlaggedShowOnly: "mostra solo loro",
		monFlaggedShowAll: "mostra tutti",
		monProgramFilterNote: "Solo gli atleti che hanno questo programma assegnato.",
		monSortAttention: "Attenzione",
		monSortAttentionNote: "In ordine di attenzione: prima chi ha avvisi, poi chi ha segnalazioni minori, poi gli altri. In fondo chi non registra niente da 90 giorni.",
		monSortCustomNote: "Ordine scelto da te.",
		monSortResetAttention: "Torna all'ordine per attenzione",
		monWriteTo: "Scrivi",
		monAthleteLoadError: "Impossibile aprire il monitoraggio di questo atleta: potrebbe non essere fra quelli che segui.",
		monTrendsWhat: "Che cosa guardare",
		monTrendsAllWork: "Tutto il lavoro",
		monTrendsBackToProfile: "Esercizi del profilo",
		monTrendsMoreMeasures: "Altre misure",
		monTrendsFewerMeasures: "Meno misure",
		monTimesShort: "volte",
		monMovementRowHint: "Tocca il nome di un movimento per vederne l'andamento.",
		monOpenMovementTrend: "Andamento",
		monSectionDaysShort: "Giorni",
		monOpenAthleteShort: "Scheda",
	},

	en: {
		// Common
		save: "Save",
		cancel: "Cancel",
		delete: "Delete",
		edit: "Edit",
		create: "Create",
		select: "Select",
		fillRequiredFields: "Fill in the required fields",
		search: "Search",
		loading: "Loading...",
		error: "Error",
		success: "Success",
		confirm: "Confirm",
		confirmDelete: "Are you sure you want to delete this item?",
		back: "Back",
		next: "Next",
		copy: "Copy",
		download: "Download",
		upload: "Upload",
		view: "View",
		close: "Close",
		today: "Today",

		// Navigation
		dashboard: "Dashboard",
		athletes: "Athletes",
		yesterday: "Yesterday",
		msgNew: "New",
		msgNoThreads: "No conversations yet. Tap “New” to message your coach.",
		msgYou: "You",
		msgDirect: "Direct message",
		msgOriginalFeedback: "Original feedback",
		msgSupportRequest: "Support request",
		msgOpenInDiary: "Open in diary",
		msgProgramNoLongerActive: "Program no longer active",
		msgProgramNoLongerAvailable: "Program no longer available",
		msgOpenAthlete: "Open athlete",
		msgAskSupport: "Ask coach support",
		msgGoToThread: "Go to conversation",
		actionResultShort: "Result",
		actionSupportShort: "Support",
		actionThreadShort: "Thread",
		actionLeaderboardShort: "Leaderboard",
		actionHistoryShort: "History",
		exerciseHistoryLabel: "Exercise History",
		exerciseProgressLabel: "Progression",
		hide: "Hide",
		value: "Value",
		msgEmptyThread: "No messages yet. Write below.",
		msgWritePlaceholder: "Write a message…",
		msgSend: "Send",
		msgSelectContact: "New conversation",
		msgNoContacts: "No contacts available.",
		msgLoadError: "Could not load the conversation.",
		msgSendError: "Send failed.",
		msgArchive: "Archive",
		msgUnarchive: "Unarchive",
		msgDeleteThread: "Delete conversation",
		msgDeleteThreadConfirmTitle: "Delete conversation",
		msgDeleteThreadConfirmBody:
			"Delete this conversation? You won't be able to see it anymore.",
		msgArchived: "Archived",
		msgInbox: "Messages",
		msgArchivedEmpty: "No archived conversations.",
		msgArchivedDone: "Conversation archived.",
		msgUnarchivedDone: "Conversation restored.",
		msgDeletedDone: "Conversation deleted.",
		msgActionError: "Action failed.",
		msgStatusSent: "Sent",
		msgStatusDelivered: "Delivered",
		msgStatusRead: "Read",
		feedbackSeenByCoach: "Seen by coach",
		feedback: "Feedback",
		feedbackSubtitle: "All your athletes' feedback, newest first.",
		feedbackMarkAllRead: "Mark as read",
		feedbackAll: "All",
		feedbackUnreadOnly: "Unread",
		feedbackNeedsAttention: "Needs attention",
		feedbackAllAthletes: "All athletes",
		feedbackAllPrograms: "All programs",
		feedbackPeriod7: "Last 7 days",
		feedbackPeriod30: "Last 30 days",
		feedbackPeriodAll: "All time",
		feedbackEmpty: "No feedback to show with these filters.",
		feedbackLoadError: "Could not load feedback.",
		feedbackAllRead: "All feedback marked as read.",
		feedbackReplySent: "Reply sent.",
		feedbackReplyError: "Send failed.",
		feedbackDiary: "Diary",
		feedbackNoNote: "No note",
		feedbackGroup: "Group",
		feedbackReply: "Reply",
		feedbackOpenAthlete: "Open athlete",
		feedbackOpenProgram: "Program preview",
		feedbackReplyPlaceholder: "Write a reply to the athlete…",
		feedbackSend: "Send",
		feedbackLoadMore: "Load more",
		feedbackMarkReadOne: "Mark read",
		feedbackViewFeed: "Feed",
		feedbackViewProgram: "By program",
		feedbackViewAthlete: "By athlete",
		feedbackViewGroup: "Group leaderboards",
		feedbackSelectProgram: "Select a program",
		feedbackSelectGroup: "Select a group",
		feedbackSearchGroup: "Search group…",
		feedbackNoGroups: "You don't manage any group.",
		feedbackGroupNoPrograms: "No program assigned to this group.",
		feedbackGroupHint:
			"Per-exercise leaderboards, restricted to this group. They also include non-public results (visible only to you).",
		feedbackGroupMembers: "{count} athletes",
		feedbackGroupExerciseResults: "{count} results",
		feedbackGroupNoResultsYet: "No result",
		feedbackGroupOpenLeaderboard: "Open group leaderboard",
		feedbackGroupShowPrescription: "Show the prescribed exercise",
		feedbackGroupNoPrescription: "No detail available.",
		feedbackNoAthletes: "No athletes in this program.",
		feedbackColAthlete: "Athlete",
		feedbackGridHint:
			"Click a cell to see the athlete's feedback for this program.",
		feedbackSelectAthlete: "Select an athlete to see their feedback.",
		feedbackScopeMine: "Mine",
		feedbackScopeAll: "All (admin)",
		feedbackCoachFilter: "Coach filter",
		feedbackAllCoaches: "All coaches",
		feedbackCompleted: "Completed",
		feedbackLoggedEarly: "logged early",
		feedbackIncludeCompleted: "Include completed",
		feedbackSearchAthlete: "Search athlete…",
		feedbackSearchProgram: "Search program…",
		feedbackDetail: "Details",
		schemaMigrateNeedsSingleField:
			"Automatic conversion not possible: the schema must have a single target field.",
		schemaMigrateTitle: "Convert results and unlock the schema",
		schemaMigrateIntro:
			"Results already exist for this conditioning. I can convert the existing free score into the new schema field and unlock the edit.",
		schemaMigrateResultsToConvert: "Results to convert",
		schemaMigrateTargetField: "Target field",
		schemaMigratePrograms: "Programs updated",
		schemaMigrateHint:
			"The free score becomes the new field's value (1:1). The original value is not deleted.",
		schemaMigrateConfirmBtn: "Convert & unlock",
		schemaMigrateDone:
			"Conversion done: {converted} results converted, {programs} programs updated.",
		exercises: "Exercises",
		programs: "Programs",
		workouts: "Workouts",
		diary: "Diary",
		wellnessDiary: "Health diary",
		athletesScopeMine: "Mine",
		athletesScopeShared: "Shared with me",
		athletesScopeAll: "All (admin)",
		wellnessDiaryTitle: "Health diary",
		wellnessDiarySubtitle: "Daily recovery tracking",
		wellnessConfigure: "Settings",
		wellnessTrends: "Trends",
		wellnessEnabled: "Diary enabled",
		wellnessEnabledDescription:
			"The athlete will see the diary and can fill it in every day.",
		wellnessDailyReminder: "Daily reminder",
		wellnessDailyReminderDescription:
			"Show the athlete a reminder until they complete the diary for the day. Turn it off if it feels too intrusive.",
		wellnessConsentPending: "Waiting for the athlete's consent",
		wellnessConsentAccepted: "Consent accepted",
		wellnessNoData: "No data entered yet.",
		wellnessSubjectiveParameters: "Subjective parameters",
		wellnessObjectiveParameters: "Objective parameters",
		wellnessSaveConfiguration: "Save settings",
		wellnessConfigurationSaved: "Settings saved",
		wellnessEnableToCollect: "Enable the diary to collect data.",
		wellnessNoAthleteData: "No data entered by the athlete yet.",
		wellnessLoadError: "Loading error",
		wellnessSaveError: "Save error",
		wellnessUnavailable:
			"The diary is not active. You can configure it and start tracking your recovery whenever you like.",
		wellnessSelfSetupTitle: "Choose what to track",
		wellnessSelfSetupDescription:
			"Choose the indicators you want to record. You can change them later.",
		wellnessActivateDiary: "Enable diary",
		wellnessSelectAtLeastOne: "Select at least one indicator to continue.",
		wellnessInactive: "Inactive",
		wellnessSetupDiary: "Set up diary",
		wellnessActivationError: "Unable to enable diary",
		wellnessBackToDashboard: "Back to dashboard",
		wellnessConsentTitle: "Health diary consent",
		wellnessAcceptAndStart: "I agree and get started",
		wellnessConsentProfileHint:
			"You can turn off tracking and delete your data from your profile at any time.",
		wellnessInsert: "Log",
		wellnessDay: "Day",
		wellnessTodayFilled: "Today completed",
		wellnessFilled: "Completed",
		wellnessToFill: "To complete",
		wellnessDayAlreadyFilled:
			"You have already entered data for this day. You can edit and save it again, or delete it.",
		wellnessWriteHere: "Write here...",
		wellnessUpdate: "Update",
		wellnessRecordedDays: "Recorded days",
		wellnessEditing: "Editing",
		wellnessDeleteDayConfirm: "Delete the data for {date}?",
		wellnessConsentRecorded: "Consent recorded",
		wellnessDataSaved: "Data saved",
		wellnessDataDeleted: "Data deleted",
		wellnessDeleteError: "Error deleting data",
		wellnessDiaryLoadError: "Error loading diary",
		wellnessConsentSaveError: "Error saving consent",
		wellnessAthleteTrendsEmpty:
			"Start filling in the diary to see your trends.",
		wellnessDisableConfirm:
			"Turn off tracking? Previously entered data will remain saved.",
		wellnessDeleteAllConfirm:
			"Permanently delete all health diary data? This action cannot be undone.",
		wellnessTrackingDisabled: "Tracking disabled",
		wellnessConsentToAccept: "Consent required",
		wellnessActive: "Active",
		wellnessPrivacyDescription:
			"Your data is visible only to you and your coach, never publicly. You are in control: you can view it, turn off tracking or delete it.",
		wellnessOpenDiary: "Open diary",
		wellnessDisable: "Turn off",
		wellnessDeleteData: "Delete data",
		wellnessHealthTab: "Health",
		wellnessBulkTitle: "Bulk health diary enablement",
		wellnessBulkDescription:
			"Apply the same configuration to several athletes or whole groups in a single operation.",
		wellnessBulkDisableDescription:
			"The diary disappears from the athlete's view. Entries already filled in and the chosen parameters are kept.",
		wellnessBulkOverwriteWarning:
			"The parameters chosen here replace the ones already configured for the selected athletes.",
		wellnessBulkConsentNotice:
			"Consent cannot be granted in bulk: every athlete still has to accept it before their first entry.",
		wellnessBulkRecipients: "{count} athletes selected",
		wellnessBulkRecipientsEmpty:
			"No athlete selected: pick a group or individual athletes.",
		wellnessBulkRecipientsBreakdown:
			"{active} with the diary already on · {inactive} off",
		wellnessBulkSelectAll: "Select all",
		wellnessBulkClearSelection: "Clear selection",
		wellnessBulkFromGroup: "From group",
		wellnessBulkFromGroupHint:
			"Included because they belong to a selected group.",
		wellnessBulkStepRecipients: "1 · Pick who",
		wellnessBulkStepAction: "2 · What to do",
		wellnessBulkStepSettings: "3 · What to track",
		wellnessBulkActionEnable: "Turn the diary on",
		wellnessBulkActionDisable: "Turn the diary off",
		wellnessBulkGroupMembers: "{count} athletes",
		wellnessBulkGroupActive: "{count} with the diary on",
		wellnessBulkGroupNoneActive: "nobody with the diary on",
		wellnessBulkFilterAll: "All",
		wellnessBulkFilterActive: "Diary on",
		wellnessBulkFilterInactive: "Diary off",
		wellnessBulkApplyEnable: "Enable for selected",
		wellnessBulkApplyDisable: "Disable for selected",
		wellnessBulkApplyEnableCount: "Turn on for {count} athletes",
		wellnessBulkApplyDisableCount: "Turn off for {count} athletes",
		wellnessBulkApplied: "Configuration applied to {count} athletes",
		wellnessBulkSkipped:
			"{count} athletes skipped: they are not among the ones you manage.",
		wellnessBulkPendingConsent:
			"{count} athletes still have to accept the consent.",
		wellnessBulkOpen: "Bulk enablement",
		wellnessError: "Error",
		performance: "Performance",
		library: "Library",
		leaderboard: "Leaderboard",
		profile: "Profile",
		settings: "Settings",
		aiCoach: "AI assistant",
		aiGuideNav: "AI guide",
		logout: "Logout",
		languageLabel: "Language",
		switchAccountLabel: "Switch account",
		textSize: "Text size",
		textSizeSmall: "Small",
		textSizeMedium: "Medium",
		textSizeLarge: "Large",
		themeLabel: "Theme",
		themeDark: "Dark",
		themeLight: "Light",
		accountSwitchSuccess: "Account switched",
		accountSwitchError: "Unable to switch account",
		switchRoleLabel: "Mode",
		roleModeAthlete: "Athlete",
		roleModeCoach: "Coach",
		roleSwitchSuccess: "Mode switched",
		roleSwitchError: "Unable to switch mode",

		// Auth
		login: "Login",
		register: "Register",
		email: "Email",
		password: "Password",
		confirmPassword: "Confirm Password",
		confirmEmail: "Confirm Email",
		name: "Name",
		role: "Role",
		coach: "Coach",
		athlete: "Athlete",
		continueWithGoogle: "Continue with Google",
		sessionExpired: "Your session has expired. Please login again.",

		// Dashboard
		welcome: "Hello",
		readyToTrain: "Ready to train today?",
		totalWorkouts: "Total",
		thisWeek: "This Week",
		personalRecords: "Personal Records",
		goal: "Goal",
		todaysWorkout: "Today's Workout",
		noWorkoutScheduled: "No workout scheduled",
		addToDiary: "Add to diary",
		viewAll: "View all",
		inviteAthleteLink: "Athlete Invite Link",
		inviteAthleteLinkIntro: "Invite an athlete with a ready-to-send link",
		inviteAthleteLinkDescription:
			"Choose an optional group and program, generate the link, and send it by WhatsApp, email, or direct message.",
		createInviteLink: "Create invite link",
		inviteDialogDescription:
			"Set the athlete's initial context and generate a one-time onboarding link.",
		inviteGroupOptional: "Athlete group (optional)",
		inviteProgramOptional: "Program (optional)",
		noGroupOption: "No group",
		noProgramOption: "No program",
		inviteHowItWorksTitle: "How to use it",
		inviteCreateStepSelect:
			"Select a group and program only if you want them preassigned from the first access.",
		inviteCreateStepGenerate:
			"Generate the personal invite link for this athlete.",
		inviteCreateStepSend:
			"Send the link to the athlete: opening it starts guided onboarding or login.",
		inviteCreateOutcomeTitle: "What happens next",
		inviteCreateOutcome:
			"When the athlete uses the link, they are automatically linked to your coach profile and, if selected, also to the chosen group and program.",
		generateInviteLink: "Generate invite link",
		inviteCreating: "Creating link...",
		inviteLinkReady: "Link ready",
		inviteGeneratedHelp:
			"Copy and send this link. On first open, the athlete will see onboarding with automatic coach and assignment linking from this setup.",
		inviteExpiryNoticeTitle: "Invite link expiration",
		inviteExpiryNoticeBody:
			"For security, onboarding invite links expire automatically after 30 days (up to 90 max). If an athlete opens an old link, generate a new invite.",
		inviteExpiresAtLabel: "Expires on",
		copyInviteLink: "Copy",
		inviteLinkCopied: "Link copied",
		inviteTitle: "Onboarding Invite",
		inviteSubtitle:
			"Accept the invite to be linked automatically to your coach and complete onboarding.",
		inviteLoading: "Checking invite...",
		inviteInvalid: "Invalid or expired invite",
		inviteCoachLabel: "Coach",
		inviteGroupLabel: "Group",
		inviteProgramLabel: "Program",
		inviteApplying: "Applying invite...",
		acceptInviteNow: "Accept invite",
		goToLoginToAccept: "Log in or sign up to continue",
		goToPortal: "Go to portal and install application",
		inviteAcceptedSuccess: "Invite applied successfully",
		inviteAcceptFailed: "Unable to apply invite",
		errorLinkClick:
			'If the link is still needed, request a new one from your coach. For proper portal access, install the app using "Add to Home Screen".',

		// Exercises
		exerciseLibrary: "Exercise Library",
		manageExercises: "Manage exercise database",
		newExercise: "New Exercise",
		createExercise: "Create exercise",
		createConditioning: "Create conditioning",
		category: "Category",
		allCategories: "All categories",
		strength: "Strength",
		cardio: "Cardio",
		gymnastics: "Gymnastics",
		olympic: "Olympic",
		accessory: "Accessory",
		description: "Description",
		tags: "Tags",
		noMedia: "No media",

		// Programs
		myPrograms: "My Programs",
		createProgram: "Create Program",
		programBuilder: "Program Builder",
		individual: "Individual",
		group: "Group",
		assignedAthletes: "Assigned Athletes",
		assignAthleteBtn: "Assign athletes",
		noAssignedAthletes: "No athletes assigned",
		days: "Days",
		addDay: "Add Day",
		warmup: "Warmup",
		cooldown: "Cooldown",
		notes: "Notes",
		sets: "Sets",
		reps: "Reps",
		load: "Load",

		// Workout Execution
		startWorkout: "Start Workout",
		progress: "Progress",
		logResult: "Log Result",
		weight: "Weight",
		time: "Time",
		suggestedLoad: "Suggested Load",
		basedOn1RM: "Based on your estimated 1RM",
		showInLeaderboard: "Show in leaderboard",
		finishWorkout: "Finish Workout",
		workoutComplete: "Workout complete!",

		// Profile
		strengthProgression: "Strength Progression",
		workoutFrequency: "Workout Frequency",
		records: "Records",
		history: "History",
		estimated1RM: "Estimated 1RM",
		week: "Week",
		uploadAvatar: "Upload avatar",
		uploadAvatarHint: "Tap the icon to update your profile photo",
		uploadingAvatar: "Uploading avatar...",
		avatarUpdated: "Avatar updated",
		invalidImageType: "Please select a valid image (JPG, PNG, WebP, or GIF)",
		cropPhoto: "Crop photo",
		cropZoom: "Zoom",
		cropConfirm: "Confirm",
		cropCancel: "Cancel",
		memberSince: "Member since",
		personalData: "Personal data",
		nickname: "Nickname",
		nicknamePlaceholder: "What do you want to be called?",
		accountLabel: "Account",
		genderLabel: "Gender",
		selectGender: "Select gender",
		genderMale: "Male",
		genderFemale: "Female",
		genderRequiredWarning:
			"To appear in male/female leaderboards you need to set your gender. Continue without setting it?",
		dateOfBirth: "Date of birth",
		heightCm: "Height (cm)",
		upcomingEvents: "Upcoming Events",
		pastEvents: "Past Events",
		noEventsScheduled: "No upcoming events",
		eventNamePlaceholder: "CrossFit Open 2026",
		eventNotesPlaceholder: "Additional details...",
		fromDiary: "From diary",
		manualLabel: "Manual",
		manualRemovedOn: "Manual · removed on",
		manualValueUnchanged: "Value already saved today, nothing changed",
		manualNoLongerActive: "Manual · no longer active",
		enterManualValue: "Enter manual value",
		removeManualValue: "Remove manual value",

		// AI Assistant
		aiAssistant: "AI Coach",
		aiDescription: "Your AI assistant for training programming",
		chat: "Chat",
		generateProgram: "Generate Program",
		howCanIHelp: "How can I help you?",
		askAnything:
			"Ask me to create programs, suggest progressions, or answer training questions.",
		quickPrompts: "Quick Prompts",
		programParams: "Program Parameters",
		duration: "Duration",
		daysPerWeek: "Days/Week",
		level: "Level",
		focus: "Focus",
		beginner: "Beginner",
		intermediate: "Intermediate",
		advanced: "Advanced",
		additionalNotes: "Additional Notes",
		generating: "Generating...",
		generatedProgram: "Generated Program",
		libraryContext: "Library Context",
		selectDocuments: "Select documents to use as reference",
		noDocumentsSelected: "No documents selected",
		documentsSelected: "documents selected",
		toolCallsUsed: "Tool calls used",
		sourcesUsed: "Sources used",
		estimatedCost: "Estimated cost",
		liveDebug: "Live debug",
		aiModel: "AI model",
		aiAttach: "Attach document",
		aiStop: "Stop generation",
		aiSend: "Send message",
		qualityGates: "Quality gates",
		jsonRepaired: "JSON repaired",
		agentRetryUsed: "Agent retry used",
		parseError: "Parse error",
		activeConstraints: "Active constraints",
		generationTrigger: "Generation trigger",
		coachStructureLocked: "Coach structure locked",
		athleteHistoryContext: "Athlete history context",
		selectedMesocycle: "Selected mesocycle",
		agendaRange: "Agenda range",
		agendaWeeks: "Agenda weeks",
		requestedDurationWeeks: "Requested duration (weeks)",
		requestedSessionsPerWeek: "Requested sessions/week",
		analysisReportAttached: "Analysis report attached",
		cacheHit: "Cache hit",
		plannerUsed: "Planner used",
		plannerModel: "Planner model",
		yesLabel: "Yes",
		noLabel: "No",
		athleteAnalysis: "Athlete Analysis",
		nextMesocycleAthleteContext: "Next mesocycle athlete context",
		nextMesocycleAthleteContextHint:
			"When enabled, program generation uses selected athlete historical results to define progression and priorities.",
		useAthleteHistoricalResults: "Use athlete historical results",
		selectAthleteForMesocycle: "Select athlete for mesocycle",
		selectAthleteForAnalysis: "Select athlete for analysis",
		enabledLabel: "Enabled",
		disabledLabel: "Disabled",
		analysisPrompt: "Analysis prompt",
		analysisPromptPlaceholder:
			"E.g. highlight 30/90-day trends, weaknesses, risk alerts, and what to do in the next mesocycle",
		analyzingAthlete: "Analyzing athlete...",
		runAthleteAnalysis: "Run athlete analysis",
		analysisResult: "Analysis result",
		programReview: "Program Review",
		reviewDraft: "Review draft",
		programId: "Program ID",
		programIdPlaceholder: "Existing program ID (optional)",
		useGeneratedDraftForReview: "Use current generated draft for review",
		reviewPrompt: "Review prompt",
		reviewPromptPlaceholder:
			"E.g. highlight high-severity warnings on progression, movement coverage, and missing prescriptions",
		reviewingProgram: "Reviewing program...",
		runProgramReview: "Run program review",
		reviewResult: "Review result",
		reviewWarnings: "Warnings",
		correctiveActions: "Corrective actions",
		quickWins: "Quick wins",
		applySuggestedFixes: "Apply suggested fixes",
		programReviewEmptyState:
			"Run a review on a generated draft or Program ID to get warnings and actionable fixes.",
		trend30: "30-day trend",
		trend90: "90-day trend",
		riskAlerts: "Risk alerts",
		recommendedActions: "Recommended actions",
		athleteAnalysisEmptyState:
			"Select an athlete and run analysis to get trends, KPIs, and recommended actions.",

		// Library
		coachLibrary: "Coach Library",
		manageLibrary: "Manage your training materials",
		uploadDocument: "Upload Document",
		emptyLibrary: "Empty library",
		uploadFirst: "Upload your first PDF document",
		methodology: "Methodology",
		programming: "Programming",
		nutrition: "Nutrition",
		recovery: "Recovery",
		reference: "Reference",
		other: "Other",

		// Leaderboard
		leaderboardTitle: "Leaderboard",
		leaderboardPrivateLabel: "Private",
		leaderboardPrivateResultHint:
			"Non-public result: visible only to you as a coach, it does not appear in public leaderboards.",
		compareResults: "Compare your results with other athletes",
		noResults: "No results",
		points: "points",

		// PDF Export
		exportPDF: "Export PDF",
		exporting: "Exporting...",

		// Errors
		errorLoading: "Loading error",
		errorLoadingResults: "Error loading results",
		tryAgain: "Try again",

		// Results / History
		noResultsFound: "No results found",
		startLoggingResults: "Start logging results for this exercise",
		mostRecent: "Most recent",
		results: "results",

		// Login hero
		heroTagline: "TRAIN. TRACK.",
		heroTaglineAccent: "DOMINATE.",
		heroDescription:
			"The complete platform for coaches and athletes. Create programs, track progress and achieve your goals.",
		heroDescriptionShort: "The platform for coaches and athletes",

		// Layout / Navigation
		messages: "Messages",

		// Messages page
		communicateLabel: "Communicate with your coach or athletes",
		newMessage: "New Message",
		recipient: "Recipient",
		selectRecipient: "Select recipient",
		general: "General",
		workoutFeedback: "Workout Feedback",
		programFeedback: "Program Feedback",
		messageLabel: "Message",
		subject: "Subject",
		subjectPlaceholder: "Message subject",
		messagePlaceholder: "Write your message...",
		send: "Send",
		inbox: "Inbox",
		sent: "Sent",
		noMessages: "No messages",
		reply: "Reply",
		replyPlaceholder: "Write your reply...",
		sendReply: "Send Reply",
		selectMessageToRead: "Select a message to read",
		fillAllFields: "Fill all fields",
		messageSent: "Message sent!",
		writeReply: "Write a reply",
		replySent: "Reply sent!",
		confirmDeleteMessage: "Delete this message?",
		messageDeleted: "Message deleted",
		conditioning: "Conditioning",
		aiDocs: "AI Docs",
		aiDocsTitle: "AI Training Documents",
		aiDocsSubtitle: "Sources that provide context to the AI assistant.",
		aiDocsDisabledTitle: "AI documents are temporarily disabled",
		aiDocsDisabledBody:
			"You can view them, but cannot create, edit, or manage documents.",
		aiDocsSearchPlaceholder: "Search documents...",
		aiDocsNew: "New document",
		aiDocsActive: "Active",
		aiDocsInactive: "Disabled",
		aiDocsPages: "pages",
		aiDocsCharacters: "characters",
		aiDocsTooLong: "exceeds the AI context limit; its text will be truncated",
		aiDocsWithinLimit: "within the AI context limit",
		aiDocsDeactivate: "Deactivate",
		aiDocsActivate: "Activate",
		aiDocsDeactivateHelp:
			"Deactivate the document so the AI assistant can no longer use it.",
		aiDocsActivateHelp:
			"Reactivate the document to make it available to the AI assistant.",
		aiDocsEditHelp: "Edit the document title, category, and content.",
		aiDocsDeleteHelp: "Permanently delete this training document.",
		aiDocsCategoriesTitle: "AI document categories",
		aiDocsCategoriesSubtitle:
			"Manage category names used by documents and AI filters.",
		aiDocsCategoriesSave: "Save categories",
		aiDocsCategoryName: "Category name",
		aiDocsCategoryUsage: "documents",
		aiDocsCategoryAddPlaceholder: "New category name",
		aiDocsCategoryAdd: "Add category",
		aiDocsCategoryRequired: "The Other category is required",
		aiDocsCategoryUsed: "Reassign documents in this category first",
		aiDocsCategoryRemove: "Remove category",
		aiDocsCategorySaved: "Document categories saved",
		aiDocsCategoryEmpty: "Every category needs a name",
		aiDocsCategoryInvalid: "Enter a valid category name",
		aiDocsCategoryDuplicate: "A category with this name already exists",
		aiDocsDelete: "Delete document",
		aiDocsDeleteAction: "Delete",
		aiDocsDeleteDocument: "Delete document",
		aiDocsManagePermission:
			"Only an admin or the document author can manage it",
		aiDocsDeleteConfirm: "Delete this training document?",
		aiDocsDeleted: "Document deleted",
		aiDocsDeleteError: "Unable to delete the document",
		aiDocsActivated: "Document activated",
		aiDocsDeactivated: "Document deactivated",
		aiDocsRequired: "A title and content, or a PDF, are required",
		aiDocsCreated: "Document created",
		aiDocsSaveError: "Unable to save the document",
		aiDocsLoadError: "Error loading documents",
		aiDocsEmptyTitle: "No training documents",
		aiDocsEmptyBody:
			"Add guidelines, methodologies, and references for AI context.",
		aiDocsNewTitle: "New training document",
		aiDocsEditTitle: "Edit training document",
		aiDocsEntryTitle: "Adding AI documents",
		aiDocsEntryHelp:
			"Paste text or Markdown, or upload a PDF with selectable text. Scanned PDFs are not supported.",
		aiDocsUseHelp:
			"Active documents can be consulted by the AI assistant as additional context.",
		aiDocsTitleLabel: "Title",
		aiDocsTitlePlaceholder: "E.g. Strength periodization guidelines",
		aiDocsCategory: "Category",
		aiDocsSourceText: "Text",
		aiDocsSourcePdf: "Upload PDF",
		aiDocsPdfLabel: "PDF file",
		aiDocsPdfHint: "Select a text-based PDF to extract its content.",
		aiDocsContentLabel: "Content",
		aiDocsContentPlaceholder: "Paste guidelines as text or Markdown.",
		aiDocsSaving: "Saving...",
		aiDocsSaveChanges: "Save changes",
		aiDocsCreate: "Create document",
		billing: "Payments",

		// Desktop sidebar / command palette
		navGroupCoaching: "Coaching",
		navGroupTraining: "Training",
		navGroupAi: "Artificial intelligence",
		navGroupManagement: "Management",
		navSearch: "Search",
		navSearchPlaceholder: "Search a section or an action...",
		navSearchEmpty: "No results",
		navSearchSections: "Sections",
		navSearchActions: "Quick actions",
		navPinSidebar: "Pin the menu",
		navUnpinSidebar: "Collapse the menu",
		navMenu: "Menu",
		payments: "Payments",
		invoices: "Invoices",
		invoice: "Invoice",
		products: "Products",
		paymentPlans: "Recurring plans",
		overview: "Overview",
		createInvoice: "Create invoice",
		newProduct: "New product",
		editProduct: "Edit product",
		productName: "Product name",
		recordPayment: "Record payment",
		issueInvoice: "Issue",
		voidInvoice: "Void invoice",
		dueDate: "Due date",
		amount: "Amount",
		quantity: "Quantity",
		unitPrice: "Unit price",
		lineDescription: "Description",
		addLineItem: "Add line",
		lineItems: "Items",
		payer: "Athlete",
		billingNotes: "Notes",
		selectAthlete: "Select athlete",
		searchAthlete: "Search by name or email...",
		noAthleteFound: "No athlete found",
		selectProduct: "Product (optional)",
		customLineItem: "Custom item",
		total: "Total",
		amountDue: "Due",
		amountPaid: "Paid",
		statusDraft: "Draft",
		statusOpen: "Open",
		statusPartiallyPaid: "Partially paid",
		statusPaid: "Paid",
		statusOverdue: "Overdue",
		statusVoid: "Void",
		statusRefunded: "Refunded",
		collected: "Collected",
		toCollect: "To collect",
		overdueAmount: "Overdue",
		recentPayments: "Recent payments",
		paymentMethod: "Method",
		methodCash: "Cash",
		methodBankTransfer: "Bank transfer",
		methodPos: "POS",
		methodOther: "Other",
		refund: "Refund",
		refundAmount: "Refund amount",
		noInvoices: "No invoices",
		noProducts: "No products",
		noPayments: "No payments",
		myPayments: "My payments",
		toPay: "To pay",
		paymentHistory: "History",
		paymentStatus: "Status",
		paymentActions: "Actions",
		paymentDate: "Date",
		paymentSaved: "Payment recorded",
		invoiceCreated: "Invoice created",
		invoiceIssued: "Invoice issued",
		invoiceVoided: "Invoice voided",
		editInvoice: "Edit invoice",
		invoiceUpdated: "Invoice updated",
		lineItemsLockedHint:
			"Payments have already been recorded: refund them first to edit line items.",
		refundSaved: "Refund recorded",
		refundHint: "Amount collected:",
		filterByAthlete: "Filter by athlete",
		filterByStatus: "Filter by status",
		allStatuses: "All statuses",
		paymentStatusPending: "Pending",
		paymentStatusSucceeded: "Succeeded",
		paymentStatusFailed: "Failed",
		paymentStatusCanceled: "Canceled",
		paymentStatusRefunded: "Refunded",
		paymentStatusPartiallyRefunded: "Partially refunded",
		onlinePayments: "Online payments",
		stripeNotConfigured:
			"Online payments are not enabled on the platform yet. Contact the administrator.",
		stripeConnectIntro:
			"Connect your Stripe account to let athletes pay online: funds go straight to your Stripe account.",
		connectStripe: "Connect Stripe",
		completeSetup: "Complete setup",
		refreshStatus: "Refresh status",
		statusUpdated: "Status updated",
		connectActive: "Active",
		connectOnboarding: "Onboarding",
		connectNotConnected: "Not connected",
		connectActiveHint: "Athletes can pay your invoices online.",
		externalPaymentLink: "External payment link",
		externalPaymentLinkIntro:
			"As an alternative to Stripe Connect, paste your own payment link here (Stripe Payment Link, PayPal.me, SumUp, Satispay...). The athlete will be redirected there to pay; afterwards you must record the payment manually on the invoice.",
		externalPaymentLinkLabel: "Payment link URL",
		externalLinkSaved: "Payment link saved",
		externalPaymentRedirectHint:
			"We opened the coach's payment page in a new tab. The coach will confirm the payment once received.",
		payNow: "Pay now",
		allAthletes: "All athletes",
		dateFrom: "From",
		dateTo: "To",
		resetFilters: "Reset filters",
		invoiceDate: "Invoice date",
		pickDate: "Pick a date",
		subtotal: "Subtotal",
		vat: "VAT",
		vatRate: "VAT rate",
		vatNotFiscalHint:
			"Informational per-line VAT calculation only — does not generate any fiscal document (e-invoicing excluded).",
		productSaved: "Product saved",
		confirmVoidInvoice: "Void this invoice?",
		athletePaymentsHint:
			"Invoices issued by your coach. Payments are recorded by the coach.",
		admin: "Admin",
		manageCookies: "Manage Cookies",

		// Login
		welcomeBack: "Welcome",
		loginSubtitle: "Login or create an account to continue",
		orWith: "Or",
		loggingIn: "Logging in...",
		registering: "Registering...",
		yourName: "Your name",
		surname: "Surname",
		yourSurname: "Your surname",
		newAccountNote:
			"New accounts are created as athlete. Coach role is assigned by admin.",
		signupOptionalProfileTitle: "Profile details",
		signupOptionalProfileHint:
			"You can fill these fields now for both email registration and Google signup.",
		registerSportPlaceholder: "e.g. CrossFit, Running, Hyrox",
		passwordsDoNotMatch: "Passwords do not match",
		emailsDoNotMatch: "Emails do not match",
		passwordTooShort: "Password must be at least 6 characters",
		saving: "Saving...",
		sending: "Sending...",
		genericError: "Something went wrong. Please try again.",
		newPassword: "New password",
		currentPassword: "Current password",
		newEmail: "New email",
		goToLogin: "Go to login",
		backToLogin: "Back to login",
		forgotPasswordLink: "Forgot password?",
		forgotPasswordEnterEmail: "Enter your email in the field above first.",
		forgotPasswordSent:
			"If the email is registered, you'll receive a reset link.",
		resetPasswordTitle: "Reset password",
		resetPasswordSubtitle: "Choose a new password for your account.",
		resetPasswordInvalidLink: "Invalid or missing link.",
		resetPasswordSuccess: "Password updated. You can now log in.",
		resetPasswordError: "Invalid or expired link. Request a new one.",
		resetPasswordCta: "Reset password",
		verifyEmailTitle: "Confirm email",
		verifyEmailLoading: "Confirming...",
		verifyEmailSuccess: "Email updated successfully.",
		verifyEmailError: "Invalid or expired link.",
		verifyEmailInvalidLink: "Invalid or missing link.",
		changeEmailCta: "Change email",
		changeEmailHint:
			"We'll send a confirmation link to the new address. Your email changes only after you confirm.",
		changeEmailSubmit: "Send confirmation",
		changeEmailSent: "We sent a confirmation email to the new address.",
		changeEmailEmailDisabled:
			"Email sending is not configured: contact support to complete the change.",
		googleLoginError: "Error during Google login",
		loginNavigationCloneError:
			"Login succeeded, but the browser blocked automatic navigation. Try again or close and reopen the app.",
		loginNavigationCloneFallback:
			"Temporary PWA app issue detected: completing sign-in with a direct redirect.",
		googleOnlyAccountError:
			'This account was created with Google. Use the "Continue with Google" button to sign in.',
		completeProfileAfterGoogle: "Complete your profile to finish setup.",

		// Common actions
		open: "Open",
		rename: "Rename",
		moveToFolder: "Move to Folder",
		saveChanges: "Save Changes",
		errorSavingChanges: "Error saving changes",
		type: "Type",
		date: "Date",
		competitionCalendarTab: "Competition Calendar",
		competitionCalendarTabShort: "Events",
		shootingLeaderboards: "Shooting rankings",
		shootingDrills: "Drill library",
		shootingConfig: "Shooting config",
		mode: "Mode",
		noneOption: "None",
		folder: "Folder",
		root: "Root",
		remove: "Remove",

		// Programs
		programDomainPhysical: "Physical",
		programDomainShooting: "Shooting",
		programDomainHybrid: "Hybrid",
		programScopeMine: "Mine",
		programSharedBadge: "Shared",
		programScopeShared: "Shared with me",
		programScopeAll: "All (admin)",
		programReorder: "Reorder",
		programsMoreActions: "More actions",
		programReorderDone: "Finish reordering",
		programReorderOwnOnly: "You can only reorder your own programs.",
		programDragMoveHint:
			"Drag a program or a folder onto a folder, or onto a breadcrumb level, to move it.",
		programFolderCount: "folders",
		programCount: "programs",
		programSharing: "Sharing",
		programVisibleViaSharing: "Visible via sharing",
		folderSharingTitle: "Folder sharing",
		saveSharing: "Save sharing",
		programVisibilityOwner: "Mine",
		programVisibilitySharedDirect: "Shared directly",
		programVisibilitySharedTeam: "Shared via coach team",
		programVisibilityShared: "Shared",
		programViewReadonlyBadge: "Read-only",
		programViewReadonlyNote:
			"You can read this program but not change it: only the coach who created it can.",
		programViewSharedVia: "Shared by team",
		programViewDuplicate: "Duplicate into my library",
		programViewDuplicated: "Program duplicated into your library",
		programViewBack: "Back to programs",
		programViewNoWeeks: "This program has no weeks yet.",
		programViewLoadError: "Program not available",
		groupSharingOwnerOnly:
			"Only the coach who created the group can change its sharing.",
		coachTeams: "Coach teams",
		coachTeamsSubtitle:
			"The teams you use to share programs, folders and athlete groups with other coaches.",
		coachTeamsNew: "New team",
		coachTeamsNewHint:
			"You become its owner: you will be able to add coaches and assign them your athletes.",
		coachTeamsNamePlaceholder: "e.g. North Gym, Competitor staff",
		coachTeamsGuideTitle: "How coach teams work",
		coachTeamsGuideShow: "How do they work?",
		coachTeamsGuideWhat: "What a coach team is",
		coachTeamsGuideWhatBody:
			"A group of coaches who work together, for example the trainers of a gym. It lets you share material and athletes without doing it one person at a time: share with the team and it applies to everyone in it, including whoever joins tomorrow.",
		coachTeamsGuideOwner: "If the team is yours",
		coachTeamsGuideOwnerBody:
			"You created it, so you administer it: you can rename it, add and remove coaches, assign your athletes to it and delete it. No other coach in the team can.",
		coachTeamsGuideMember: "If you were added",
		coachTeamsGuideMemberBody:
			"You see the team, the colleagues in it and everything shared with it. You cannot administer it: that belongs to the coach who created it.",
		coachTeamsGuideShare: "What coaches in the team can do",
		coachTeamsGuideShareBody:
			"Read the programs and folders shared with the team, and duplicate them into their own library to work on them. They cannot change your programs: sharing is read-only, so nobody deletes someone else's work. On shared athlete groups, instead, they manage the athletes alongside you.",
		coachTeamsGuideAdd: "How to add a coach",
		coachTeamsGuideAddBody:
			"You can add colleagues from teams you already belong to, or one of your athletes whose coach mode the administrator has enabled. To bring in a new trainer: invite them as an athlete with your invite link, ask the administrator to enable coach mode, then add them here.",
		coachTeamsEmpty:
			"You are not part of any team yet. Create one to share programs and athletes with other coaches.",
		coachTeamsOwnerBadge: "Your team",
		coachTeamsOwnerShort: "owner",
		coachTeamsOwnerLabel: "Owner",
		coachTeamsNoOwner: "Platform team (no owner)",
		adminCoachAthletesSummary: "{direct} directly assigned · {shared} shared",
		adminCoachAthletesSelfNote:
			"The coach's own athlete profile is not counted: it is used to assign programs to themselves and goes away by disabling coach mode.",
		adminCoachAthletesTabDirect: "Direct",
		adminCoachAthletesTabShared: "Shared",
		adminCoachAthletesTabAdd: "Add",
		adminCoachAthletesDirectEmpty: "No directly assigned athletes.",
		adminCoachAthletesSharedEmpty:
			"No athletes shared through teams or groups.",
		adminCoachAthletesSharedHint:
			"The coach manages them because they belong to a group or a team shared with them. They are not removed here: remove the athlete from the group or the team.",
		adminCoachAthletesViaTeam: "Team",
		adminCoachAthletesGroupOwner: "by {name}",
		adminCoachAthletesTeamBucketMeta:
			"Assigned to the team, outside shared groups",
		adminCoachAthletesAddHint:
			"Search by name or email for an athlete to assign directly to this coach.",
		adminCoachAthletesAddMore:
			"Showing the first {count} results: refine the search.",
		adminCoachAthletesDirectStat: "Direct",
		adminCoachAthletesSharedStat: "+{count} shared",
		adminCoachAthletesNotDirect:
			"This athlete is not directly assigned to this coach: they come from a team or a shared group.",
		coachTeamsOwnerUnavailable: "Account unavailable",
		coachTeamsMemberBadge: "You are a member",
		coachTeamsPlatformBadge: "Managed by the administrator",
		coachTeamsMembers: "Team coaches and athletes",
		coachTeamsCoaches: "Coaches",
		coachTeamsAthletes: "Athletes assigned to the team",
		coachTeamsCoachCount: "Coaches",
		coachTeamsAthleteCount: "Athletes",
		coachTeamsSharedFolders: "Shared folders",
		coachTeamsSharedPrograms: "Shared programs",
		coachTeamsSharedGroups: "Shared groups",
		coachTeamsAddCoach: "Add a coach",
		coachTeamsNoCandidates: "No coach available",
		coachTeamsAddAthletes: "Assign athletes",
		coachTeamsAddAthletesHint:
			"Athletes assigned to the team are visible and manageable by every coach in it.",
		coachTeamsNoAthletes: "No athlete assigned to this team.",
		coachTeamsNoAthletesToAdd: "No athlete to add.",
		coachTeamsAthletesSkipped:
			"Some athletes were not assigned: you can only assign your own.",
		coachTeamsCreated: "Team created",
		coachTeamsDeleted: "Team deleted",
		coachTeamsDeleteConfirm:
			"Delete this team? Programs, folders and groups shared with it will stop being shared. No content is deleted.",
		programSearchPlaceholder: "Search programs...",
		programSortNewest: "Newest first",
		programSortOldest: "Oldest first",
		programSortAlphabetical: "Alphabetical",
		team: "Team",
		teams: "Teams",
		newProgram: "New Program",
		newFolder: "New Folder",
		renameFolder: "Rename Folder",
		emptyFolder: "Empty folder",
		noPrograms: "No programs",
		addToFolder: "Add programs or sub-folders",
		createFirstProgram: "Start by creating your first training program",
		trashBin: "Trash",
		trashBinDesc: "Recently deleted programs",
		noDeletedPrograms: "Trash is empty",
		noDeletedProgramsDesc: "Deleted programs will appear here",
		restoreProgram: "Restore",
		permanentlyDelete: "Delete permanently",
		backToPrograms: "Back to programs",
		pbProgramSettings: "Details & assignments",
		pbGroupShowAthletes: "Show/hide the group's athletes",
		pbGroupNoAthletes: "Empty group",
		pbGroupHiddenAthletes: "not visible to you",
		pbExerciseActions: "Exercise actions",
		pbExerciseToggleEditor: "Open/close the exercise editor",
		pbActionEditExercise: "Edit exercise",
		pbActionAddSetRow: "Add set row",
		pbActionMoveUp: "Move up",
		pbActionMoveDown: "Move down",
		pbActionLeaderboardOn: "Enable leaderboard",
		pbActionLeaderboardOff: "Disable leaderboard",
		pbActionResultEntryOn: "Enable result entry",
		pbActionResultEntryOff: "Disable result entry",
		pbActionCopyExercise: "Copy exercise",
		pbActionExportExercise: "Export exercise",
		pbActionShareExercise: "Share exercise",
		pbActionDuplicateNextWeek: "Duplicate to next week",
		pbActionRemoveExercise: "Remove exercise",
		pbDayActions: "Day actions",
		pbWeekActions: "Week settings",
		pbDayActionEdit: "Edit title and date",
		pbDayActionEditClose: "Close title and date editing",
		pbDayActionDuplicate: "Duplicate day",
		pbDayActionExport: "Export day",
		pbDayActionRemove: "Delete day",
		pbHideSettings: "Hide panel",
		pbHideSettingsHint:
			"Hides the details / athletes / access column so the editor gets more width. Still reachable from the same button.",
		pbProgramSettingsHint:
			"Program title, type and dates, assigned athletes and groups, other coaches' access",
		pbShowSettingsColumn: "Always show as column",
		pbSettingsInSheetHint:
			"While the side panel is open, settings stay here so the editor keeps its width.",
		pbWideModeOn: "Use full width",
		pbWideModeOff: "Back to standard width",
		// Season strip (docs/program-builder-season-strip)
		pbSeasonStripOn: "Show phases and competitions on the weeks",
		pbWeekViewOverview: "Week overview in columns",
		pbWeekViewEditor: "Back to the editor",
		pbWeekOverviewOpenDay: "Open in the editor",
		pbWeekOverviewHint:
			"Read-only view: click a day to edit it in the editor. You can drop exercises here from the reference panel.",
		pbSeasonBandLabel: "Mesocycle planning",
		pbDockAgenda: "Agenda",
		pbSeasonFollowEditorOn: "Follows the week open in the editor",
		pbSeasonFollowEditorOff: "Fixed month: enable to follow the editor",
		pbSeasonOpenAthlete: "Open athlete page",
		pbSeasonAgendaHint:
			"The week open in the editor is highlighted on the calendar.",
		pbSeasonStripOff: "Hide phases and competitions",
		pbSeasonNoPhases: "No phase planned",
		pbDeleteWeekTitle: "Delete week",
		pbDeleteWeekBody:
			"This program is dated: the weeks after this one can move back to close the hole it leaves, or stay on their dates.",
		pbDeleteWeekKeepDates: "Delete and keep the dates",
		pbDeleteWeekShiftDates: "Delete and move back by",
		pbDeleteWeekLoading: "Loading the following weeks…",
		pbSeasonAgendaError: "Agenda not loaded",
		pbSeasonAgendaRetry: "Retry",
		pbSeasonPlan: "Plan",
		pbSeasonPlanAthleteHint: "Open the planning in the side panel",
		pbSeasonPlanGroupHint: "Open the competition calendar in a new tab",
		pbSeasonGroupBadge: "Group",
		mesocycleGroupReadonly: "Group phase: edit it from the group planning",
		competitionHubPickGroup: "Add every athlete of a group",
		pbSeasonNoCompetitions: "No upcoming competitions",
		pbSeasonIn: "in",
		pbSeasonDaysShort: "d",
		pbSeasonToday: "today",
		pbSeasonTomorrow: "tomorrow",
		pbSeasonOngoing: "ongoing",
		pbSeasonAthletes: "athletes",
		pbSeasonAthleteSelector: "Agenda of",
		pbCopyDay: "Copy day",
		pbPaste: "Paste",
		pbClipboardOneItem: "1 exercise on the clipboard",
		pbClipboardManyItems: "exercises on the clipboard",
		pbClipboardClear: "Clear clipboard",
		pbClipboardCopiedOne: "Exercise copied",
		pbClipboardCopiedMany: "exercises copied",
		pbClipboardPastedOne: "Exercise pasted",
		pbClipboardPastedMany: "exercises pasted",
		pbClipboardNothingToCopy: "No copyable exercise in this day",
		pbClipboardNotShared:
			"Clipboard not shared with other browser tabs (storage unavailable)",
		pbDockReference: "Reference",
		pbOpenReference: "Compare",
		pbOpenReferenceHint:
			"Open another program side by side to compare weeks and copy exercises",
		pbDockAi: "AI",
		pbDockClose: "Close panel",
		pbDockResize: "Resize panel",
		pbSourceThisProgram: "This program",
		pbSourceOtherProgram: "Other program",
		pbSourceSearch: "Search program...",
		pbSourceUntitled: "Untitled program",
		pbSourceNoResults: "No program found",
		pbSourceLoadFailed: "Could not load programs",
		pbSourceAllPrograms: "All programs",
		pbSourceEmptyFolder: "Empty folder",
		pbRetry: "Retry",
		pbSwapWithEditor: "Swap with the editor: edit this program",
		pbSwapSaveFirst: "Save the program before swapping it with the reference",
		pbSwapConfirmTitle: "Unsaved changes",
		pbSwapConfirmBody:
			"This program has unsaved changes. Save them to open the reference program in the editor, keeping this one as reference.",
		pbSwapSaveAndSwap: "Save and swap",
		pbReferenceJumpToDay: "Go to this day in the editor",
		pbDeltaVsReference: "Compared to the reference week:",
		pbDeltaVsPreviousWeek: "Compared with the previous week",
		pbDeltaTopLoad: "top load",
		pbDeltaSameTopLoad: "same top load",
		pbViewWeek: "Week view",
		pbViewProgression: "Progression view",
		pbProgressionEmpty: "No exercise to compare",
		pbProgressionGoToCell: "Go to this week in the editor",
		pbProgressionCloseDetail: "Close detail",
		pbProgressionFullscreen: "Open the matrix full screen",
		pbProgressionLegend:
			"Arrows compare the top percentage load against the previous week. No arrow is shown where the load is not a percentage.",
		pbReferenceFollowOn: "Follows the editor (previous week)",
		pbReferenceFollowOff: "Pinned week: turn on to follow the editor",
		pbReferenceSelect: "Select multiple exercises",
		pbReferenceCopySelection: "Copy",
		pbReferenceCopyExercise: "Copy exercise to clipboard",
		pbReferenceCopyDay: "Copy day to clipboard",
		pbReferenceEditorWeek: "Week open in the editor",
		pbReferenceSharedReadonly: "Shared read-only exercise",
		pbReferenceEmptyWeek: "This week has no days",
		pbReferenceEmptyDay: "No exercise",
		pbReferenceNoWeeks: "This program has no weeks",
		pbReferencePickSource: "Pick a program to compare",
		pbReferenceLoadError: "Could not load the program",
		pbReferenceReadOnlyHint:
			"Read-only: use the clipboard to bring exercises into the editor",
		pbReferenceUnsavedHint:
			"Program not saved yet: the reference shows your current edits",
		deletedOn: "Deleted on",
		movedToTrash: "Program moved to trash",
		programRestored: "Program restored",
		programPermanentlyDeleted: "Program permanently deleted",
		confirmPermanentDelete:
			"This program will be permanently deleted and cannot be recovered. Continue?",
		assignGroups: "Assign Groups",
		datedMode: "Dated (calendar)",
		datedModeRecommended: "Recommended: dated",
		undatedMode: "Undated (sequential)",
		datedModeHint:
			"Days have real dates: in the builder you choose when it starts, then each week appears to athletes by itself the Sunday before and hides after its Sunday. Change it in Details.",
		undatedModeHint:
			"Sequential days without dates, to reuse for several athletes at different times: you publish the weeks yourself.",
		sortNewest: "Most recent",
		sortOldest: "Least recent",
		sortAlpha: "Alphabetical",
		titleLabel: "Title",
		editProgram: "Edit program",
		programsLoadError: "Error loading programs",
		programCreatedSuccess: "Program created successfully",
		programDuplicated: "Program duplicated",
		programDeleted: "Program deleted",
		confirmDeleteProgram: "Are you sure you want to delete this program?",
		pdfExported: "PDF exported successfully!",
		exporting: "Exporting...",
		exportPdf: "Export PDF",
		duplicateProgram: "Duplicate program",
		exportError: "Export error",
		folderCreated: "Folder created",
		folderRenamed: "Folder renamed",
		folderDeleted: "Folder deleted",
		folderMoved: "Folder moved",
		confirmDeleteFolder:
			"Delete this folder? Contents will be moved to the parent folder.",
		programMoved: "Program moved",
		programTitlePlaceholder: "4-Week Strength Program",
		programDescriptionPlaceholder: "Program description...",
		createIn: "Will be created in",
		inLabel: "In",
		folderNamePlaceholder: "Folder name",
		rootNoFolder: "Root (no folder)",
		daysLabel: "days",
		athletesLabel: "athletes",
		createdByLabel: "Created by",
		createdOnLabel: "Created on",

		// Athletes
		manageAthletes: "Manage your athletes and monitor their progress",
		editAthlete: "Edit Athlete",
		sportLabel: "Sport",
		weightKg: "Weight (kg)",
		searchAthletes: "Search athletes...",
		selectSport: "Select sport",
		sportsMultiHint:
			"You can pick more than one. The first is your main sport and opens the performance profile.",
		sportPrimaryBadge: "Main",
		performanceNoDomainsForSport:
			"No domains configured for this discipline yet.",
		performanceNoSportTitle: "No sport configured",
		performanceNoSportHint:
			"The performance profile is organised by discipline: until you pick one you cannot enter your maxes, and percentage-based loads stay estimated from your diary results.",
		performanceNoSportCta: "Pick your discipline",
		performanceNoSportCoachHint:
			"This athlete has not picked a discipline yet: the performance profile stays empty and their manual maxes cannot be entered. Percentage-based loads are estimated from diary results.",
		notesPlaceholder: "Athlete notes...",
		openPerformanceProfile: "Open performance profile",
		// In-app explanation: what choosing a sport changes (athlete) and what
		// following a discipline changes (coach). Spec: docs/sport-config/ANALYSIS.md §1.3
		sportsNoneConfigured: "No discipline configured yet.",
		sportsFilterAll: "All sports",
		sportsExplainTitle: "What choosing a sport changes",
		sportsExplainProfile: "The performance profile",
		sportsExplainProfileBody:
			"Each sport has its own, with its own domains, tests and reference tables: the system one, or the coach's if they published one. With several sports there is one tab per sport. A max counts in every sport that uses that exercise, but the level can differ because the tables differ.",
		sportsExplainLeaderboards: "Leaderboards",
		sportsExplainLeaderboardsBody:
			"Athletes appear in the performance-profile leaderboards of every sport they practise, only if their performance is public.",
		sportsExplainSections: "Profile tabs",
		sportsExplainSectionsBody:
			"Shooting disciplines add the Shooting tab, with firearms and merit classes; physical-preparation disciplines add the Exercises tab, with records and maxes.",
		sportsExplainCompetitions: "Race calendar",
		sportsExplainCompetitionsBody:
			"It suggests the races entered by athletes of the same coaches who practise at least one of the same sports, plus those of group mates.",
		sportsExplainPrimary: "Main sport",
		sportsExplainPrimaryBody:
			"It is the first in the list: the performance profile opens on it. Remove it and the next one becomes the main sport.",
		sportsExplainUnchanged: "What does not change",
		sportsExplainUnchangedBody:
			"Programs, logged results and entered maxes. Removing a sport deletes nothing: it leaves the profile and the leaderboards, and adding it back restores everything.",
		sportsExplainCoachNote:
			"The coach can change them here, or the athlete from their profile: the last save wins. When an athlete's performance profile is empty, the missing sport is usually why.",
		coachDisciplinesExplainTitle:
			"What following a discipline changes for a coach",
		coachDisciplinesExplainWhat: "What it decides",
		coachDisciplinesExplainWhatBody:
			"The sports the coach can create their own performance model for, in Sports and models. The coach picks them; shooting ones are assigned by the admin.",
		coachDisciplinesExplainScope: "Shooting",
		coachDisciplinesExplainScopeBody:
			"Shooting disciplines are the only ones that change the interface: they add drills, dry fire, live fire and shooting leaderboards. Without a shooting discipline the coach does not see these sections.",
		coachDisciplinesExplainEmpty: "No selection",
		coachDisciplinesExplainEmptyBody:
			"The coach works on physical preparation as usual, but cannot create models of their own until they pick at least one sport.",
		coachDisciplinesExplainData: "What it does not limit",
		coachDisciplinesExplainDataBody:
			"It is not a permission and filters no data: the coach keeps seeing their athletes, shared programs and each athlete's full performance profile, even for sports they don't follow.",
		coachDisciplinesExplainConfigure: "“Can configure” is something else",
		coachDisciplinesExplainConfigureBody:
			"It lets the coach edit a discipline's reference data — weight classes and, for shooting, divisions, classes and scoring systems — without being an admin. The system performance model stays with the admin: a coach who wants a different profile creates their own. It grants no access to users, teams or programs.",
		ppSystemModelGlobalOnly:
			"The system model only uses exercises and conditioning from the global library. To use a personal one, make it global first from Library collaboration.",
		// Performance model editor (components/performance/PerformanceModelEditor.js)
		pmNewDomain: "New domain",
		pmTablesLabel: "Reference tables",
		pmTablesByGender: "By gender",
		pmTablesByDivision: "By gender and division",
		pmExercisesCount: "{count} exercises",
		pmScale: "Scale",
		pmEditDomainHint: "Edit domain and score scale",
		pmDeleteDomain: "Delete domain",
		pmScoreScale: "Score scale",
		pmScaleMinColumns: "Numbers only · at least {n} columns",
		pmScaleAddPlaceholder: "e.g. 20",
		pmAdd: "Add",
		pmScaleHelp1: "To rewrite the whole scale at once use",
		pmEditDomain: "Edit domain",
		pmScaleHelp2:
			"Here, add the new values before removing the old ones: below {n} columns the score can no longer be interpolated.",
		pmRemoveColumn: "Remove column {score}",
		pmRemoveColumnBlocked:
			"At least {n} columns are needed: add a new one before removing this one",
		pmReferences: "References",
		pmMale: "Male",
		pmFemale: "Female",
		pmDivision: "Division",
		pmDivisionEmptyHint: "Empty cells: this division uses the gender table.",
		pmColExercise: "Exercise",
		pmColUnit: "Unit",
		pmColActions: "Actions",
		pmMoveUp: "Move up",
		pmMoveDown: "Move down",
		pmRemoveExercise: "Remove exercise",
		pmNoExercises: "No exercises configured",
		pmNoExercisesHint: "Add exercises or conditioning from the library",
		pmAddExercise: "Add exercise or conditioning",
		pmNoDomains: "No domains configured",
		pmNoDomainsHint:
			"Create domains such as “Max strength”, “Power”, “Endurance” and add the exercises that measure them.",
		pmCreateFirstDomain: "Create the first domain",
		pmUnitKg: "Kg",
		pmUnitReps: "Reps",
		pmUnitSeconds: "Seconds",
		pmUnitMinutes: "Minutes",
		pmUnitMinSec: "Minutes and seconds",
		pmUnitHitFactor: "Hit factor (points/time)",
		pmUnitMeters: "Meters",
		pmUnitPoints: "Points",
		pmErrScaleValueRequired: "Enter the value to add to the scale",
		pmErrNotNumber:
			"“{value}” is not a number: the scale only accepts numbers, for example 1, 5, 10, 15.",
		pmErrColumnExists: "Column {score} is already in the scale",
		pmColumnAdded: "Column {score} added",
		pmErrMinColumns:
			"At least {n} columns are needed to interpolate the score: add the new values before removing these.",
		pmColumnRemoved: "Column {score} removed",
		pmErrFormat: "Invalid format. Use: {format}",
		pmErrDomainName: "The domain name is required",
		pmErrScaleInvalid:
			"Invalid scale: {values}. Use only comma-separated numbers, for example 1, 5, 10, 15.",
		pmErrScaleMin: "The scale needs at least {n} numeric scores.",
		pmDomainUpdated: "Domain updated",
		pmDomainCreated: "Domain created",
		pmConfirmDeleteDomain: "Delete this domain and all its exercises?",
		pmDomainDeleted: "Domain deleted",
		pmExerciseAdded: "{name} added",
		pmExerciseRemoved: "Exercise removed",
		pmUnitUpdated: "Unit updated",
		pmOrderUpdated: "Order updated",
		pmSegmentationUpdated: "Tables updated",
		pmDomainDialogEdit: "Edit domain",
		pmDomainDialogNew: "New domain",
		pmDomainName: "Domain name *",
		pmDomainNamePlaceholder: "E.g. Max strength",
		pmDomainDescription: "Description",
		pmDomainDescriptionPlaceholder: "Optional",
		pmDomainDescriptionHint:
			"Coaches and athletes read it in the profile's «How to read the levels» guide: the place to say where the thresholds come from.",
		pmDomainColor: "Colour",
		pmDomainScale: "Score scale *",
		pmDomainScaleHelp:
			"Only comma-separated numbers, at least {n}. They are the levels of the scale, for example 1, 5, 10, 15: for each exercise enter the reference of each level, and the athlete's score is interpolated between them.",
		pmDomainScaleEditWarning:
			"Removing a level hides the references already entered on it, and they are discarded the next time the exercise is saved.",
		pmSaving: "Saving…",
		pmSaveChanges: "Save changes",
		pmCreateDomain: "Create domain",
		pmCategory: "Category",
		pmAllCategories: "All categories",
		// Sports and models section (docs/sport-config, phase 2)
		sportConfigNav: "Sports and models",
		scTitle: "Sports and models",
		scSubtitle:
			"The sports you coach and the models you assess your athletes with.",
		scGuideShow: "How does it work?",
		scGuideTitle: "How this section works",
		scGuideSports: "The sports you follow",
		scGuideSportsBody:
			"Pick the sports you coach: they are the ones you can build your own performance model for. They do not change what you see in the rest of the platform, nor of your athletes.",
		scGuideModel: "The performance model",
		scGuideModelBody:
			"It is the grid an athlete is assessed with in a sport: domains, tests and levels, from beginner to competitor. The system model is the same for everyone; you can create your own, starting from the system one or from scratch.",
		scGuidePublish: "Publishing and withdrawing",
		scGuidePublishBody:
			"Your model starts unpublished: build it calmly, changes are saved right away. Once published it applies to your athletes in that sport instead of the system one; if you withdraw it they go back to the system model. Athletes' maxes and results do not change: only how they are read.",
		scGuideTeam: "In a team",
		scGuideTeamBody:
			"The coaches in your team see your published model but cannot edit it. If an athlete is followed by two coaches with two different models, they stay on the system one until one of the coaches picks a model by hand from their profile.",
		scFollowedTitle: "The sports you follow",
		scFollowedHint: "These are the sports you can create your own model for.",
		scShootingLocked: "Shooting disciplines are assigned by the admin.",
		scSaveSports: "Save",
		scSportsSaved: "Sports updated",
		scNoSports: "Pick at least one sport you follow to see its models.",
		scYourAthletes: "{count} of your athletes",
		scNotFollowed: "No longer followed",
		scEdit: "Edit",
		scOpen: "Open",
		scWithdraw: "Withdraw",
		scPublish: "Publish",
		scDelete: "Delete",
		scNoOwnModel:
			"You have no model of your own for this sport: your athletes use the system one.",
		scCreateFromSystem: "Create yours from the system model",
		scCreateEmpty: "Create empty",
		scTeamConflictHint:
			"A colleague in your team already has a published model: if you publish yours too, the athletes you share go back to the system model until one of you picks by hand.",
		scTeamModels: "Your team's models",
		scModelCreated: "Model created, not published yet",
		scConfirmWithdraw:
			"Withdrawing the model sends your athletes back to the system model. Continue?",
		scModelWithdrawn: "Model withdrawn",
		scConfirmDelete:
			"Delete the model with all its domains and tests? Athletes' values are kept.",
		scModelDeleted: "Model deleted",
		scModelPublished: "Model published",
		scSystemModel: "System model",
		scCoachModel: "Coach model",
		scSystemModelOwner: "Platform",
		scModelOf: "by {name}",
		scCounts: "{domains} domains, {exercises} tests",
		scUsedBy: "used by {count} of your athletes",
		scPublished: "Published",
		scNotPublished: "Not published",
		scPublishTitle: "Publish the model?",
		scPublishUsing:
			"Once published, {using} of your {athletes} athletes in this sport will use your model instead of the system one.",
		scPublishManual: "{count} stay on the model picked by hand for them.",
		scPublishConflicts:
			"{count} stay on the system model because {owners} also follows them with their own model: you can pick by hand from their profile.",
		scAnotherCoach: "another coach",
		scPublishGeneric:
			"Once published, it applies to your athletes in this sport instead of the system model.",
		scPublishReversible:
			"You can withdraw it at any time: your athletes go back to the system model, and their values do not change.",
		scModelRenamed: "Name updated",
		scModelNotFound: "Model not found, or not visible to you.",
		scModelName: "Model name",
		scReadOnlySystem:
			"Read only: this is the system model. To change it, create your own starting from it, in Sports and models.",
		scReadOnlyTeam: "Read only: this is a team colleague's model.",
		scDraftHint:
			"Not published: your athletes stay on the system model until you publish it. Changes are saved right away.",
		scAthleteModelSaved: "Athlete model updated",
		scEvaluatedWith: "Assessed with:",
		scChosenByHand: "picked by hand",
		scChooseModel: "Choose the model",
		scAutomatic: "Automatic",
		scBadgeInfoTitle: "Your weight class",
		adminPmSport: "Discipline",
		adminPmSelectSport: "Select a discipline",
		adminPmModelsTitle: "Performance models",
		adminPmModelsHint:
			"The system model and the coaches' models for this discipline. Select a row to open it.",
		adminPmColModel: "Model",
		adminPmColOwner: "Owner",
		adminPmColStatus: "Status",
		adminPmColContent: "Content",
		adminPmColAthletes: "Athletes",
		adminPmPlatform: "Platform",
		adminPmAthletesUsing: "{count} use it · {manual} picked by hand",
		adminPmAthletesTotal: "Athletes in this discipline: {count}",
		adminPmCoachModelWarning:
			"This is a coach's model: you are editing it as an admin, for support. Changes apply right away to their athletes.",
		// IPF GL and bodyweight leaderboards (docs/sport-config, D14)
		coefSinclair: "Sinclair",
		coefIpfGl: "IPF GL",
		pmCoefficient: "Coefficient",
		pmCoefficientNone: "None",
		pmIpfGlHint:
			"IPF GL applies to the bench press and to the total of the three lifts: mark under each exercise whether it is the competition squat, bench press or deadlift. Squat and deadlift alone have no GL points.",
		pmIpfLift: "Competition lift",
		pmIpfLiftNone: "Not a competition lift",
		pmIpfSquat: "Squat",
		pmIpfBench: "Bench press",
		pmIpfDeadlift: "Deadlift",
		ipfClassic: "classic",
		ipfEquipped: "equipped",
		ipfTotalLabel: "Total",
		ipfGlPoints: "{points} GL points",
		ppGlValue: "GL {value}",
		lbAllClasses: "All classes",
		lbMyClass: "My class · {label}",
		lbMyClassUnknown: "My class",
		lbAddWeightHint: "Add your weight to your profile to see your class.",
		lbSortBy: "Sort by",
		lbSortValue: "kg",
		// Bodyweight: weight classes and Sinclair (docs/sport-config, Phase 4)
		scGuideBodyweight: "Bodyweight",
		scGuideBodyweightBody:
			"In sports where it matters, such as weightlifting and powerlifting, the model can read levels by weight class and show Sinclair next to the kilos. You switch it on in the model, and it stays off where it is not needed, such as CrossFit.",
		pmTablesByWeightClass: "By weight class",
		pmSinclairUpdated: "Coefficient updated",
		pmWeightClassesTitle: "Weight classes of the sport",
		pmManageClasses: "Manage classes",
		pmNoClassesCanEdit:
			"This sport has no weight classes yet: add them to fill in the tables.",
		pmNoClassesAskAdmin:
			"This sport has no weight classes yet: whoever administers the sport decides them.",
		pmWeightClassHint:
			"The athlete's class is derived from the weight in their profile. A class without a table uses the gender table.",
		pmWeightClass: "Class",
		pmGenderTable: "Gender table (no bodyweight)",
		pmGenderTableHint:
			"This is the fallback table: it applies to athletes without bodyweight or gender in their profile and to classes without a table of their own.",
		pmWeightClassEmptyHint:
			"You are filling in the table of a class. If it stays empty, athletes in that class are read on the gender table.",
		wcTitle: "Weight classes · {sport}",
		wcHint:
			"They apply to every model of this sport. Removing a class does not delete its tables: put it back and you find them again.",
		wcPresets: "Start from:",
		wcPresetIwf: "IWF weightlifting (from 2026)",
		wcPresetIpf: "IPF powerlifting",
		wcNone: "No classes",
		wcRemove: "Remove -{cap} kg",
		wcCapLabel: "Class limit in kg",
		wcCapPlaceholder: "E.g. 73",
		wcAdd: "Add",
		wcOpenClass: "Open class above the last limit",
		wcKeepsTables:
			"Each class is named by its limit: -73 means up to and including 73 kg.",
		wcSaved: "Classes saved",
		wcInvalidCap: "Enter a limit in kg, greater than zero",
		ppSinclairValue: "Sinclair {value}",
		ppGenderTableUsed: "gender table",
		lgOpen: "How to read the levels",
		lgTitle: "How to read the levels · {domain}",
		lgIntro: "What each exercise's level means, and which thresholds it is computed on.",
		lgHowTitle: "The level",
		lgHowScore:
			"Each exercise has one threshold per level. The level comes from the max: between two thresholds it is interpolated, so 6.5 means halfway between level 6 and 7. Beyond the last threshold it stays at the top level, below the first it goes towards 0.",
		lgHowTimes: "For times it works the other way round: less time, higher level.",
		lgWeightClass:
			"The thresholds are those of the {class} class, derived from the bodyweight and gender in the profile: the same max is worth more in a lighter class.",
		lgFallback:
			"Where the profile has no bodyweight, or the class has no table, the gender thresholds are used.",
		lgScaleTitle: "The scale",
		lgScaleNumbers: "From {min} to {max}: higher is better.",
		lgThresholds: "The thresholds",
		lgThresholdsClass: "Thresholds of the {class} class",
		lgThresholdsHint: "The level reached in each exercise is highlighted.",
		lgSourcesTitle: "Where the numbers come from",
		scAskAssistant: "Configure with the assistant",
		scAskAssistantRead: "Ask the assistant",
		scAssistantTitle: "Assistant · {model}",
		scAssistantDescription:
			"Ask it to configure the model: domains, scales, tables by class. It writes only on this model; publishing and removing need your yes, and you can undo everything.",
		scAssistantDescriptionRead:
			"Ask how this model works or to compare it with another one: here it only reads it.",
		scCreateWithAssistant: "Create with the assistant",
		scSportAssistantTitle: "Assistant · {sport}",
		scSportAssistantDescription:
			"Ask it to create your model for this sport, starting from the system one if you like. It starts unpublished.",
		ppLevel: "Level {score}",
		ppLevelOf: "of {max}",
		ppNextLevel: "{delta} to level {score}{label} ({value})",
		ppTopLevel: "Top level of the scale",
		pmScoreLabels: "Level names",
		pmScoreLabelsHint: "Optional: they appear in the profile next to the number (e.g. «6 · National elite»).",
		pmScoreLabelPlaceholder: "Name",
		pmScoreLabelsSaved: "Level name saved",
		scBadgeClass: "Class {label}",
		scBadgeAddWeight: "Add your weight to your profile to get your class",
		scBadgeAddGender: "Add your gender to your profile to get your class",
		scBadgeInfoClass:
			"In this sport levels depend on the weight class: we derive it from the weight in your profile. If your weight changes, your class changes too.",
		scBadgeInfoSinclair:
			"Next to the kilos you see Sinclair: your max relative to bodyweight, to compare yourself with athletes of a different weight.",
		scClassOf: "Class",
		scClassWeight: "weight {weight} kg",
		scClassNoClasses:
			"The sport has no weight classes yet: levels on the gender table",
		scClassNoWeight: "No weight in the profile: levels on the gender table",
		scClassNoGender: "No gender in the profile: no class",
		scCompareClass: "Compare with another class",
		scCompareWith: "Compare with {label}",
		wccTitle: "Comparison: {base} and {other}",
		wccHint:
			"The same maxes, read on the tables of the two classes: useful to decide where the athlete should compete.",
		wccNoValues: "No values to compare.",
		wccValue: "Value",
		wccGenderTable: "Gender table",
		wccGenderTableShort: "(gender)",
		// Sport catalog: coach sports, deactivation, promotion (docs/sport-config, Phase 3)
		scGuideNewSport: "A sport that isn't there",
		scGuideNewSportBody:
			"Add it yourself: you, the coaches of your team and your athletes will see it, and athletes can pick it from their profile. If it is useful to everyone, the admin can make it available to the whole platform. Shooting sports are created by the admin only.",
		scAddSport: "Add a sport that isn't there",
		scManageSportsAdmin: "Manage disciplines",
		scAddSportTitle: "Add a sport",
		scAddSportConfirm: "Add",
		scSportCreated: '"{label}" added to the sports you follow',
		scSportReactivated: '"{label}" is active again',
		scFollowExisting: 'Follow "{label}"',
		scSportMineBadge: "yours",
		scSportTeamBadge: "by {name}",
		scSportCreatedByYou: "Created by you",
		scSportOfTeam: "From your team",
		scPersonalSportHint:
			"This sport was added by a coach: it has no system model. You build the model your athletes are assessed with.",
		scCreateOwnModel: "Create your model",
		scCreatedTitle: "Sports you created",
		scCreatedHint:
			"You, the coaches of your team and your athletes see them. You can rename and deactivate them; while nobody uses them you can also fix their identifier or delete them. The admin can make them available to everyone.",
		scCreatedUsage: "{athletes} athletes practise it · {models} coach models",
		scIdentifier: "Identifier",
		scIdentifierHint: "Will become: {value}",
		scDelete: "Delete",
		scDeleteTitle: 'Delete "{label}"?',
		scDeleteBody: "Nobody uses it: the sport is removed for good. It cannot be recovered.",
		scDeleted: '"{label}" deleted',
		scSportActive: "Active",
		scSportInactive: "Deactivated",
		scRename: "Rename",
		scSportRenamed: 'Name updated: "{label}"',
		sdfLabel: "Name",
		sdfLabelPlaceholder: "E.g. Climbing",
		sdfCoachHint:
			"You, the coaches of your team and your athletes will see it. It is a physical preparation sport: shooting sports are created by the admin.",
		sdfSlug: "Identifier",
		sdfSlugHint:
			"Athletes, models and leaderboards rely on it: it cannot change after creation. The name can.",
		sdfSlugLocked:
			"It cannot change: athletes, coaches and models point to it. You can rename the name.",
		sdfFamilies: "Areas",
		sdfFamiliesHint:
			"They decide which sections coaches and athletes of this sport see. Pick both for a hybrid sport (shooting with physical preparation).",
		sdfFamilyPhysical: "Physical preparation",
		sdfFamilyShooting: "Shooting",
		sdfNoFamilies: "No area: it will be treated as physical preparation.",
		sdfOrder: "Order",
		sdDeactivate: "Deactivate",
		sdReactivate: "Reactivate",
		sdDeactivated: '"{label}" deactivated',
		sdReactivated: '"{label}" reactivated',
		sdDeactivateTitle: 'Deactivate "{label}"?',
		sdUsageAthletes: "Athletes who practise it",
		sdUsageCoaches: "Coaches who follow it",
		sdUsageModels: "Coach performance models",
		sdUsageUnavailable: "I can't read who uses it right now.",
		sdDeactivateKeeps:
			"Nobody who uses it loses anything: profile, models and leaderboards stay. Nobody will be able to pick it any more, and you can reactivate it whenever you want.",
		sdConflictMine:
			'You already created "{label}": you\'ll find it among the sports you created.',
		sdConflictTeam:
			'A colleague of your team already created "{label}": you can follow it.',
		sdConflictOther:
			"Another coach already created this sport. Ask the admin to make it available to everyone.",
		sdConflictGlobal: '"{label}" already exists: you can follow it.',
		sdConflictInactive:
			"This sport exists but is deactivated: ask the admin to reactivate it.",
		sdConflictLabel: 'A sport called "{label}" already exists.',
		sdConflictGlobalAdmin: '"{label}" already exists: edit it from the list.',
		sdConflictPersonal:
			'"{label}" is {owner}\'s sport: make it global from the list instead of creating another one.',
		adminSportsTitle: "Sport disciplines",
		adminSportsHint:
			"The platform's sports and those created by coaches. Nothing is deleted: it is deactivated, and whoever uses it keeps their data. The identifier is chosen only when creating.",
		adminSportsFilterAll: "All",
		adminSportsFilterPersonal: "Created by coaches",
		adminSportsFilterInactive: "Deactivated",
		adminSportsEmpty: "No discipline in this filter",
		adminSportsGlobal: "Global",
		adminSportsPersonalOf: "By {owner}",
		adminSportsActive: "Active",
		adminSportsInactive: "Deactivated",
		adminSportsUsage:
			"{athletes} athletes · {coaches} coaches · {models} models",
		adminSportsProposedBy: "Proposed by {owner}",
		adminSportsPromote: "Make global",
		adminSportsConfirmPromote:
			'Make "{label}" available to everyone? All coaches and athletes will see it; the data of whoever already uses it stays as it is.',
		adminSportsPromoted: '"{label}" is now available to everyone',
		adminSportsNewTitle: "New discipline",
		adminSportsEditTitle: "Edit discipline",
		adminSportsCancelEdit: "Cancel editing",
		adminSportsClear: "Clear fields",
		adminSportsEditingPersonal:
			"This sport was created by {owner}: you are editing it as an admin, for support.",
		adminSportsSave: "Save changes",
		adminSportsCreate: "Create discipline",
		adminSportsCreated: 'Discipline "{label}" created',
		adminSportsUpdated: 'Discipline "{label}" updated',
		openCompetitionCalendar: "Open competition calendar",
		// Competition Hub (coach)
		competitionHub: "Race Calendar",
		competitionHubSubtitle:
			"Overview of the competition calendars of all your athletes",
		competitionHubScopeMine: "Mine",
		competitionHubScopeAll: "All (admin)",
		competitionHubEventsCount: "Events",
		competitionHubSharedCount: "Shared races",
		competitionHubLoadError: "Error loading race calendar",
		competitionHubSearchPlaceholder: "Search race, city or athlete...",
		competitionHubPeriodUpcoming: "Upcoming",
		competitionHubPeriodNext30: "Next 30 days",
		competitionHubPeriodNext90: "Next 90 days",
		competitionHubPeriodPast: "Past",
		competitionHubPeriodAll: "All",
		competitionHubAllAthletes: "All athletes",
		competitionHubAthletesSelected: "selected",
		competitionHubSharedOnly: "Shared only",
		competitionHubResetFilters: "Reset filters",
		competitionHubFilters: "Filters",
		competitionHubFilterType: "Event type",
		competitionHubFilterOther: "Other filters",
		competitionHubLegend: "Legend",
		competitionHubLegendTypeTitle: "Event type",
		competitionHubLegendTypeBody:
			"The nature of the competition: Race (official competition), Qualification, Open, Test (trial/simulation) or Other.",
		competitionHubLegendPriorityA:
			"Target race: peak form is built around this race.",
		competitionHubLegendPriorityB:
			"Secondary race: important but not the main goal of the season.",
		competitionHubLegendPriorityC:
			"Tune-up race: raced in training, without a specific taper.",
		competitionHubLegendStatusIntro:
			"The race registration status, set when you create or edit the event:",
		competitionHubLegendStatusPlanned: "under consideration, not yet decided",
		competitionHubLegendStatusConfirmed:
			"the athlete will take part, registration to be completed",
		competitionHubLegendStatusRegistered: "registration completed",
		competitionHubLegendStatusDone: "race completed",
		competitionHubLegendStatusCancelled: "race cancelled or withdrawal",
		competitionHubViewList: "List",
		competitionHubViewShared: "Shared events",
		competitionHubViewCalendar: "Calendar",
		competitionHubViewTimeline: "Timeline",
		competitionHubKpiNext30: "Next 30 days",
		competitionHubKpiNextRace: "Next race",
		competitionHubKpiShared: "Shared races",
		competitionHubKpiWithoutRace: "Athletes without races",
		competitionHubIn: "in",
		competitionHubNone: "None",
		competitionHubPrevMonth: "Previous month",
		competitionHubNextMonth: "Next month",
		competitionHubAllDisciplines: "All disciplines",
		competitionHubAllStatus: "All statuses",
		competitionPriority: "Priority",
		competitionPriorityA: "A — Target",
		competitionPriorityB: "B — Secondary",
		competitionPriorityC: "C — Tune-up",
		competitionStatus: "Status",
		competitionStatusPlanned: "Planned",
		competitionStatusConfirmed: "Confirmed",
		competitionStatusRegistered: "Registered",
		competitionStatusDone: "Done",
		competitionStatusCancelled: "Cancelled",
		competitionDiscipline: "Discipline",
		competitionDisciplinePlaceholder: "E.g. Arm wrestling, Ultra trail",
		// Competition sports (docs/sport-config, D16)
		competitionSport: "Sport",
		competitionSportNone: "No sport",
		competitionSportOther: "Other: not listed",
		competitionSportOtherHint:
			"Competitions of unlisted sports keep their text: you find them in the filter, but they do not count for a sport.",
		competitionHubAllSports: "All sports",
		competitionHubFreeText: "free text",
		competitionCategory: "Category",
		competitionCategoryPlaceholder: "E.g. Rx, Scaled, Master, -73kg",
		competitionEndDate: "End date (multi-day)",
		competitionSuggestionsTitle:
			"Races added by athletes in your sport or your group",
		competitionSuggestionsHint:
			"The number shows how many athletes added it. They are the athletes of your coaches practising your sport, plus your training-group mates.",
		competitionOthersTitle: "Races of the other athletes",
		competitionOthersHint:
			"What the other athletes of your coaches are up to, other sports and groups included",
		competitionOthersEmpty:
			"No upcoming race for the other athletes of your coaches.",
		competitionOthersError: "Could not load the races of the other athletes",
		competitionOthersAdd: "Add to my calendar",
		competitionHubNewRace: "New race",
		competitionHubConflicts: "Calendar conflicts (close A races)",
		competitionHubSelectAthletes: "Select at least one athlete",
		competitionHubAssignAthletes: "Assign to athletes",
		competitionHubEventsCreated: "Races created",
		competitionHubAddAthletes: "Add athletes",
		competitionHubAddAthletesTitle: "Add athletes to the race",
		competitionHubSelectAthletesToAdd: "Select the athletes to add",
		competitionHubAthletesAdded: "Athletes added to the race",
		competitionHubAlreadyIn: "Already in",
		competitionHubParticipants: "participants",
		competitionParticipantsTitle: "Who is doing this race",
		competitionParticipantsOpen: "See who is doing this race",
		competitionParticipantsYou: "You",
		competitionParticipantsEmpty:
			"No other athlete linked to your coaches is attending.",
		competitionParticipantsError: "Could not load the participants",
		competitionHubExistingRace: "Races already in the calendar",
		competitionHubApplyToGroup: "Apply to the other athletes in this race too",
		competitionHubApplyToGroupHint:
			"Name, dates, location, type and discipline are updated for everyone. Priority, category, status, result and notes stay personal.",
		competitionHubGroupUpdated: "Race updated for all participants",
		competitionHubDeleteConfirm: "Delete the selected races?",
		competitionHubBulkDone: "Operation completed",
		competitionHubSelected: "selected",
		competitionHubSetStatus: "Set status",
		competitionHubClearSelection: "Clear",
		competitionHubEmpty: "No races found with current filters",
		competitionHubToday: "Today",
		competitionHubDaysShort: "d",
		eventType_gara: "Race",
		eventType_qualificazione: "Qualification",
		eventType_open: "Open",
		eventType_test: "Test",
		eventType_altro: "Other",
		openAthleteAgenda: "Open results agenda",
		openAthleteDetail: "Open athlete detail",
		athleteDetailCta: "Detail",
		athleteProgramsPreviewCta: "Programs",
		viewModeGrid: "Grid view",
		viewModeList: "List view",
		athleteProgramsPreviewTitle: "Athlete dashboard preview",
		noAssignedProgramsPreview: "No programs assigned to this athlete",
		coachSandboxBadge: "Coach support mode",
		coachSandboxHint:
			"You are acting on behalf of the athlete on their real data: results and history are theirs, and anything you log or correct is saved to their diary.",
		coachSandboxLoggedByCoach: "Logged by coach",
		coachSandboxEditedByCoach: "Corrected by coach",
		coachSandboxResultSaved: "Result saved for {name}",
		coachSandboxResultUpdated: "Result updated for {name}",
		coachSandboxResultDeleted: "Result deleted for {name}",
		athletePerformanceProfile: "Athlete performance profile",
		athleteCompetitionCalendar: "Athlete competition calendar",
		athleteAgendaResults: "Athlete results agenda",
		noPerformanceProfileData: "No data available in performance profile",
		noCompetitionEvents: "No events in competition calendar",
		noAgendaResults: "No results available in agenda",
		manualEntry: "Manual entry",
		autoFromResults: "Calculated from results",
		calculatedFrom: "Calculated from",
		source1rmExact: "1RM test from diary",
		source1rmEstimate: "Estimate from diary test",
		sourceManualHigher: "Manual (higher than estimate)",
		sourceAutoHigher: "Result higher than manual",
		sourceAutoHigherEstimate: "Estimate higher than manual",
		performanceHistoryTitle: "Exercise history",
		sessionDetailButton: "Session detail",
		sessionDetailTitle: "Session detail",
		sessionDetailLoadError: "Unable to load the session detail",
		sessionDetailProfileValue: "Profile value",
		sessionDetailNoPrescription: "Result not linked to a program day",
		sessionDetailNoResult: "No result logged",
		sessionDetailExtraResults: "Results outside the prescription",
		performanceHistoryDescription:
			"Timeline of diary results and manual entries for this exercise.",
		historyLoadError: "Unable to load history",
		historyEmpty: "No history available for this exercise",
		historyFilter30Days: "Last 30 days",
		historyFilter6Months: "Last 6 months",
		historyFilter1Year: "Last year",
		historyFilterAll: "All",
		historyWeight: "Weight",
		historyEstimated1rm: "Estimated 1RM",
		historySourceDiary: "Diary",
		historySourceManual: "Manual",
		historyLegacyManual:
			"Legacy manual value saved before complete history tracking",
		historyDeleteConfirm: "Delete this result from history?",
		historySharedResultWarning:
			"This result is shared with other movements in the complex/EMOM.",
		historySharedEditConfirm:
			"Editing this result will also change the other movements in the complex/EMOM. Continue?",
		historySharedDeleteConfirm:
			"Deleting this result will remove the whole complex/EMOM result, including other movements. Continue?",
		historyEntryPartOf: "Done within",
		historyEntryUpdated: "History result updated",
		historyEntryDeleted: "History result deleted",
		historyInvalidValue: "Enter a valid result value",
		resultDate: "Result date",
		viewSourceWorkout: "View source workout",
		sourceWorkoutTitle: "Source workout (auto value)",
		exerciseLabel: "Exercise",
		prescriptionLabel: "Prescription",
		resultLabel: "Result",
		noFeedbackLabel: "No feedback provided",
		repsLabel: "Reps",
		timeLabel: "Time",
		profileLoadError: "Error loading performance profile",
		calendarLoadError: "Error loading competition calendar",
		agendaLoadError: "Error loading agenda results",
		noAthletesFound: "No athletes found",
		tryDifferentSearch: "Try a different search",
		athletesWillAppear: "Athletes will appear here when they register",

		// Groups
		groups: "Groups",
		newGroup: "New Group",
		createGroup: "Create Group",
		addAthletes: "Add Athletes",
		noGroups: "No groups",
		createGroupHint: "Create groups to organize your athletes",

		// Exercises (extra)
		editExercise: "Edit Exercise",
		exerciseImage: "Exercise Image",
		clickToUpload: "Click to upload an image",
		noExercisesFound: "No exercises found",
		startCreatingExercise: "Start by creating your first exercise",
		removeImage: "Remove image",
		newConditioningCircuit: "New Conditioning Circuit",
		createCircuit: "Create Circuit",
		editConditioningCircuit: "Edit Conditioning Circuit",
		saveCircuitChanges: "Save Circuit Changes",
		managePrograms: "Create and manage training programs",
		manageExercisesDb: "Manage the exercises database",
		exerciseLinksTitle: "Active links",
		exerciseLinksHint:
			"Library renames are synchronized across the linked entities below.",
		linkedPrograms: "Linked programs",
		linkedOccurrences: "references",
		linkedActiveProgramsLabel: "active programs",
		showLinkedProgramDetails: "show",
		hideLinkedProgramDetails: "hide",
		noProgramLinks: "No linked programs",
		linkedPerformanceProfiles: "Linked performance profiles",
		noPerformanceProfileLinks: "No links in performance profile",
		notAvailable: "n/a",
		libraryScopeLabel: "Library",
		libraryScopeVisible: "Visible library",
		libraryScopeMine: "Only personal",
		libraryScopeGlobal: "Only global",
		libraryScopeAllAdmin: "All (admin)",
		libraryScopeAll: "All",
		libraryScopePersonalPlural: "Personal",
		libraryScopeGlobalPlural: "Global",
		libraryScopePersonal: "Personal",
		libraryScopeGlobalSingle: "Global",
		dashboardMyPersonalLibrary: "My personal library",
		dashboardGlobalLibrary: "Global library",
		dashboardSharedToGlobalLabel: "Shared to global library",
		todayCardTitle: "Today",
		todayCardEmpty: "No program has a workout for your athletes today.",
		todayCardGoToPrograms: "Go to programs",
		todayCardError: "Couldn't load today's workouts.",
		todayCardRetry: "Retry",
		todayCardShowMore: "Show {count} more",
		todayCardShowLess: "Show less",
		todayCardShared: "Shared",
		todayCardUndated: "Undated",
		todayCardUndatedHint: "Opens on the first day",
		todayCardDayFallback: "Today's workout",
		todayCardSessions: "{count} sessions",
		todayCardAthleteOne: "1 athlete",
		todayCardAthletes: "{count} athletes",
		todayCardGroupOne: "1 group",
		todayCardGroups: "{count} groups",
		todayCardOpenHint: "Tap a program to see it the way athletes see it.",
		todayPreviewOpenProgram: "Open program",
		todayPreviewEmpty: "This program has no weeks visible to athletes.",
		todayPreviewError: "Couldn't open the program.",
		coachShowcaseTitle: "Athlete view",
		coachShowcaseBadge: "Athlete view · read only",
		coachShowcaseHint:
			"The program as athletes see it. Results, history and personal loads are on each athlete's page.",
		ownerFilterLabel: "Coach filter",
		allOwners: "All coaches/admin",
		globalExerciseEditAdminOnly: "Only admin can edit global exercises",
		globalExerciseDeleteAdminOnly: "Only admin can delete global exercises",
		globalTemplateEditAdminOnly: "Only admin can edit global templates",
		globalTemplateDeleteAdminOnly: "Only admin can delete global templates",
		addExerciseToPersonalLibrary: "Add to personal library",
		addConditioningToPersonalLibrary: "Add personal circuit",
		scopePersonalLabel: "Personal",
		scopeGlobalLabel: "Global",
		conditioningLibraryTitle: "Conditioning Library",
		conditioningLibrarySubtitle:
			"Manage preconfigured circuits and WOD templates",
		libraryExercisesLabel: "Exercise Library",
		searchExercisePlaceholder: "Search exercise...",
		addExerciseButton: "Add exercise",
		selectedExerciseLabel: "Selected",
		addExerciseToDomainTitle: "Add Exercise to Domain",
		unitOfMeasure: "Unit of measure",
		sourceAll: "All",
		sourceExercises: "Exercises",
		searchExerciseOrConditioning: "Search exercise or conditioning...",
		availableItemsSuffix: "available items",
		filteredSuffix: "(filtered)",
		noResultsForSelectedFilters: "No results for selected filters",
		allExercisesAlreadyAddedToDomain:
			"All exercises have already been added to this domain",

		// Workouts
		logWorkout: "Log workout",
		addWorkout: "Add Workout",
		workoutData: "Workout Data",
		strengthData: "Strength Data",
		cardioData: "Cardio Data",
		generalData: "General Data",
		durationMin: "Duration (min)",
		distanceKm: "Distance (km)",
		totalDurationMin: "Total duration (min)",
		avgHR: "Avg HR (bpm)",
		caloriesBurned: "Calories burned",
		paceLabel: "Pace",
		totalVolumeLabel: "Total volume",
		restDay: "Rest day",
		noWorkoutsToday: "No workouts for this date",
		sessionFallbackTitle: "Training session",
		moreExercises: "more exercises",
		resultsLogged: "Logged results",
		prevWeek: "Previous week",
		nextWeek: "Next week",
		workoutAdded: "Workout added!",
		enterTitle: "Please enter a title",
		running: "Running",
		add: "Add",
		workoutTitlePlaceholder: "e.g. Morning run, Gym session...",
		workoutDescPlaceholder: "Describe your workout...",
		notesWorkoutPlaceholder: "How did you feel? Anything to remember?",
		every: "every",
		cycling: "Cycling",

		// Diary
		personalDiary: "Personal Diary",
		logPersonalWorkouts: "Log your personal workouts",
		newWorkout: "New Workout",
		saveToDiary: "Save to Diary",
		latestWorkouts: "Latest Workouts",
		noDiary: "No workouts in the diary",
		howDidItGo: "How did it go? Anything to remember?",
		noWorkoutsDate: "You haven't logged workouts for this date",
		workoutAddedDiary: "Workout added to diary!",
		addManualResult: "Add manual result",
		manualResultDialogTitle: "Add manual result",
		manualResultLoadError: "Failed to load manual exercises",
		manualResultSelectExercise: "Select an exercise",
		manualResultInvalidValue: "Enter a valid result",
		manualResultFillAtLeastOne: "Fill at least one result field",
		manualResultFillBeforeSave: "Enter a result before saving",
		manualResultAdded: "Manual result added",
		manualResultSaving: "Saving...",
		manualResultSave: "Save result",
		manualResultSearchPlaceholder: "Search exercise or template",
		manualResultNoExercisesFound: "No exercises found",
		manualResultFilterAll: "All",
		manualResultFilterProfile: "In profile",
		manualResultQuickPicks: "Quick picks",
		manualResultProfileUnit: "Profile unit",
		manualResultType: "Result type",
		manualResultSelectTypePlaceholder: "Select result type",
		manualResultFreePlaceholder: "Ex. 15 rounds + 12 reps",
		manualResultNotePlaceholder: "Optional note about the result",
		manualResultKindSchema: "Result schema",
		manualResultKindForTime: "For Time",
		manualResultKindTimeOrReps: "Time or Reps",
		manualResultKindScore: "Score",
		manualResultKindFreeScore: "Free score",
		manualResultKindFreeResult: "Free result",
		manualResultKindWeightReps: "Weight + reps",
		manualResultKindWeight: "Weight only",
		manualResultKindReps: "Repetitions",
		manualResultKindTime: "Time",
		programOrderLabel: "Order programs",
		programOrderTitle: "Order assigned programs",
		programOrderDescription:
			"Choose which program appears first. Weeks and days keep their natural order.",
		moveUp: "Move up",
		moveDown: "Move down",
		noResultsForDate: "No results logged for this date",
		resultSourceManual: "Manual",
		resultSourceAssigned: "Assigned",
		deleteResultTitle: "Delete result",
		deleteResultConfirm:
			"Are you sure you want to delete this result? This action cannot be undone.",
		deleteResultConfirmBtn: "Delete result",
		resultDeleted: "Result deleted",
		resultValueNotAvailable: "Value not available",
		diaryHistoryEmptyTitle: "Your diary is empty",
		diaryHistoryEmptyText:
			"Only what you have done shows up here: results logged in your workouts and the ones you add by hand.",
		diaryHistoryNothingBefore: "No activity logged before this date.",
		diaryHistoryLoadMore: "Show earlier days",
		diaryHistoryEnd: "Start of your diary",
		diaryHistoryJumpToDate: "Go to a date",
		diaryHistoryUntil: "Up to",
		diaryHistoryBackToToday: "Back to today",
		diaryHistoryManualGroup: "Added manually",
		diaryHistoryFreeEntries: "Training notes",
		diaryHistoryProgramFallback: "Program",
		diaryHistoryOpenWorkout: "Open workout",
		diaryHistoryLoadError: "Could not load your diary",
		resultUpdated: "Result updated",

		// Athlete Dashboard
		noActiveProgram: "No active program",
		contactCoach: "You have no assigned programs. Contact your coach!",
		programNotYetPublishedTitle: "Program assigned, no week visible",
		programNotYetPublishedBody: "Your coach has assigned you a program, but no week is published for you right now. As soon as one is, you will find it here.",
		programVisibleFrom: "Your coach has assigned you a program: you will see it here from",
		weekNotesLabel: "Week Notes",
		dayNotesLabel: "Day Notes",
		selectSession: "Select a session",
		chooseDay: "Choose a day from the list above",
		noSessionsWeek: "No sessions this week",
		noWeeksAvailable: "No weeks available",
		weeksNotPublished: "Your coach hasn't published any weeks yet",
		emptyWeek: "Empty week",
		noDaysWeek: "No days configured for this week",
		sessionLabel: "Session",
		noExercisesInSession: "No exercises in this session",
		unassignedExercisesLabel: "Extra",
		complexMethodLabel: "Complex",
		coachNotes: "Coach Notes",
		programLabel: "Program",
		weekShort: "Wk.",
		exerciseCountLabel: "exercises",
		intervalsLabel: "intervals",
		setsShort: "sets",
		repsShort: "reps",
		swimLabel: "Swim",
		bikeLabel: "Bike",
		timeCapLabel: "Time Cap",
		timeOrRepsLabel: "Time or Reps",
		timeOrRepsPlaceholder: "mm:ss or total reps",
		timeOrRepsTimecapBadge: "TIMECAP",
		timeOrRepsHintTime: "Enter the time (mm:ss) if you completed the WOD",
		timeOrRepsHintReps:
			"Or enter the total reps reached if you didn't finish in time",
		roundLabel: "round",
		roundsLabel: "rounds",
		hiitWorkLabel: "Work",
		hiitRecoveryLabel: "Rest",
		hiitRatioLabel: "Work/Rest",
		mediaLabel: "Media",
		setLabel: "Set",
		restLabel: "Rest",
		jogLabel: "(jog)",
		blockLabel: "block",
		indoorLabel: "Indoor",
		outdoorLabel: "Outdoor",
		mixedLabel: "Mixed",
		weightKgLabel: "Weight (kg)",
		generalRpeLabel: "General RPE",
		rpePlaceholder: "RPE",
		rirPlaceholder: "RIR",
		rpeInfoOpenAria: "Open RPE explanation",
		rpeInfoTitle: "What is RPE?",
		rpeInfoDescription:
			"RPE (Rate of Perceived Exertion) indicates how hard the set felt.",
		rpeInfoEasy: "very easy",
		rpeInfoHard: "hard but controlled",
		rpeInfoMax: "max effort (0 reps in reserve)",
		exerciseNoteLabel: "Exercise Note",
		exerciseNotePlaceholder: "Describe how you performed the exercise...",
		repeatShortLabel: "reps",
		editResultTitle: "Edit Result",
		logResultTitle: "Log Result",
		freeScoreLabel: "Free score",
		emomScorePlaceholder: "Ex: completed 8/10 rounds, technically clean",
		repeatScoresLabel: "Repeats",
		repeatResultPlaceholder: "e.g. 1:32 / 4:05/km",
		cardioRepeatResultPlaceholder: "e.g. 1:42 / 2:05/500m / 250m",
		cardioRepeatResultHint: "Enter the time or distance for each interval.",
		customRunningResultLabel: "Result",
		customRunningResultPlaceholder: "e.g. 10km in 50min, how it went...",
		segmentScoresLabel: "Segments",
		segmentResultPlaceholder: "e.g. 25:00 / 3.66 km / 6:50/km",
		runningTotalsLabel: "Whole run",
		runningTotalsHint:
			"Time and distance of the whole run, splits included. Leave blank what you don't have.",
		avgHeartRateLabel: "Avg HR",
		maxHeartRateLabel: "Max HR",
		minShort: "Min",
		secShort: "Sec",
		distanceMetersLabel: "Distance (m)",
		distanceKmLabel: "Distance (km)",
		completedRepsLabel: "Completed reps",
		amrapTotalRepsPlaceholder: "Ex: 120 (total reps sum)",
		amrapTotalRepsHint: "Enter total reps, not the number of rounds",
		scoreLabel: "Score",
		emomRoundsPlaceholder: "Ex: completed 7 rounds + 5 reps",
		notesResultPlaceholder: "How did it go?",
		scalingLabel: "Scaling",
		scalingPlaceholder: "Scaling (opt., empty = RX)",
		scalingRxLabel: "RX",
		scalingScaledLabel: "SCALED",
		insertResultLabel: "Insert Result",
		viewLeaderboardLabel: "View Leaderboard",
		youLabel: "You",
		leaderboardEmptyLabel: "No public results for this exercise yet",
		leaderboardLoadError: "Unable to load leaderboard",
		cancelEditLabel: "Close",
		saveResultLabel: "Save Result",
		updateResultLabel: "Update Result",
		resultLoggedChip: "Logged",
		resultDraftChip: "Draft",
		resumeDraftLabel: "Resume the draft",
		actionResumeDraftShort: "Resume",
		resultDraftKeptToast:
			"Not saved: your values stay on the exercise as a draft. Reopen it with “Resume”.",
		dayResultsProgress: "{done} of {total} logged",
		resultRecordedLabel: "Result Logged",
		everyLabel: "Every",
		customWodLabel: "Custom WOD",
		distanceLabel: "Distance",
		watchVideo: "Watch Video",
		viewGuide: "View Guide",
		paceShort: "Pace",
		equipment: "Equipment",
		targetPower: "Power target",
		targetCadence: "Cadence target",
		loadLabel: "Load",
		exerciseUpdated: "Exercise updated",
		exerciseCreatedSuccess: "Exercise created successfully",
		exerciseDeleted: "Exercise deleted",
		exerciseAddedToLibrary: "added to library!",
		updateError: "Update error",
		createError: "Creation error",
		uploadError: "Upload error",
		circuitName: "Circuit name",
		wodDescription: "WOD Description",
		exercisesInWod: "Exercises in WOD",
		exerciseName: "Exercise Name",
		exerciseNamePlaceholder: "Exercise name",
		exerciseDescriptionPlaceholder: "Exercise description...",
		exerciseTechniquePlaceholder: "Exercise and technique description...",
		searchExercise: "Search exercise...",
		searchExercises: "Search exercises...",
		saveProfile: "Save Profile",
		savingLabel: "Saving...",
		newEvent: "New Event",
		editEvent: "Edit Event",
		locationLabel: "Location",
		addEvent: "Add Event",
		performanceProfilePending:
			"Your performance profile will be configured by your coach",
		programTitleRequired: "Program title is required!",
		programSaved: "Program saved!",
		saveError: "Save error",
		intervalDurationRequired: "Enter interval duration",
		noNextWeek: "There is no next week",
		noDaysNextWeek: "The next week has no days",
		publishWeekAuto: "The week will be published automatically on the chosen date",
		programAutoDisableLabel: "Automatic hiding",
		pbCalendarRulesTitle: "Weeks and calendar",
		programAutoPublishLabel: "Automatic publishing",
		programAutoPublishHint:
			"Each week appears to athletes by itself, from the dates of its days. A week without dated days stays hidden until you publish it.",
		programAutoPublishUndated: "Dated programs only: here you publish the weeks yourself.",
		programAutoPublishLeadLabel: "Appears",
		programAutoPublishLead1: "the Sunday before",
		programAutoPublishLead0: "on the week's Monday",
		programAutoPublishLead2: "the Saturday before",
		programCalendarBothHint:
			"With both on, athletes see only the current week, and the next one from Sunday evening.",
		programAutoDisableHint:
			"Each week hides by itself from the Monday after its Sunday. Turn it off to keep everything visible until you pick a date yourself.",
		weekDisableAutoHint:
			"Pick the last day athletes see it: from the next day they no longer do. With no choice it stays visible through the Sunday that ends the week.",
		weekDisableManualHint:
			"Automatic deactivation is off for this program (see Details). Pick the last day athletes see it only if you want to hide this week.",
		weekDisableAutoReset: "Reset to automatic date",
		weekKeepVisibleHint:
			"Reactivated by hand: it no longer disables itself. Pick a date to hide it, or reset to the automatic one.",
		weekGuidancePlaceholder:
			"General weekly notes (focus, goals, volume, recovery...)",
		newDay: "New Day",
		workoutDescription: "Workout description",
		intensity: "Intensity",
		speedPace: "Speed/Pace",
		currentExerciseLoadReference: "Current exercise",
		athleteBodyweightReference: "Athlete bodyweight",
		loadReferenceExercise: "Load percentage based on",
		loadReferenceSummary: "Based on",
		complexLoadReferenceMissing:
			"Choose which max the % is based on: a complex has no max of its own",
		complexLoadReferenceLabel: "% of the max of",
		complexLoadReferenceOther: "Other exercise…",
		complexLoadReferenceRequired:
			"The complex has a % without a reference: choose which max it is based on",
		complexLoadReferenceToSet: "Reference to choose",
		loadMissingMaxInProfile: "Max not in your profile",
		allowResultEntry: "Athlete result entry",
		resultEntryEnabledHint: "Athlete can submit a score",
		resultEntryDisabledHint: "Read-only exercise (no score entry)",
		resultEntryOpen: "Enabled",
		resultEntryLocked: "Read-only",
		leaderboardEnabledHint: "Exercise appears in group leaderboard",
		leaderboardDisabledHint: "Leaderboard hidden for this exercise",
		leaderboardVisible: "Visible",
		leaderboardHidden: "Hidden",
		resultEntryBlocked: "Score entry is disabled for this exercise",
		resultAlreadyLogged: "Score logged",
		orCreateManually: "Or create manually",
		supersetExercises: "Exercises in superset",
		addFirstDayWeek: "Add the first day to the week",
		profileUpdated: "Profile updated",
		eventAdded: "Event added",
		eventDeleted: "Event deleted",
		eventUpdated: "Event updated",
		enterValidNumeric: "Enter a valid numeric value",
		valueSaved: "Value saved",
		manualValueRemoved: "Manual value removed",
		performancePublicLabel: "Public performance",
		performancePublicDescription:
			"Make your performances visible to athletes in your same sport and enable performance profile leaderboards.",
		resultsPublicLabel: "Public results",
		resultsPublicDescription:
			"Make your workout results visible in the group exercise leaderboard.",
		performancePublicLeaderboardHint:
			"Enable Public performance in your Profile tab to use performance profile leaderboards.",
		performanceLeaderboardTitle: "Performance profile leaderboard",
		performanceLeaderboardSportScope: "Everyone in this sport",
		performanceLeaderboardEmpty:
			"No public athletes with an available result for this exercise.",
		performanceLeaderboardLoadError:
			"Unable to load performance profile leaderboard",
		leaderboardGenderAll: "All",
		bodyweightShort: "BW",
		bodyweightRatioShort: "x BW",
		performanceGeneralTab: "General",
		performanceRadarTitle: "Radar",
		performanceRadarMissingConfig:
			"Configure at least 3 exercises with scale values to display the radar.",
		profileUnsavedChangesWarning:
			"You have unsaved profile changes. Do you want to leave without saving?",
		updatedOnLabel: "Last updated",

		// Athlete Detail / Mesocycles
		mesocyclePlanning: "Planning",
		resultsAnalysis: "Results",
		athleteInfo: "Info",
		performanceProfile: "Performance Profile",
		mesocycles: "Mesocycles",
		addMesocycle: "Add Mesocycle",
		// Athlete read-only preparation plan view
		preparationPlan: "Preparation plan",
		mesocycleInProgress: "In progress",
		mesocycleUpcoming: "Upcoming",
		mesocycleCompleted: "Completed",
		mesocycleStartsIn: "Starts in",
		editMesocycle: "Edit Mesocycle",
		mesocycleCreated: "Mesocycle created",
		mesocycleUpdated: "Mesocycle updated",
		mesocycleDeleted: "Mesocycle deleted",
		mesocycleInvalidDates: "End date must be after start date",
		mesocycleNamePlaceholder: "e.g. General Preparation",
		mesocycleDescPlaceholder: "Goals and notes for this mesocycle...",
		startDate: "Start Date",
		endDate: "End Date",
		color: "Color",
		athleteNotFound: "Athlete not found",
		personalInfo: "Personal Info",
		recentResults: "Recent Results",
		athleteCompetitions: "Competition Calendar",
		noEventsThisDay: "No events",
		monthsVisible: "Visible months",
		monthSingular: "month",
		monthsPlural: "months",
		weeksVisible: "Visible weeks",
		weekSingular: "week",
		weeksPlural: "weeks",
		coachAddCompetitionEvent: "Force Competition Event",
		coachCompetitionInsertHint:
			"You can force an event using the event button in planning",
		competitionTypePlaceholder: "competition, test, open...",
		noResultsLoadedShort: "Not loaded",
		mesocycleDragHint:
			"Drag across calendar days to create a mesocycle, or click a mesocycle to edit it",
		selectedRangeLabel: "Selected",
		mesocycleSelectionActive: "Mesocycle selection:",
		dateOfBirth: "Date of Birth",
		height: "Height",
		weight: "Weight",
		assignedPrograms: "Assigned Programs",
		programActiveShort: "Active",
		programInactiveShort: "No active",
		programActiveStatus: "Active",
		programArchivedStatus: "Archived",
		programWeeksShort: "wks",
		autoDetected: "Auto-detected",
		manual: "Manual",

		// Mobile
		installApp: "Install App",
		offlineReady: "Available offline",
		installPromptTitle: "Install Kraveon",
		installPromptSubtitle:
			"Add the app to your Home Screen for faster access and full-screen experience.",
		installPromptIosStep1: "Tap Share in Safari",
		installPromptIosStep2: "Select Add to Home Screen",
		installPromptAndroidFallback:
			"If the popup does not appear, open the browser menu and select Install app or Add to Home screen.",
		installPromptLater: "Later",

		// App update while open (lib/appVersion.js)
		appUpdateTitle: "A new version of Kraveon is ready",
		appUpdateBody: "Reload to get the latest features and fixes.",
		appUpdateAction: "Reload",

		// Assignments (Profile tab)
		assignmentsTab: "Groups",
		assignmentsTabShort: "Groups",
		myCoachesTitle: "Assigned coaches",
		noCoachesAssigned: "No assigned coach",
		trainingGroupsTitle: "Training groups",
		noTrainingGroupsAssigned: "You are not part of any training group",
		viewGroupDetails: "Details",
		groupDetailsTitle: "Group details",
		leaveTrainingGroupAction: "Leave group",
		leaveTrainingGroupConfirm: "Do you want to leave this training group?",
		leftTrainingGroupSuccess: "You left the training group",
		leaveTrainingGroupError: "Unable to leave the group",
		activeProgramsTitle: "Active programs",
		noActiveProgramsInGroup: "No active program for this group",
		teammatesTitle: "Training teammates",
		noTeammatesInGroup: "No teammates in this group",
		activeProgramsCountLabel: "programs",
		teammatesCountLabel: "teammates",
		// Program Builder - exercise/discipline option labels
		ergTypeRowerg: "RowErg",
		ergTypeBikeerg: "BikeErg",
		ergTypeSkierg: "SkiErg",
		ergTypeAssaultBike: "AssaultBike",
		ergTypeMixedErg: "Mixed",
		ergTypeCustom: "Custom",
		ergTypeBenchmark: "Benchmark",
		exTypeStrength: "Strength",
		exTypeRunning: "Running",
		exTypeSwim: "Swim",
		exTypeBike: "Bike",
		exTypeErg: "Erg",
		exTypeConditioning: "Conditioning",
		exTypeDryFire: "Dry Fire",
		exTypeLiveFire: "Live Fire",
		shootTargetIpsc: "IPSC target",
		shootTargetMiniIpsc: "Mini IPSC",
		shootTargetIdpa: "IDPA target",
		shootTargetNoShoot: "IPSC no-shoot",
		shootTargetNoShootIdpa: "IDPA no-shoot",
		shootTargetBobber: "Bobber",
		shootTargetPopper: "Popper",
		shootTargetMiniPopper: "Mini popper",
		shootTargetPopperLarge: "Large popper",
		shootTargetPlate: "Round plate",
		shootTargetPlateLarge: "Large plate",
		shootTargetCustom: "Other",
		shootFocusDraw: "Draw",
		shootFocusTransitions: "Transitions",
		shootFocusReload: "Reload",
		shootFocusMovement: "Movement",
		shootFocusAccuracy: "Accuracy",
		shootFocusStage: "Stage sequence",
		shootFocusManipulation: "Gun handling",
		runTypeLungo: "Long run",
		runTypeProgressivo: "Progressive",
		runTypeRipetute: "Intervals",
		runTypeFartlek: "Fartlek",
		runTypeSalite: "Hill repeats",
		runTypeBenchmark: "Benchmark",
		runTypeCustom: "Custom",
		swimTypeIntervals: "Intervals",
		swimTypeEndurance: "Endurance",
		swimTypeTechnique: "Technique",
		swimTypeDrill: "Drills",
		swimTypeThreshold: "Threshold",
		swimTypeSprint: "Sprint",
		swimTypeMixed: "Mixed",
		swimTypeRecovery: "Recovery",
		swimTypeBenchmark: "Benchmark",
		swimTypeCustom: "Custom",
		swimStrokeStileLibero: "Freestyle",
		swimStrokeDorso: "Backstroke",
		swimStrokeRana: "Breaststroke",
		swimStrokeDelfino: "Butterfly",
		swimStrokeMisto: "Medley",
		swimGearPullbuoy: "Pull buoy",
		swimGearPalette: "Paddles",
		swimGearPinne: "Fins",
		swimGearTavoletta: "Kickboard",
		swimGearSnorkel: "Snorkel",
		swimGearElastico: "Resistance band",
		bikeTypeEndurance: "Endurance",
		bikeTypeTempo: "Tempo",
		bikeTypeThreshold: "Threshold (FTP)",
		bikeTypeIntervals: "Intervals",
		bikeTypeVo2max: "VO2max",
		bikeTypeHillRepeats: "Hill repeats",
		bikeTypeSprint: "Sprint",
		bikeTypeRecovery: "Recovery",
		bikeTypeBenchmark: "Benchmark",
		bikeTypeCustom: "Custom",
		// Program Builder - discipline forms (shared)
		pbSelectBenchmark: "Select benchmark",
		pbReferenceBenchmark: "Reference benchmark",
		pbPaceReference: "Pace reference",
		pbPacePercent: "% of pace",
		pbPaceRefAt: "At",
		pbPaceRefOfPace: "% of the pace of",
		pbExtraNotesPlaceholder: "Additional notes...",
		pbTargetTime: "Target time",
		pbEg85: "Ex: 85",
		pbNoBenchmarkSwim:
			"No swim benchmark configured. Set them up in the Admin panel.",
		pbNoBenchmarkRunning:
			"No running benchmark configured. Set them up in the Admin panel.",
		pbNoBenchmarkRunningShort: "No running benchmark available",
		pbSwimTypeLabel: "Swim type",
		pbSwimStrokeLabel: "Stroke",
		pbSwimGearLabel: "Equipment",
		pbSwimPacePer100: "Pace/100m",
		pbSwimWarmupPlaceholder: "Ex: 400m medley, 200m kick...",
		pbSwimCooldownPlaceholder: "Ex: 200m medley cooldown...",
		pbSwimFreePlaceholder: "Describe the swim session freely...",
		pbSwimGearSetPlaceholder: "paddles, fins...",
		pbSwimGearSessionPlaceholder: "kickboard, fins, pull buoy...",
		// Program Builder - running form
		pbRunTypeLabel: "Run type",
		pbRunWarmupPlaceholder: "Ex: 15' easy run, 2km easy...",
		pbRunCooldownPlaceholder: "Ex: 10' easy run, stretching...",
		pbRunFreePlaceholder: "Describe the run freely...",
		pbPaceTarget: "Target pace",
		pbBenchmarkModifier: "Benchmark modifier",
		pbBenchmarkModifierPlaceholder: "Ex: 85% | +10s | -15s",
		pbRestType: "Rest type",
		pbBlockReps: "Block reps",
		pbTimes: "times",
		pbSegments: "Segments",
		pbSegment: "Segment",
		pbProgressiveSegments: "Progressive segments",
		pbDurationOrDistance: "Duration / Distance",
		pbTotalDistance: "Total distance",
		pbAiWand: "AI wand",
		pbAiParsing: "Parsing...",
		// Program Builder - bike/erg form
		pbTypologyLabel: "Type",
		pbErgMode: "Mode",
		pbErgMixedConfig: "Mixed configuration",
		pbErgModeEndurance: "Endurance",
		pbErgModeConditioning: "Intervals",
		pbBikeWarmupPlaceholder: "Ex: 20' Z1-Z2 progressive...",
		pbBikeCooldownPlaceholder: "Ex: 15' Z1 cooldown...",
		pbErgFreePlaceholder: "Describe the erg session freely...",
		pbBikeFreePlaceholder: "Describe the bike session freely...",
		pbCadence: "Cadence",
		pbPower: "Power",
		// Program Builder - shooting form
		pbShootFirearmHandgun: "Handgun",
		pbShootFirearmRifle: "Rifle",
		pbShootFirearmShotgun: "Shotgun",
		pbShootFirearmPcc: "PCC",
		pbShootFormatStructured: "Structured",
		pbShootFormatStructuredHint: "measurable",
		pbShootFormatFree: "Free",
		pbShootFormatFreeHint: "described in words",
		pbShootFreeTitlePlaceholder: "Ex: Front sight focus",
		pbShootWhatToDo: "What to do",
		pbShootWhatToDoPlaceholder:
			"Line up the sights and work on focus, alternating between the rear notch and the target.",
		pbShootFirearm: "Firearm",
		pbShootFirearmUnset: "Not specified",
		pbShootFirearmUnsetLong: "Firearm: not specified",
		pbShootFocus: "Focus",
		pbShootFocusUnset: "Focus: not specified",
		pbShootPickFromLibrary: "Reuse a drill from the library",
		pbShootDrillSection: "The drill",
		pbShootHowMuch: "How much",
		pbShootHowMuchHint: "Repetitions and the time cap for each.",
		pbShootParTime: "Par time (s)",
		pbShootSeries: "Series",
		pbShootExpectedShots: "Expected shots",
		pbShootStageSection: "Stage",
		pbShootStageHint:
			"Distance belongs to the target: a drill with three targets at 5, 10 and 15 metres has no single distance.",
		pbShootTarget: "Target",
		pbShootNoTarget: "No target specified.",
		pbShootStageMap: "Stage diagram",
		pbShootCloseDrawing: "Close the diagram",
		pbShootDrawStage: "Draw the stage",
		pbShootUploadImage: "Upload image",
		pbShootHowJudged: "How it is scored",
		pbShootHowJudgedHint:
			"The scoring system decides which zones the athlete fills in and how the result is computed.",
		pbShootScoringSystem: "Scoring system",
		pbShootNoScoringWarning:
			"Without a scoring system the athlete cannot record a live-fire result.",
		pbShootSuccessCriteriaLive: "Success criterion — e.g. HF > 5.0 with 90% A",
		pbShootSuccessCriteriaDry: "Success criterion — 80% within the par time",
		pbShootOtherDetails: "Other details",
		pbShootStartPosition: "Start position — holstered, hands above shoulders",
		pbShootSetupNotes: "Setup notes — cover, activators, angles",
		pbShootStageSector: "Stage sector — if you use the day's layout",
		// ── Shooting: start conditions, goals, series (FITDS 8.1-8.2) ──
		// ── Warmup library ──
		pbWarmupFromLibrary: "Library",
		pbWarmupSaveToLibrary: "Save this warm-up to the library",
		pbWarmupSavePrompt: "What do you call it?",
		pbWarmupSaved: "Warm-up saved to the library",
		pbShootStartSection: "Start conditions",
		pbShootStartSectionHint:
			"How the firearm and the shooter are at the start signal",
		pbShootStartFirearm: "Firearm ready condition",
		pbShootStartFirearmHint:
			"Rule 8.1 — how the firearm is at the start signal",
		pbShootStartShooter: "Shooter ready condition",
		pbShootStartShooterHint:
			"Rule 8.2 — the stance; the default is standing, arms relaxed at the sides",
		pbShootGoalSection: "Goal and logging",
		pbShootAthleteGoal: "Goal for the athlete",
		pbShootAthleteGoalHint:
			"What they have to achieve. They see it in the diary.",
		pbShootScoringInstructions: "What to record",
		pbShootScoringInstructionsHint:
			"If the score has to be taken a particular way, say it here.",
		pbShootScoringInstructionsPlaceholder:
			"e.g. record only the split between the two shots",
		pbShootCoachNotes: "Coach technical notes",
		pbShootCoachNotesHint: "For you and whoever reads the program.",
		pbShootCoachNotesPlaceholder: "Typical mistakes, what to insist on",
		pbShootAthleteNotesHint: "The message to the athlete about this day.",
		pbShootSetupNotesHint:
			"What the target list does not say: angles, cover, activators.",
		pbShootStageSectorHint: "Which part of the layout this drill uses.",
		pbShootSeriesSection: "Planned series",
		pbShootSeriesHint:
			"A series is one repetition of the exercise. Define them to get a score per distance.",
		pbShootSeries: "Series",
		pbShootNoSeries:
			"No series defined: the athlete adds as many as they shoot.",
		pbShootSeriesLabelPlaceholder: "Optional — e.g. kneeling",
		pbShootTargets: "Targets",
		pbShootFromLibrary: "Library drill",
		pbShootFromLibraryHint: "Configured in the library: read-only here.",
		pbShootViewStage: "Open the stage map",
		pbShootUnlink: "Unlink",
		pbShootUnlinkHint:
			"Unlink from the drill to edit targets and stage map here",
		pbShootAthleteNotes: "Notes for the athlete",
		pbShootAthleteWillSee: "The athlete will see",
		pbShootToFill: "to be filled in",
		pbShootUploadFailed: "Upload failed",
		pbShootStandardSuffix: "standard",
		// Program Builder - shooting form (live fire hint)
		pbShootHowMuchHintLive: "Series to shoot and rounds to bring.",
		// ── Shooting: second test session (docs/shooting/15) ──
		pbUnsavedLeaveConfirm: "You have unsaved changes. Leave without saving?",
		pbShootLibraryPickerTitle: "Reuse a drill from the library",
		pbShootLibraryPickerHint:
			"Targets, stage map and scoring come already configured.",
		pbShootLibraryCount: "drills in the library",
		pbShootLibraryEmptyHint:
			"No drills in the library yet: create one in the Drill library and it shows up here.",
		pbShootDrillName: "Drill name",
		pbShootDiscipline: "Discipline",
		pbShootAllDisciplines: "All",
		pbShootVideo: "Demo video",
		pbShootVideoPlaceholder: "YouTube or video link",
		pbShootDescription: "Description",
		pbShootDescriptionPlaceholder:
			"How to run it, what to focus on, typical mistakes.",
		pbShootBenchmark: "Benchmark drill for the performance profile",
		pbShootSeriesCount: "How many series",
		pbShootSeriesCountHint:
			"A series is one repetition of the exercise, with its own score.",
		pbShootSeriesDetail: "Per-series detail",
		pbShootSeriesDetailHint:
			"Only if something changes between series — typically the distance (5, 10, 15 m). Not needed on a stage with a start box.",
		pbShootSeriesDistance: "Distance",
		pbShootSeriesLabel: "Label",
		pbShootRoundsPerSeries: "Rounds per series",
		pbShootRoundsPerSeriesHint:
			"The rounds of one series. With targets on the map they count themselves.",
		pbShootRoundsFromTargets: "from the targets",
		pbShootRoundsTotal: "Rounds to bring",
		pbShootRoundsMismatch:
			"You wrote {declared} rounds, but the targets count {fromTargets}: the shooter will only be able to log {fromTargets}.",
		pbShootRoundsApply: "Set {declared} rounds on the targets",
		pbShootRoundsApplyManual:
			"Set the rounds target by target in the “Hits” column.",
		pbShootRoundsApplied: "Rounds updated on the targets",
		pbShootTargetTableHint:
			"The table is what the shooter fills in: one score row per T. Write it by hand or let the drawing produce it.",
		pbShootColQty: "Qty",
		pbShootColTarget: "Target",
		pbShootColDistance: "Distance",
		pbShootColHits: "Hits",
		pbShootColHitsHint:
			"Hits that count on that target. Empty = rulebook (paper 2, steel 1).",
		pbShootAttachments: "Other files",
		pbShootAttachmentsHint:
			"The target photo, a stage detail: anything that is not the stage map.",
		pbShootAddAttachment: "Add image",
		pbShootAttachmentLabelPlaceholder: "e.g. target, position 2",
		pbShootGenerateImage: "Generate image from the drawing",
		pbShootImageGenerated: "Image generated from the drawing",
		pbShootZoom: "Zoom",
		pbShootMissing: "Missing",
		pbShootMissingName: "the drill name",
		pbShootMissingScoring: "the scoring system",
		pbShootScoringZones: "Zones and penalties",
		pbShootReps: "Repetitions",
		pbShootDryQuantityHint: "Repetitions and the time cap for each.",
		pbShootPrintSheet: "Print score sheet",
		pbShootPrintStage: "Print stage map",
		pbShootScoreTimeOptional: "Add the time",
		pbShootScorePickSystem: "Scoring system",
		pbShootScorePickSystemHint:
			"The drill has none: choose which table to log with.",
		shootTargetMicroIpsc: "Micro IPSC",
		shootTargetPlateRect: "Plate 15×15",
		shootTargetPlateRectLarge: "Plate 30×30",
		shootTargetPlateRack: "Plate rack",
		shootTargetNoShootMetal: "Steel no-shoot",
		pbRxShotsPerSeries: "rounds/series",
		pbShootNotIndicated: "Not specified",
		pbShootCustomOption: "Other — write it",
		pbShootDescribeCondition: "Describe the condition",
		pbShootDrillSaved: "Drill saved",
		pbShootDrillCopied: "Copied to your library",
		pbShootDrillDeactivated: "Drill deactivated",
		pbShootEditDrill: "Edit drill",
		pbShootNewDrill: "New drill",
		pbShootSaveDrill: "Save drill",
		pbShootNoDrills: "No drills in the library.",
		pbShootNoDrillsHint:
			"Create one and you will find it in the ProgramBuilder without retyping it.",
		pbShootCopyToLibrary: "Copy to my library",
		// Program Builder - conditioning form
		conditioningNameAutoHint:
			"Optional. Leave it empty and the title is generated from the conditioning type.",
		pbEnduranceNameAutoHint:
			"Until you change it, it follows the chosen type. Leave it empty and it is generated from the type.",
		pbCondUseLibraryTemplate: "Use a library template",
		pbCondTemplatesAvailable: "available",
		pbCondSearchTemplate: "Search templates...",
		pbCondSavingToLibrary: "Saving to library...",
		pbCondSaveToLibrary: "Save to personal library",
		pbCondLinkedToLibrary: "Template linked to the personal library",
		pbKeepCurrent: "Keep current",
		// Program Builder - conditioning template editor
		pbCondNamePlaceholder: "e.g. Fran, Cindy, Hero WOD...",
		pbWodType: "WOD type",
		pbTimeMin: "Time (min)",
		pbEnterDurationMin: "Enter duration (min), e.g. 12",
		pbEnterRoundsOrScheme: "Enter rounds or scheme (e.g. 3 or 21-15-9)",
		pbTimeCapMin: "TC (min)",
		pbEg20: "Ex. 20",
		pbRoundDuration: "Round duration",
		pbEmomRoundBuilder: "EMOM round builder",
		pbAddRound: "Add round",
		pbMoveRoundUp: "Move round up",
		pbMoveRoundDown: "Move round down",
		pbEmomOddRound: "Odd round",
		pbEmomEvenRound: "Even round",
		pbEmomSpecificRound: "Specific round",
		pbCustomLabel: "Custom",
		pbRoundTitlePlaceholder: "Round title (optional)",
		pbLibraryLabel: "Library",
		pbLoadMaleFemale: "Load men/women",
		pbRoundContentPlaceholder:
			"Round content (e.g. 10 thrusters @40kg + 8 burpees, or 40s work / 20s rest)",
		pbEmomNotes: "EMOM notes",
		pbEmomNotesPlaceholder: "Additional EMOM notes...",
		pbCycles: "Cycles",
		pbWorkBlockPlaceholder: "Ex. 5 burpees + 10 double unders + 30m sled push",
		pbHiitScheme: "Scheme",
		pbHiitSchemePlaceholder: "21-15-9 or 3 rounds",
		pbHiitTimeCap: "Time cap",
		pbHiitDuration: "Duration",
		pbHiitRestFixed: "Fixed",
		pbHiitRestRatio: "Ratio",
		pbHiitRatioField: "Work : Rest",
		pbHiitRatioResult: "Resulting",
		pbHiitDescribeBlock: "Describe the block",
		pbHiitPreview: "Preview",
		pbHiitPreviewEmpty: "Fill in the fields above",
		pbHiitCycleOne: "cycle",
		pbHiitCycleMany: "cycles",
		pbHiitTotalApprox: "total",
		pbHiitMissingWork: "work duration missing",
		pbHiitMissingRest: "rest missing",
		pbHiitInvalidRatio: "invalid ratio",
		pbWodCustomDescription: "WOD description (custom format)",
		pbStartTypingToSearch: "Start typing to search",
		pbDescriptionOptional: "Description (optional)",
		pbVideoUrlOptional: "Video URL (optional)",
		pbWodNotes: "WOD notes",
		pbWodNotesPlaceholder: "Additional WOD notes...",
		pbAiWandDisabledForCoach:
			"AI wand is visible but currently disabled for this coach.",
		pbAiDisabledForCoach:
			"AI features are currently disabled for this coach by the administrator.",
		pbAiWriteConditioningFirst: "Write the conditioning to parse first",
		pbAiWriteExerciseFirst: "Write the exercise to parse first",
		pbAiWriteWorkoutFirst: "Write the workout to parse first",
		pbAiParseFailed: "AI could not parse the text",
		pbAiParseError: "AI parsing error",
		pbAiConvertedTo: "Converted to",
		pbVideoUnavailable: "No video available for this exercise",
		// Program Builder - shared toasts
		pbEnterExerciseName: "Enter a name for the exercise",
		pbExerciseAddedToPersonalLibrary: "added to your personal library!",
		pbVideoPreviewOf: "Video preview",
		// Program Builder - conditioning result schema editor
		pbSchemaTitle: "Result schema (optional)",
		pbSchemaEmpty:
			"No schema configured — the default input for the conditioning type will be used.",
		pbSchemaFieldTitlePlaceholder: "Result title (e.g. Total time)",
		pbSchemaRemoveField: "Remove field",
		pbSchemaOrderHint:
			"Ordering: reps/kg/meters/points → higher is better. seconds/minutes/MM:SS → lower is better.",
		pbMoveUp: "Move up",
		pbMoveDown: "Move down",
		// Program Builder - result unit types
		resultUnitKg: "Weight (kg)",
		resultUnitReps: "Repetitions",
		resultUnitSeconds: "Seconds",
		resultUnitMinutes: "Minutes",
		resultUnitMinutesSeconds: "MM:SS",
		resultUnitTimeOrReps: "Time or Reps (mm:ss or reps)",
		resultUnitMeters: "Meters",
		resultUnitPoints: "Points",
		resultUnitHitFactor: "Hit factor",
		pbSchemaLockedHint:
			"Schema locked: this conditioning already has recorded results. You can only edit field labels, not the type.",
		// Program Builder - result schema editor hint
		pbSchemaConfiguredHint:
			"When configured, the athlete enters these values instead of the default input. The leaderboard uses these fields and sorts by their type.",
		// Program Builder - page: toasts
		pbLoadError: "Loading error",
		pbSchemaLockedToastFull:
			"Result schema locked: this conditioning already has recorded results. You can only change field labels, not the type (unit), and you cannot add or remove fields. Schema changes were not applied.",
		pbWeekLoadFailed: "Could not load the week",
		pbSaveBeforeSharing:
			"Save the program first, then start sharing to avoid inconsistencies.",
		pbSaveSourceBeforeSharing: "Save the source program before sharing",
		pbSelectedProgramLoadError: "Error loading the selected program",
		pbSelectTargetWeek: "Select a target week",
		pbSelectTargetDay: "Select a target day",
		pbExportError: "Export error",
		pbDayAdded: "Day added",
		pbDayRemoved: "Day removed",
		pbDayDuplicated: "Day duplicated",
		pbSharedExerciseSourceOnly:
			"Shared exercise: editable only from the source program",
		pbSharedExerciseLockedTarget:
			"Shared exercise: settings are locked in the target program",
		pbAiInterpretedAs: "Parsed as",
		pbNameTheDrill: "Give the drill a name",
		pbComplexNeedsTwo: "A complex needs at least 2 exercises",
		pbSupersetNeedsTwo: "A superset needs at least 2 exercises",
		pbEnterSetCount: "Enter the number of sets",
		pbAddAtLeastOneEmomRound: "Add at least one EMOM round",
		pbEnterCustomDescription: "Enter a custom description",
		pbSelectConditioningType: "Select the conditioning type",
		pbSavedWithoutSchema:
			"Saved without a result schema: athletes will enter a free-form result and the ranking may be less comparable.",
		pbEnterNameBeforeSaving: "Enter a name before saving to the library",
		pbConditioningSavedToLibrary: "Conditioning saved to your personal library",
		pbDuplicatedIn: "Duplicated into",
		pbNextWeekShort: "next week",
		pbSelectCoach: "Select a coach",
		pbSelectCoachTeam: "Select a coach team",
		pbConfigureSchemaNow:
			"Configure the result schema now: it is in the highlighted section below.",
		// Program Builder - page: UI chrome
		pbDetails: "Details",
		pbEditing: "Editing",
		pbProgramLabel: "Program",
		pbNoExercises: "No exercises",
		pbSelectExercise: "Select an exercise",
		pbMethodStandard: "Standard",
		pbRoundLabel: "Round",
		pbPreviewRendering: "Rendering preview",
		pbPreviewRenderingHint:
			"Simulates the athlete's mobile screen so you can check how exercises render before publishing.",
		pbNoGroupCreated: "No group created",
		pbCoachTeamAccess: "Coach team access",
		pbCoachesWithAccess: "Coaches with access",
		pbSelectCoachPlaceholder: "Select coach",
		pbCoachTeamsWithAccess: "Coach teams with access",
		pbNoCoachTeamAssigned: "No coach team assigned",
		pbSelectCoachTeamPlaceholder: "Select coach team",
		pbCoachAiDisabledTitle: "Coach AI temporarily disabled",
		pbCoachAiDisabledBody:
			"The AI wand and the assistant stay visible in the builder, but they are not operational for this coach.",
		pbRemoveDate: "Remove date",
		pbPreviewAthletes: "Preview athletes",
		pbPublishPreviewOnlyFor: "Publish in preview only for",
		pbWeekName: "Week title",
		pbDuplicateWeek: "Duplicate week",
		pbShareWeek: "Share week",
		pbExportWeek: "Export week",
		pbEditDayTitleAndDate: "Edit day title and date",
		pbSectionOpenHintEsc:
			'This section is open. Press ESC or click "Close" to exit.',
		pbSectionOpenHintShort: 'Section open. Press ESC or click "Close".',
		pbDayTitle: "Day title",
		pbDayDate: "Day date",
		pbDayDetails: "Day details",
		pbConfigured: "Configured",
		pbEditDayDetails: "Edit day details",
		pbWarmup: "Warm-up",
		pbWarmupPlaceholder: "Quick warm-up...",
		pbCooldown: "Cool-down",
		pbCooldownPlaceholder: "Quick cool-down...",
		pbDayNotes: "Day Notes",
		pbQuickNotesPlaceholder: "Quick notes...",
		pbSessions: "Sessions",
		pbMoveSessionUp: "Move session up",
		pbMoveSessionDown: "Move session down",
		pbRemoveSession: "Remove session",
		pbNewSession: "New session",
		pbSharedExerciseReadonly: "Shared exercise (read-only)",
		pbDragToReorderExercise: "Drag to reorder exercise",
		pbNoSession: "No session",
		pbLocalNote: "Local note (this program only)",
		pbLocalNotePlaceholder: "Add a local note for this shared exercise",
		pbSetRowNote: "Set note",
		pbRemoveSetRowNote: "Remove this set's note",
		pbMovementNote: "Movement note",
		pbRemoveMovementNote: "Remove this movement's note",
		pbSequence: "Sequence",
		pbPercentOrLoad: "% or load",
		pbEg230: "Ex. 2:30",
		pbMethodology: "Method",
		pbMethodSuperset: "Superset",
		pbMethodEmom: "EMOM",
		pbSearchOrAddExercise: "Search or type a new exercise...",
		pbAddRow: "Add row",
		pbExerciseNotes: "Exercise notes",
		pbExerciseNotesPlaceholder:
			"Notes for the exercise (tempo, technique, cues...)",
		pbExerciseSequence: "Exercise sequence",
		pbChangeExercise: "Change exercise",
		pbAddExerciseToSequence: "Add an exercise to the sequence...",
		pbComplexNotes: "Complex notes",
		pbComplexNotesPlaceholder: "Notes for the complex...",
		pbComplexNamePlaceholder: "Ex: Back Squat - technique variation",
		pbAiFreeTextPlaceholder:
			"Ex: 5x5 BS @75% rest 2' / E2MOM 10' 3 PC @80% / A1 BS 4x8 + A2 RDL 4x10",
		pbAthleteCuesPlaceholder: "Additional cues for the athlete...",
		pbTotalRounds: "Total rounds",
		pbRestBetweenRounds: "Rest between rounds",
		pbSupersetNotes: "Superset notes",
		pbSupersetNotesPlaceholder: "Notes for the superset...",
		pbExerciseNotesShortPlaceholder: "Exercise notes...",
		pbSearchExerciseToAdd: "Search an exercise to add...",
		pbNoDay: "No day",
		pbAthletePreview: "Athlete view preview",
		pbPreviewContext: "Preview context",
		pbConfigureConditioningResult: "Configure conditioning result",
		pbConfigureConditioningResultBody:
			"This custom conditioning has no result schema yet. Configuring it now makes result entry and ranking more consistent.",
		pbContinueWithoutSchema: "Continue without a schema",
		pbConfigureSchemaNowCta: "Configure schema now",
		pbLoadingPrograms: "Loading programs...",
		pbParentFolder: "Parent folder",
		pbNoProgramInFolder: "No program found in this folder",
		pbTargetProgram: "Target program",
		pbTargetWeek: "Target week",
		pbPickWeek: "Pick a week",
		pbTargetDay: "Target day",
		pbPickDay: "Pick a day",
		pbShared: "shared",
		pbShareWeekExplain:
			"into the target week. Days are matched automatically by weekday (or by day number for undated programs). Shared exercises stay in sync.",
		pbUnsavedBeforeSharing:
			"There are unsaved changes. Save the program before sharing.",
		pbWarmupShort: "WU:",
		pbCooldownShort: "CD:",
		// Program Builder - page: misc
		pbUnknownError: "unknown error",
		pbErrorShort: "error",
		pbSchemaLockedToastSaved:
			"Result schema locked: this conditioning already has recorded results. You can only change field labels, not the type (unit), and you cannot add or remove fields. Schema changes were not saved.",
		pbAiCoachAssistant: "AI Coach Assistant",
		// Program Builder - page: wrapped texts
		pbShareWeekExplainFull:
			"All exercises in the week will be shared into the target week. Days are matched automatically by weekday (or by day number for undated programs). Shared exercises stay in sync with the original.",
		pbUntitled: "Untitled",
		// Program Builder - rounds placeholder
		pbRoundsPlaceholder: "3 or 3/4",
		// Program Builder - week status, plurals, day label
		day: "Day",
		dayOne: "day",
		daysLower: "days",
		pbWeekReactivate: "Reactivate",
		pbSchedulePublish: "Publish on...",
		pbPublishOn: "Publish on",
		pbPublishNowInstead: "Publish now instead",
		pbWeekConflictFirstDay: "warning: the workouts start",
		pbWeekConflictPublish: "warning: it publishes",
		pbWeekConflictButHidden: "but athletes only see it through",
		pbPublishNow: "Publish now",
		pbVisibleUntil: "Visible through",
		pbVisibleUntilPick: "Visible through…",
		pbStaysVisible: "Stays visible",
		pbWeekMoreActions: "More week actions",
		pbDeleteWeekAction: "Delete Week",
		pbWeekStatusVisible: "Visible to athletes",
		pbWeekStatusVisibleSince: "Visible since",
		pbWeekStatusScheduled: "Publishes on",
		pbWeekStatusHidden: "Hidden since",
		pbWeekStatusDraft: "Not visible to athletes",
		pbFirstDayQuestion: "When does it start?",
		pbFirstDayToday: "Today",
		pbFirstDayNextMonday: "Next Monday",
		pbFirstDayCustom: "Another date",
		pbFirstDaySentence: "Week 1 from {date}.",
		pbWeekVisibleUntil: "visible through",
		pbWeekStaysVisible: "stays visible",
		pbWeekHideAuto: "automatic",
		pbWeekHideManual: "chosen date",
		pbWeekPreviewFor: "previewed by",
		pbWeekSeenBy: "see it",
		pbWeekSeenByOne: "sees it",
		pbWeekNoAthletes: "no athlete assigned",
		pbWeekAfterSave: "after saving",
		pbWeekHeld: "Held back: it does not publish until you release it",
		pbWeekHeldStarts: "workouts start",
		pbWeekNoDatedDays: "without dated days it does not publish by itself",
		pbWeekConflictEmpty: "and it is still empty",
		pbHoldWeek: "Hold back",
		pbReleaseWeek: "Release",
		pbSavedWeekScheduled: "publishes on",
		pbSavedAutoPublishOn: "Automatic publishing on",
		pbSavedAutoPublishOff: "Automatic publishing off",
		pbAutoPublishDialogTitle: "Turn on automatic publishing?",
		pbAutoPublishDialogBody:
			"These weeks are visible to athletes today (or scheduled before their turn). With automatic publishing each one will appear by itself:",
		pbAutoPublishDialogFooter:
			"Past weeks and the current one do not change. It applies on save: read it in each week's status line.",
		pbAutoPublishActivate: "Turn on",
		pbSavedWeekPublished: "published to",
		pbSavedWeekPublishedNoAthletes: "published, no athlete assigned",
		pbSavedWeekHidden: "hidden from athletes",
		pbSavedAthleteAdded: "1 athlete added",
		pbSavedAthletesAdded: "athletes added",
		pbHideWeekTitle: "Hide week",
		pbHideWeekTo: "from",
		pbHideWeekBody: "Assigned athletes will no longer see it after the next save. Results already logged stay.",
		pbAthletesSeeWeeks: "They see",
		pbAthletesSeeNothing: "They see nothing yet: no week published",
		pbAssignSelectedCount: "selected",
		pbAssignAllAssigned: "All your athletes are already assigned",
		assignedGroups: "Assigned groups",
		pbVisibleWeeksShort: "visible",
		pbNoVisibleWeeks: "none visible",
		pbDeleteDayConfirm: "Delete this day?",
		// Program Builder - date picker
		pbSelectDate: "Select date",
		// Program Builder - cadence and pace modifier
		pbEvery: "every",
		pbMinuteOne: "minute",
		pbMinuteMany: "minutes",
		pbPaceModifierSyntax: "Syntax: 85% or +10s / -15s",
		pbPaceModifierInvalid: "Invalid format. Examples: 85% | +10s | -15s",
		pbBenchmarkPercentage: "Benchmark percentage",
		// Program Builder - compact prescription tokens
		pbRxRec: "rest",
		pbRxSegments: "segments",
		pbRxSegFast: "fast",
		pbRxSegMedium: "medium",
		pbRxSegSlow: "slow",
		pbRxCap: "cap",
		pbRxRound: "round",
		pbRxCycles: "cycles",
		pbRxWork: "work",
		pbRxReps: "reps",
		pbRxSeries: "series",
		pbRxShots: "shots",
		pbRxFree: "free",
		pbRxHandgun: "handgun",
		pbRxRifle: "rifle",
		pbRxShotgun: "shotgun",
		pbRxPcc: "PCC",
		// Program Builder - interval section headings
		pbHillRepeats: "Hill repeats",
		pbThresholdBlocks: "Threshold blocks",
		pbVo2maxIntervals: "VO2max intervals",
		pbErgConditioningBlocks: "Erg conditioning blocks",
		pbIntervals: "Intervals",
		pbIntervalSeries: "Interval series",
		// Program Builder - sharing, tooltips, dialogs
		pbSourceWeekNotFound: "Source week not found",
		pbSourceDayNotFound: "Source day not found",
		pbTargetWeekNotFound: "Target week not found",
		pbSourceExerciseNotFound: "Source exercise not found",
		pbInvalidTarget: "Invalid target",
		pbSaveSourceToShareExercises:
			"Save the source program before sharing exercises",
		pbSaveSourceToShareWeek: "Save the source program before sharing the week",
		pbCannotUpdateSource: "Could not update the source",
		pbCannotShareWeekWithItself: "A week cannot be shared with itself",
		pbSourceWeekHasNoExercises: "The source week has no exercises to share",
		pbExerciseShareDone: "Exercise shared",
		pbWeekShareDone: "Week shared",
		pbExportDone: "Export complete",
		pbExerciseUpdated: "Exercise updated",
		pbExerciseAdded: "Exercise added",
		pbTemplateNotCreated: "Template was not created correctly",
		pbLibrarySaveError: "Error saving to the library",
		pbUntitledProgram: "Untitled program",
		pbDatedProgramDragHint: "Dated program: ordered automatically by date",
		pbDragToReorderDay: "Drag to reorder the day",
		pbHasTitle: "Title",
		pbNoTitle: "No title",
		pbNoWarmup: "No warm-up",
		pbNoCooldown: "No cool-down",
		pbHasNotes: "Notes",
		pbNoNotes: "No notes",
		pbSourceProgramFallback: "source program",
		pbSessionPrefix: "Session",
		pbSharedWith: "Shared with",
		pbProgramOne: "program",
		pbProgramMany: "programs",
		pbSharingActive: "Sharing active",
		pbSharingActiveNoTarget: "Sharing active - no target program",
		pbExerciseGlobalLibrary: "Exercise from the global library",
		pbExercisePersonalLibrary: "Exercise from your personal library",
		supersetNameAutoHint:
			"Optional. Leave it empty and the name is generated from the selected exercises.",
		emomNameAutoHint:
			"Optional. Leave it empty and the name is generated from rounds and cadence.",
		pbCaloriesMaleFemale: "Calories men/women (e.g. 20/16)",
		pbAddToPersonalLibrary: "to your personal library",
		pbExportWeekTitle: "Export week",
		pbShareWeekTitle: "Share week",
		pbExportDayTitle: "Export day",
		pbShareExerciseTitle: "Share exercise",
		pbExportExerciseTitle: "Export exercise",
		pbExportToOtherProgram: "Export to another program",
		pbSelectAProgram: "Select a program",
		pbSharingInProgress: "Sharing...",
		pbExportInProgress: "Exporting...",
		pbConfirmShare: "Confirm sharing",
		pbConfirmExport: "Confirm export",
		pbVideoPreviewOfLabel: "Video preview",
		// Program Builder - day summary chips
		pbCreateAndSelect: "Create and select",
		pbSaving: "Saving...",
		// Program Builder - generated label suffix
		pbCopySuffix: "copy",
		// Monitoraggio atleti (docs/monitoring/)
		monitoring: "Monitoring",
		monTitle: "Athlete monitoring",
		monSubtitle: "Who is training, what was programmed and what they recorded, over the chosen period.",
		monViewOverview: "Overview",
		monViewAttendance: "Day register",
		monViewAttendanceShort: "Register",
		monSortBy: "Sort by",
		monSortAscending: "Ascending: tap to reverse",
		monSortDescending: "Descending: tap to reverse",
		monOverviewHintTouch: "Tap an athlete to open the period panel.",
		monUndatedShort: "Undated programs",
		monAttendanceTapHint: "Tap a day or the name to open the athlete panel.",
		monHowToRead: "How to read these charts",
		monPeriod: "Period",
		monPeriod7d: "Last 7 days",
		monPeriod14d: "Last 14 days",
		monPeriod28d: "Last 28 days",
		monPeriodThisWeek: "This week (Mon-Sun)",
		monPeriodLastWeek: "Last week (Mon-Sun)",
		monGroupFilter: "Group",
		monAllGroups: "All athletes",
		monProgramFilter: "Program",
		monAllPrograms: "All programs",
		monSearchAthlete: "Search athlete (name or email)",
		monColAthlete: "Athlete",
		monColLastActivity: "Last activity",
		monColOutcome: "Outcome on assigned days",
		monColExtra: "Extra",
		monColWellness: "Wellness",
		monColFlags: "Alerts",
		monCompleteShort: "complete",
		monPartialShort: "partial",
		monMissingShort: "no outcome",
		monOutOf: "of",
		monAssignedShort: "assigned",
		monUpcomingShort: "upcoming",
		monNoAssignedDays: "No assigned days in the period",
		monNoActivityLookback: "No activity in the last 90 days",
		monDaysAgo: "days ago",
		monDaysWord: "days",
		monExtraDays: "days with extra activity",
		monWellnessOff: "Diary off",
		monWellnessCheckins: "check-ins",
		monWellnessLast: "last",
		monUndatedPrograms: "Has undated programs: those results appear on the logging date as activity, not as assigned days.",
		monFlagMissingLogs: "days without outcome of",
		monFlagInactive: "No activity for",
		monFlagInactiveOver: "No activity for over",
		monFlagHighRpe: "results with RPE ≥",
		monFlagWellnessLow: "Low wellness on",
		monFlagWellnessGap: "Wellness diary on but empty in the period",
		monFlagNoData: "Insufficient data: no assigned days and no activity",
		monWellnessSleep: "sleep",
		monWellnessEnergy: "energy",
		monWellnessMood: "mood",
		monWellnessSoreness: "soreness",
		monWellnessStress: "stress",
		monStatusComplete: "Outcome complete",
		monStatusPartial: "Partial outcome",
		monStatusNone: "Outcome not recorded",
		monStatusUpcoming: "Upcoming",
		monStatusRest: "No programming",
		monDayEarly: "Done early",
		monEarlyShort: "early",
		monLegend: "Legend",
		monLegendExtra: "Extra activity (manual or diary)",
		monLegendDiary: "Diary entry",
		monLegendSessions: "sessions",
		monPresenceNote: "Attendance is not verified: the platform has no bookings or check-ins. \"Declared activity\" means the athlete recorded something that day; \"outcome not recorded\" does not mean \"not done\".",
		monPresenceDeclared: "declared activity",
		monPresenceUnknown: "attendance not available",
		monBackToList: "Monitoring",
		monOpenAthlete: "Athlete page",
		monSectionDays: "Day by day",
		monSectionWellness: "Wellness",
		monPlanned: "Planned",
		monDone: "Done",
		monNotLogged: "not recorded",
		monLoggedWithoutQuantity: "recorded, quantity not determinable",
		monExercisesLogged: "exercises with an outcome",
		monRestRun: "days with no programming or activity",
		monUnmatched: "Results not matched to a program row",
		monExtraResults: "Extra activity",
		monDiaryEntry: "Diary",
		monColMovement: "Movement",
		monColDays: "Days",
		monColQuantity: "Quantity",
		monColSets: "Sets",
		monColPlanned: "Planned",
		monColQuality: "Data quality",
		monColCoverage: "Coverage",
		monQuantified: "quantified",
		monNoMovements: "No results in the period",
		monTotalsReps: "Movement reps",
		monTotalsTonnage: "Tonnage (load as recorded)",
		monTotalsMeters: "Meters",
		monTotalsSeconds: "Recorded time",
		monTotalsCalories: "Machine calories",
		monTotalsNote: "Each rep counts once and the container of a complex does not count. Tonnage is a recorded quantity, not a difficulty index: it does not compare different exercises. This is the recorded work volume, not the performance profile: there, gymnastics counts the max unbroken set.",
		monQualityRecorded: "recorded",
		monQualityFromPrescription: "from prescription",
		monQualityFromConfirmation: "from confirmation",
		monQualityFromScore: "from score",
		monQualityPartial: "partial",
		monQualityIndeterminate: "not determinable",
		monScaled: "scaled",
		monEmpty: "No athletes in the selected scope",
		monLoadError: "Could not load monitoring",
		monWellnessOffPanel: "The wellness diary is not active for this athlete.",
		monOverviewHint: "Click an athlete to open the period panel.",
		monLoggedOn: "logged on",
		monUndatedProgramResult: "Undated program",
		monOtherDayProgramResult: "Program, other day",
		monAlertSettingsButton: "Alerts",
		monAlertCustomized: "customized",
		monAlertSettingsTitle: "Your alerts",
		monAlertSettingsIntro: "Alerts appear next to athletes in Monitoring. They are yours: choose which to keep on and with which limits. They do not change your colleagues' alerts and they are not a diagnosis, just a prompt to take a look.",
		monAlertMissingTitle: "Days without an outcome",
		monAlertMissingSentence: "Alert me when an athlete has at least {min} assigned days with no recorded result in the period.",
		monAlertMissingExplain: "Counts past program days on which the athlete recorded not even one exercise. It does not mean they did not train: they may have forgotten to log. Useful to know whom to talk to before reading their numbers.",
		monAlertInactiveTitle: "No activity",
		monAlertInactiveSentence: "Alert me when an athlete has recorded nothing for at least {days} days.",
		monAlertInactiveExplain: "Considers program results, manually entered results and diary entries. The wellness check-in does not count as training. Looks back up to 90 days.",
		monAlertRpeTitle: "High perceived effort",
		monAlertRpeSentence: "Alert me when an athlete has at least {count} results with RPE equal to or above {threshold} in the period.",
		monAlertRpeExplain: "RPE is what the athlete writes on a single exercise (1-10 scale), not the whole session. Several very hard results close together may be worth a chat or a load adjustment.",
		monAlertWellnessLowTitle: "Low wellness",
		monAlertWellnessLowSentence: "Alert me when, in the latest check-in no older than {max_age_days} days, at least {fields} items among sleep, energy, mood, soreness and stress are at the two worst levels.",
		monAlertWellnessLowExplain: "Only for athletes with the wellness diary on. Looks at the subjective 1-5 items: sleep, energy and mood at 1-2, soreness and stress at 4-5. No composite score: the alert says which items triggered it.",
		monAlertWellnessGapTitle: "Empty wellness diary",
		monAlertWellnessGapSentence: "Alert me when the wellness diary is on but has no entries over a period of at least {days} days.",
		monAlertWellnessGapExplain: "Tells you that this athlete's wellness charts say nothing, because there is no data. It is an alert about the data, not the athlete.",
		monAlertRange: "Allowed value:",
		monAlertDefault: "Default",
		monAlertReset: "Reset to defaults",
		monAlertSaved: "Alerts saved",
		monAlertSaveError: "Could not save the alerts",
		monSectionTrends: "Trends",
		monAllMovements: "All recorded work",
		monLastWeeks: "Last weeks:",
		monBucket: "Group by",
		monBucketWeek: "Week",
		monBucketSession: "Session",
		monBucketMonth: "Month",
		monBucketProgram: "Program",
		monMetric: "Measure",
		monMetricReps: "Reps",
		monMetricSets: "Sets",
		monMetricTonnage: "Tonnage",
		monMetricTopLoad: "Top load",
		monMetricAvgLoad: "Average load per rep",
		monMetricRpe: "Average RPE",
		monMetricSessions: "Sessions",
		monMetricMeters: "Meters",
		monMetricSeconds: "Time",
		monMetricCalories: "Calories",
		monTrendWindowNote: "Whole weeks, Monday to Sunday, ending on the current week. Each bar says which dates it comes from.",
		monTrendAllMovementsNote: "With all work together only additive measures count: reps, sets, tonnage, sessions.",
		monTrendLoadNote: "Load as recorded by the athlete, with no equipment convention. The heaviest set is the period's top load, the average is tonnage divided by reps with a known load.",
		monTrendAdherence: "Days with an outcome over assigned days",
		monAssignedDays: "Assigned days",
		monDaysWithOutcome: "Days with an outcome",
		monTrendAdherenceNote: "The athlete's adherence to all days delivered in the period, not only the chosen movement. \"With an outcome\" means at least one exercise recorded.",
		monTrendTotals: "Period totals",
		monSportIntro: "The exercises are those of the performance profile active for this sport: the model decides what is monitored. Every card reads the same period in whole weeks.",
		monSportModel: "Model",
		monSportOpenTrend: "Trends",
		monSportAttempts: "attempts",
		monSportBest: "Best result",
		monSportNoResults: "No results in the period",
		monSportNoExercises: "The performance model of this sport has no configured exercises.",
		monSportNoSports: "No sport configured for this athlete: sport dashboards come from the sports on their profile. Below, all recorded work.",
		monSportOtherExercises: "Other model exercises",
		monSportExtraNote: "For an exercise outside the profile choose",
		monFamiliesGroup: "Lifts with their variants",
		monMovementsGroup: "Movements",
		monFamilySnatch: "Snatch and variants",
		monFamilyCleanJerk: "Clean & Jerk and variants",
		monFamilyMembers: "Variants in the period",
		monFamilyMembersNote: "Click a variant to drop it from or return it to the count. Pulls, deadlifts, balances, presses and dumbbell or kettlebell versions stay out by rule: they are not the lift.",
		monFamilyNoMembers: "No variant recorded in the period.",
		monFamilyHint: "Belongs to",
		monFamilyOpen: "See with variants",
		monBandsPrograms: "Programs",
		monBandsPhases: "Mesocycles",
		monBandsNoPhases: "No mesocycle planned in the period",
		monChartsTitle: "Volume and intensity over the period",
		monChartsNote: "One chart per measure, same time axis: two measures with different scales never share an axis. Hover a period to read it on every chart at once. The bands at the top say which program and mesocycle each period belongs to.",
		monChartLoad: "Load (kg)",
		monLoadTop: "Heaviest set",
		monLoadAvg: "Average per rep",
		monMetricIntensity: "Intensity (% of max)",
		monIntensityRealized: "Actual",
		monIntensityRealizedAvg: "Actual, average",
		monIntensityPlanned: "Prescribed",
		monIntensityPlannedAvg: "Prescribed, average",
		monIntensityReference: "Reference max",
		monIntensityNoReference: "No max for this movement, neither in the profile nor in the diary: the actual % cannot be computed. The prescribed %, when present, comes from the program.",
		monIntensityNote: "The prescribed % is the one written in the program: rep-weighted average, range in brackets. The actual % is the recorded load divided by today's reference max: the performance-profile max or, when higher, the best diary estimate, the same one the app uses to turn % into kg. For a family the reference is the full lift.",
		monRefManual: "manual max from the profile",
		monRefTest: "1RM test in the diary",
		monRefEstimate: "diary estimate (Epley)",
		monRpeMax: "Max RPE",
		monColPeriod: "Period",
		monColSessionsShort: "Sessions",
		monColSetsShort: "Sets",
		monColRepsShort: "Reps",
		monColTonnageShort: "Tonn. (kg)",
		monColTopLoadShort: "Top (kg)",
		monColAvgLoadShort: "Avg (kg)",
		monColPlannedPctShort: "% presc.",
		monColIntensityShort: "% max",
		monColRpeShort: "RPE",
		monColOutcomeShort: "Outcomes",
		monTableNote: "Sets and reps: done / planned. Outcomes: days with an outcome over assigned days, for all work. Columns without values in the period are not shown.",
		monSportOpenFamily: "With variants",
		monAboutData: "How to read these numbers",
		monAboutDataText: "Missing data stays missing: it never becomes zero or an absence. Numbers are read now from the recorded results; dates are calendar dates in your time zone.",
		monSummaryAthletes: "athletes",
		monSummaryWithActivity: "with recorded activity",
		monSummaryDaysWithOutcome: "days with an outcome",
		monFlaggedCount: "with alerts",
		monFlaggedShowOnly: "show only them",
		monFlaggedShowAll: "show all",
		monProgramFilterNote: "Only athletes who have this program assigned.",
		monSortAttention: "Attention",
		monSortAttentionNote: "By attention: athletes with alerts first, then minor notices, then the rest. At the bottom, whoever has recorded nothing for 90 days.",
		monSortCustomNote: "Your own order.",
		monSortResetAttention: "Back to attention order",
		monWriteTo: "Message",
		monAthleteLoadError: "Unable to open monitoring for this athlete: they may not be among the athletes you coach.",
		monTrendsWhat: "What to look at",
		monTrendsAllWork: "All work",
		monTrendsBackToProfile: "Profile exercises",
		monTrendsMoreMeasures: "More measures",
		monTrendsFewerMeasures: "Fewer measures",
		monTimesShort: "times",
		monMovementRowHint: "Tap a movement name to see its trend.",
		monOpenMovementTrend: "Trend",
		monSectionDaysShort: "Days",
		monOpenAthleteShort: "Profile",
	},
};

const LanguageContext = createContext(null);

const PUBLIC_AUTO_LANGUAGE_PATHS = ["/", "/info", "/invite", "/ad", "/ads"];
const LANGUAGE_MANUAL_OVERRIDE_KEY = "language_manual_override";

function shouldAutoDetectPublicLanguageByCountry() {
	if (typeof window === "undefined") return false;
	return PUBLIC_AUTO_LANGUAGE_PATHS.some((path) => {
		if (path === "/") return window.location.pathname === "/";
		return window.location.pathname.startsWith(path);
	});
}

export function LanguageProvider({ children }) {
	const [language, setLanguageState] = useState(() => {
		const saved = localStorage.getItem("language");
		if (saved === "it" || saved === "en") return saved;
		// Auto-detect from browser locale or timezone (no external API needed)
		const isItalian =
			navigator.language.startsWith("it") ||
			Intl.DateTimeFormat().resolvedOptions().timeZone === "Europe/Rome";
		return isItalian ? "it" : "en";
	});

	const setLanguage = (nextLanguage) => {
		localStorage.setItem(LANGUAGE_MANUAL_OVERRIDE_KEY, "1");
		setLanguageState((prev) => {
			const resolvedNext =
				typeof nextLanguage === "function" ? nextLanguage(prev) : nextLanguage;
			if (resolvedNext === "it" || resolvedNext === "en") return resolvedNext;
			return prev;
		});
	};

	useEffect(() => {
		localStorage.setItem("language", language);
		document.documentElement.lang = language;
	}, [language]);

	useEffect(() => {
		if (!shouldAutoDetectPublicLanguageByCountry()) return;
		if (localStorage.getItem(LANGUAGE_MANUAL_OVERRIDE_KEY) === "1") return;

		let cancelled = false;
		const controller = new AbortController();

		const syncPublicLanguageFromCountry = async () => {
			try {
				const response = await fetch("https://ipapi.co/json/", {
					signal: controller.signal,
				});
				if (!response.ok) return;

				const data = await response.json();
				const countryCode = String(data?.country_code || "").toUpperCase();
				if (cancelled) return;

				if (countryCode && countryCode !== "IT") {
					setLanguageState("en");
				}
			} catch (error) {
				// Keep locale/timezone fallback when country lookup is unavailable.
			}
		};

		syncPublicLanguageFromCountry();

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, []);

	const t = useCallback(
		(key) => {
			return translations[language]?.[key] || translations["en"]?.[key] || key;
		},
		[language],
	);

	const toggleLanguage = () => {
		setLanguage((prev) => (prev === "it" ? "en" : "it"));
	};

	return (
		<LanguageContext.Provider
			value={{ language, setLanguage, toggleLanguage, t }}
		>
			{children}
		</LanguageContext.Provider>
	);
}

export function useLanguage() {
	const context = useContext(LanguageContext);
	if (!context) {
		throw new Error("useLanguage must be used within LanguageProvider");
	}
	return context;
}
